//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { Config } from "./Config";
import * as moment from 'moment';

export class ClientBase {
  private token: string;

  protected getBaseUrl(defaultUrl: string): string {
    return ClientConfig.ApiBaseUrl;
  }

  protected transformOptions(options: RequestInit): Promise<RequestInit> {
    if (this.token) {
      options.headers["Authorization"] = "Bearer " + this.token;
    }
    return new Promise(resolve => resolve(options));
  }

  public setToken(token: string): void {
    this.token = token;
  }
}

export class AddressClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getByPid(pid: string, signal?: AbortSignal | undefined): Promise<Address> {
        let url_ = this.baseUrl + "/address/{Pid}";
        if (pid === undefined || pid === null)
            throw new Error("The parameter 'pid' must be defined.");
        url_ = url_.replace("{Pid}", encodeURIComponent("" + pid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByPid(_response);
        });
    }

    protected processGetByPid(response: Response): Promise<Address> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Address.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Address>(null as any);
    }
}

export class AdminClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getObjects(signal?: AbortSignal | undefined): Promise<RealEstateObjectDbModel[]> {
        let url_ = this.baseUrl + "/objects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetObjects(_response);
        });
    }

    protected processGetObjects(response: Response): Promise<RealEstateObjectDbModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RealEstateObjectDbModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RealEstateObjectDbModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getObjectFile(id: string, fileId: string, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/objects/{id}/file/{fileId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetObjectFile(_response);
        });
    }

    protected processGetObjectFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    markAsHandled(objectId: string, signal?: AbortSignal | undefined): Promise<RealEstateObjectDbModel> {
        let url_ = this.baseUrl + "/objects/{objectId}/handled";
        if (objectId === undefined || objectId === null)
            throw new Error("The parameter 'objectId' must be defined.");
        url_ = url_.replace("{objectId}", encodeURIComponent("" + objectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkAsHandled(_response);
        });
    }

    protected processMarkAsHandled(response: Response): Promise<RealEstateObjectDbModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RealEstateObjectDbModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RealEstateObjectDbModel>(null as any);
    }

    /**
     * @return Success
     */
    listAvyInvoicings(signal?: AbortSignal | undefined): Promise<Invoicing[]> {
        let url_ = this.baseUrl + "/avy-invoicings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAvyInvoicings(_response);
        });
    }

    protected processListAvyInvoicings(response: Response): Promise<Invoicing[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Invoicing.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Invoicing[]>(null as any);
    }

    /**
     * @return Success
     */
    avyInvoicing(id: string, signal?: AbortSignal | undefined): Promise<AvyInvoicing> {
        let url_ = this.baseUrl + "/avy-invoicings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAvyInvoicing(_response);
        });
    }

    protected processAvyInvoicing(response: Response): Promise<AvyInvoicing> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvyInvoicing.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvyInvoicing>(null as any);
    }

    /**
     * @param status (optional) 
     * @return Success
     */
    listAvyInvoices(id: string, status: AvyInvoiceStatus | undefined, signal?: AbortSignal | undefined): Promise<AvyInvoice[]> {
        let url_ = this.baseUrl + "/avy-invoicings/{id}/invoices?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAvyInvoices(_response);
        });
    }

    protected processListAvyInvoices(response: Response): Promise<AvyInvoice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvyInvoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvyInvoice[]>(null as any);
    }

    /**
     * @return Success
     */
    sendAvyInvoice(invoicingId: string, invoiceId: string, signal?: AbortSignal | undefined): Promise<AvyInvoice> {
        let url_ = this.baseUrl + "/avy-invoicings/{invoicingId}/invoices/{invoiceId}/send";
        if (invoicingId === undefined || invoicingId === null)
            throw new Error("The parameter 'invoicingId' must be defined.");
        url_ = url_.replace("{invoicingId}", encodeURIComponent("" + invoicingId));
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendAvyInvoice(_response);
        });
    }

    protected processSendAvyInvoice(response: Response): Promise<AvyInvoice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvyInvoice.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvyInvoice>(null as any);
    }

    /**
     * @return Success
     */
    mspecsOrdersMissingFiles(signal?: AbortSignal | undefined): Promise<MspecsOrder[]> {
        let url_ = this.baseUrl + "/mspecs-orders/missing-files";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMspecsOrdersMissingFiles(_response);
        });
    }

    protected processMspecsOrdersMissingFiles(response: Response): Promise<MspecsOrder[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MspecsOrder.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MspecsOrder[]>(null as any);
    }

    /**
     * @return Success
     */
    mspecsOrderFiles(id: string, signal?: AbortSignal | undefined): Promise<MspecsFile[]> {
        let url_ = this.baseUrl + "/mspecs-orders/{id}/files";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMspecsOrderFiles(_response);
        });
    }

    protected processMspecsOrderFiles(response: Response): Promise<MspecsFile[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MspecsFile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MspecsFile[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mspecsOrderComplete(id: string, body: MspecsCompleteOrderRequest | undefined, signal?: AbortSignal | undefined): Promise<MspecsOrder> {
        let url_ = this.baseUrl + "/mspecs-orders/{id}/complete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMspecsOrderComplete(_response);
        });
    }

    protected processMspecsOrderComplete(response: Response): Promise<MspecsOrder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MspecsOrder.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MspecsOrder>(null as any);
    }
}

export class AuthenticationClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    initiate(signal?: AbortSignal | undefined): Promise<BankIdInitResponse> {
        let url_ = this.baseUrl + "/authentication/initiate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInitiate(_response);
        });
    }

    protected processInitiate(response: Response): Promise<BankIdInitResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankIdInitResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankIdInitResponse>(null as any);
    }

    /**
     * @param qrState (optional) 
     * @return Success
     */
    status(orderRef: string, qrState: string | undefined, signal?: AbortSignal | undefined): Promise<StatusResponse> {
        let url_ = this.baseUrl + "/authentication/status/{orderRef}?";
        if (orderRef === undefined || orderRef === null)
            throw new Error("The parameter 'orderRef' must be defined.");
        url_ = url_.replace("{orderRef}", encodeURIComponent("" + orderRef));
        if (qrState === null)
            throw new Error("The parameter 'qrState' cannot be null.");
        else if (qrState !== undefined)
            url_ += "qrState=" + encodeURIComponent("" + qrState) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStatus(_response);
        });
    }

    protected processStatus(response: Response): Promise<StatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    initiateSignature(body: SignInitiateRequest | undefined, signal?: AbortSignal | undefined): Promise<BankIdInitResponse> {
        let url_ = this.baseUrl + "/authentication/initiate-signature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInitiateSignature(_response);
        });
    }

    protected processInitiateSignature(response: Response): Promise<BankIdInitResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankIdInitResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankIdInitResponse>(null as any);
    }

    /**
     * @param pid (optional) 
     * @return Success
     */
    generateToken(pid: string | undefined, signal?: AbortSignal | undefined): Promise<TokenResponse> {
        let url_ = this.baseUrl + "/authentication/generate-token?";
        if (pid === null)
            throw new Error("The parameter 'pid' cannot be null.");
        else if (pid !== undefined)
            url_ += "pid=" + encodeURIComponent("" + pid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateToken(_response);
        });
    }

    protected processGenerateToken(response: Response): Promise<TokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponse>(null as any);
    }

    /**
     * @param requestToken (optional) 
     * @return Success
     */
    authenticateToken(requestToken: string | undefined, signal?: AbortSignal | undefined): Promise<AuthenticationResponse> {
        let url_ = this.baseUrl + "/authentication/authenticate-token?";
        if (requestToken === null)
            throw new Error("The parameter 'requestToken' cannot be null.");
        else if (requestToken !== undefined)
            url_ += "requestToken=" + encodeURIComponent("" + requestToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAuthenticateToken(_response);
        });
    }

    protected processAuthenticateToken(response: Response): Promise<AuthenticationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthenticationResponse>(null as any);
    }
}

export class Client extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param returnUrl (optional) 
     * @param uiOptions (optional) 
     * @return Success
     */
    auth(returnUrl: string | undefined, uiOptions: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ActiveLogin/BankId/Auth?";
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        if (uiOptions === null)
            throw new Error("The parameter 'uiOptions' cannot be null.");
        else if (uiOptions !== undefined)
            url_ += "uiOptions=" + encodeURIComponent("" + uiOptions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAuth(_response);
        });
    }

    protected processAuth(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    initialize(body: BankIdUiApiInitializeRequest | undefined, signal?: AbortSignal | undefined): Promise<BankIdUiApiInitializeResponse> {
        let url_ = this.baseUrl + "/ActiveLogin/BankId/Auth/Api/Initialize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInitialize(_response);
        });
    }

    protected processInitialize(response: Response): Promise<BankIdUiApiInitializeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankIdUiApiInitializeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankIdUiApiInitializeResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    status(body: BankIdUiApiStatusRequest | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ActiveLogin/BankId/Auth/Api/Status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStatus(_response);
        });
    }

    protected processStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    qrCode(body: BankIdUiApiQrCodeRequest | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ActiveLogin/BankId/Auth/Api/QrCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQrCode(_response);
        });
    }

    protected processQrCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancel(body: BankIdUiApiCancelRequest | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ActiveLogin/BankId/Auth/Api/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    contacts(id: string, signal?: AbortSignal | undefined): Promise<Contact> {
        let url_ = this.baseUrl + "/api/Contacts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processContacts(_response);
        });
    }

    protected processContacts(response: Response): Promise<Contact> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Contact.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Contact>(null as any);
    }

    /**
     * @return Success
     */
    anonymous(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnonymous(_response);
        });
    }

    protected processAnonymous(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ContactClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: Contact | undefined, signal?: AbortSignal | undefined): Promise<Contact> {
        let url_ = this.baseUrl + "/api/Contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<Contact> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Contact.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Contact>(null as any);
    }
}

export class EasyPriceClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    contact(body: EasyLead | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/site/contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processContact(_response);
        });
    }

    protected processContact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param nrOfDeliveries (optional) 
     * @return Success
     */
    calculate(nrOfDeliveries: number | undefined, signal?: AbortSignal | undefined): Promise<EasyPriceResponse> {
        let url_ = this.baseUrl + "/site/prices?";
        if (nrOfDeliveries === null)
            throw new Error("The parameter 'nrOfDeliveries' cannot be null.");
        else if (nrOfDeliveries !== undefined)
            url_ += "NrOfDeliveries=" + encodeURIComponent("" + nrOfDeliveries) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculate(_response);
        });
    }

    protected processCalculate(response: Response): Promise<EasyPriceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EasyPriceResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EasyPriceResponse>(null as any);
    }
}

export class EnodeClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    callback(signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/enode/callback";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCallback(_response);
        });
    }

    protected processCallback(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    syncVehicles(signal?: AbortSignal | undefined): Promise<VehicleModel[]> {
        let url_ = this.baseUrl + "/enode/vehicles/sync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSyncVehicles(_response);
        });
    }

    protected processSyncVehicles(response: Response): Promise<VehicleModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getVehicle(id: string, signal?: AbortSignal | undefined): Promise<VehicleModel> {
        let url_ = this.baseUrl + "/enode/vehicles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVehicle(_response);
        });
    }

    protected processGetVehicle(response: Response): Promise<VehicleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleModel>(null as any);
    }

    /**
     * @return Success
     */
    getVehicles(signal?: AbortSignal | undefined): Promise<VehicleModel[]> {
        let url_ = this.baseUrl + "/enode/vehicles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVehicles(_response);
        });
    }

    protected processGetVehicles(response: Response): Promise<VehicleModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleModel[]>(null as any);
    }

    /**
     * @return Success
     */
    disconnectVendor(vendor: string, signal?: AbortSignal | undefined): Promise<VehicleModel[]> {
        let url_ = this.baseUrl + "/enode/vendor/{vendor}";
        if (vendor === undefined || vendor === null)
            throw new Error("The parameter 'vendor' must be defined.");
        url_ = url_.replace("{vendor}", encodeURIComponent("" + vendor));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDisconnectVendor(_response);
        });
    }

    protected processDisconnectVendor(response: Response): Promise<VehicleModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VehicleModel[]>(null as any);
    }

    /**
     * @param deadline (optional) 
     * @param minimumChargeLimit (optional) 
     * @return Success
     */
    setSmartCharging(vehicleId: string, deadline: string | undefined, minimumChargeLimit: number | undefined, signal?: AbortSignal | undefined): Promise<SmartChargingResponse> {
        let url_ = this.baseUrl + "/enode/vehicles/{vehicleId}/smart-charging-policy?";
        if (vehicleId === undefined || vehicleId === null)
            throw new Error("The parameter 'vehicleId' must be defined.");
        url_ = url_.replace("{vehicleId}", encodeURIComponent("" + vehicleId));
        if (deadline === null)
            throw new Error("The parameter 'deadline' cannot be null.");
        else if (deadline !== undefined)
            url_ += "deadline=" + encodeURIComponent("" + deadline) + "&";
        if (minimumChargeLimit === null)
            throw new Error("The parameter 'minimumChargeLimit' cannot be null.");
        else if (minimumChargeLimit !== undefined)
            url_ += "minimumChargeLimit=" + encodeURIComponent("" + minimumChargeLimit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetSmartCharging(_response);
        });
    }

    protected processSetSmartCharging(response: Response): Promise<SmartChargingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmartChargingResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SmartChargingResponse>(null as any);
    }

    /**
     * @return Success
     */
    removeSmartCharging(vehicleId: string, signal?: AbortSignal | undefined): Promise<SmartChargingResponse> {
        let url_ = this.baseUrl + "/enode/vehicles/{vehicleId}/smart-charging-policy";
        if (vehicleId === undefined || vehicleId === null)
            throw new Error("The parameter 'vehicleId' must be defined.");
        url_ = url_.replace("{vehicleId}", encodeURIComponent("" + vehicleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveSmartCharging(_response);
        });
    }

    protected processRemoveSmartCharging(response: Response): Promise<SmartChargingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmartChargingResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SmartChargingResponse>(null as any);
    }

    /**
     * @return Success
     */
    createSmartOverride(vehicleId: string, signal?: AbortSignal | undefined): Promise<SmartChargingOverrideResponse> {
        let url_ = this.baseUrl + "/enode/vehicles/{vehicleId}/smart-override";
        if (vehicleId === undefined || vehicleId === null)
            throw new Error("The parameter 'vehicleId' must be defined.");
        url_ = url_.replace("{vehicleId}", encodeURIComponent("" + vehicleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSmartOverride(_response);
        });
    }

    protected processCreateSmartOverride(response: Response): Promise<SmartChargingOverrideResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmartChargingOverrideResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SmartChargingOverrideResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteSmartOverride(vehicleId: string, signal?: AbortSignal | undefined): Promise<SmartChargingOverrideResponse> {
        let url_ = this.baseUrl + "/enode/vehicles/{vehicleId}/smart-override";
        if (vehicleId === undefined || vehicleId === null)
            throw new Error("The parameter 'vehicleId' must be defined.");
        url_ = url_.replace("{vehicleId}", encodeURIComponent("" + vehicleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSmartOverride(_response);
        });
    }

    protected processDeleteSmartOverride(response: Response): Promise<SmartChargingOverrideResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmartChargingOverrideResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SmartChargingOverrideResponse>(null as any);
    }

    /**
     * @param redirectUri (optional) 
     * @param vendor (optional) 
     * @return Success
     */
    getLinkUrl(redirectUri: string | undefined, vendor: string | undefined, signal?: AbortSignal | undefined): Promise<EnodeLinkResult> {
        let url_ = this.baseUrl + "/enode/link?";
        if (redirectUri === null)
            throw new Error("The parameter 'redirectUri' cannot be null.");
        else if (redirectUri !== undefined)
            url_ += "redirectUri=" + encodeURIComponent("" + redirectUri) + "&";
        if (vendor === null)
            throw new Error("The parameter 'vendor' cannot be null.");
        else if (vendor !== undefined)
            url_ += "vendor=" + encodeURIComponent("" + vendor) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLinkUrl(_response);
        });
    }

    protected processGetLinkUrl(response: Response): Promise<EnodeLinkResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnodeLinkResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnodeLinkResult>(null as any);
    }

    /**
     * @return Success
     */
    getUser(userId: string, signal?: AbortSignal | undefined): Promise<UserResponse> {
        let url_ = this.baseUrl + "/enode/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<UserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserResponse>(null as any);
    }

    /**
     * @return Success
     */
    unlinkUser(userId: string, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/enode/users/{userId}/unlink";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnlinkUser(_response);
        });
    }

    protected processUnlinkUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deauthorizeUser(userId: string, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/enode/users/{userId}/deauthorize";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeauthorizeUser(_response);
        });
    }

    protected processDeauthorizeUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getLocations(signal?: AbortSignal | undefined): Promise<Location[]> {
        let url_ = this.baseUrl + "/enode/locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLocations(_response);
        });
    }

    protected processGetLocations(response: Response): Promise<Location[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Location.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Location[]>(null as any);
    }

    /**
     * @param name (optional) 
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @param timeZoneName (optional) 
     * @return Success
     */
    createLocation(name: string | undefined, latitude: number | undefined, longitude: number | undefined, timeZoneName: string | undefined, signal?: AbortSignal | undefined): Promise<Location> {
        let url_ = this.baseUrl + "/enode/locations?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "Latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "Longitude=" + encodeURIComponent("" + longitude) + "&";
        if (timeZoneName === null)
            throw new Error("The parameter 'timeZoneName' cannot be null.");
        else if (timeZoneName !== undefined)
            url_ += "TimeZoneName=" + encodeURIComponent("" + timeZoneName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateLocation(_response);
        });
    }

    protected processCreateLocation(response: Response): Promise<Location> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Location.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Location>(null as any);
    }

    /**
     * @param name (optional) 
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @param timeZoneName (optional) 
     * @return Success
     */
    updateLocation(locationId: string, name: string | undefined, latitude: number | undefined, longitude: number | undefined, timeZoneName: string | undefined, signal?: AbortSignal | undefined): Promise<Location> {
        let url_ = this.baseUrl + "/enode/locations/{locationId}?";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "Latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "Longitude=" + encodeURIComponent("" + longitude) + "&";
        if (timeZoneName === null)
            throw new Error("The parameter 'timeZoneName' cannot be null.");
        else if (timeZoneName !== undefined)
            url_ += "TimeZoneName=" + encodeURIComponent("" + timeZoneName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLocation(_response);
        });
    }

    protected processUpdateLocation(response: Response): Promise<Location> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Location.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Location>(null as any);
    }

    /**
     * @return Success
     */
    deleteLocation(locationId: string, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/enode/locations/{locationId}/delete";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteLocation(_response);
        });
    }

    protected processDeleteLocation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getInterventionById(interventionId: string, signal?: AbortSignal | undefined): Promise<Intervention> {
        let url_ = this.baseUrl + "/enode/interventions/{interventionId}";
        if (interventionId === undefined || interventionId === null)
            throw new Error("The parameter 'interventionId' must be defined.");
        url_ = url_.replace("{interventionId}", encodeURIComponent("" + interventionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInterventionById(_response);
        });
    }

    protected processGetInterventionById(response: Response): Promise<Intervention> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Intervention.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Intervention>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getChargingSessions(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, signal?: AbortSignal | undefined): Promise<SessionsStatisticsTimeseries[]> {
        let url_ = this.baseUrl + "/enode/charging-sessions?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetChargingSessions(_response);
        });
    }

    protected processGetChargingSessions(response: Response): Promise<SessionsStatisticsTimeseries[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SessionsStatisticsTimeseries.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SessionsStatisticsTimeseries[]>(null as any);
    }

    /**
     * @return Success
     */
    getSupportedModels(signal?: AbortSignal | undefined): Promise<SupportedModel[]> {
        let url_ = this.baseUrl + "/enode/supported-models";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportedModels(_response);
        });
    }

    protected processGetSupportedModels(response: Response): Promise<SupportedModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupportedModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportedModel[]>(null as any);
    }
}

export class FasAdClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param file (optional) 
     * @param objectId (optional) 
     * @param channel (optional) 
     * @return Success
     */
    uploadContract(file: FileParameter | undefined, objectId: string | undefined, channel: Channel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/fasad/contract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (objectId === null || objectId === undefined)
            throw new Error("The parameter 'objectId' cannot be null.");
        else
            content_.append("ObjectId", objectId.toString());
        if (channel === null || channel === undefined)
            throw new Error("The parameter 'channel' cannot be null.");
        else
            content_.append("Channel", channel.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadContract(_response);
        });
    }

    protected processUploadContract(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param objectId (optional) 
     * @return Success
     */
    notifyEsny(objectId: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/fasad/notify-esny?";
        if (objectId === null)
            throw new Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotifyEsny(_response);
        });
    }

    protected processNotifyEsny(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    updateOffices(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/fasad/update-offices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateOffices(_response);
        });
    }

    protected processUpdateOffices(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param months (optional) 
     * @return Success
     */
    updateStats(months: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/fasad/update-stats?";
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            url_ += "months=" + encodeURIComponent("" + months) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateStats(_response);
        });
    }

    protected processUpdateStats(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class JobsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    cancel(id: string, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/jobs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class MspecsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    subscriptionCallbacks(signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/mspecs/subscribe";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubscriptionCallbacks(_response);
        });
    }

    protected processSubscriptionCallbacks(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    dealCallbacks(signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/mspecs/deal";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDealCallbacks(_response);
        });
    }

    protected processDealCallbacks(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    listSubscriptions(signal?: AbortSignal | undefined): Promise<MspecsSubscriber[]> {
        let url_ = this.baseUrl + "/mspecs/list-subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListSubscriptions(_response);
        });
    }

    protected processListSubscriptions(response: Response): Promise<MspecsSubscriber[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MspecsSubscriber.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MspecsSubscriber[]>(null as any);
    }

    /**
     * @return Success
     */
    syncDeals(signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/mspecs/sync-deals";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSyncDeals(_response);
        });
    }

    protected processSyncDeals(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    unhandledCallbacks(signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/mspecs/unhandled-callbacks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnhandledCallbacks(_response);
        });
    }

    protected processUnhandledCallbacks(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    sendMissingFileNotification(id: string, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/mspecs/send-missing-file/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendMissingFileNotification(_response);
        });
    }

    protected processSendMissingFileNotification(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    finishDelivery(id: string, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/mspecs/finish-delivery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFinishDelivery(_response);
        });
    }

    protected processFinishDelivery(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ObjectClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param objectNumber (optional) 
     * @param accessDate (optional) 
     * @param customerId (optional) 
     * @param channel (optional) 
     * @param salesChannel (optional) 
     * @param expandDateSearchIfNotFound (optional) 
     * @return Success
     */
    get(objectNumber: string | undefined, accessDate: moment.Moment | undefined, customerId: string | undefined, channel: RealEstateChannel | undefined, salesChannel: Channel | undefined, expandDateSearchIfNotFound: boolean | undefined, signal?: AbortSignal | undefined): Promise<RealEstateObject> {
        let url_ = this.baseUrl + "/get?";
        if (objectNumber === null)
            throw new Error("The parameter 'objectNumber' cannot be null.");
        else if (objectNumber !== undefined)
            url_ += "ObjectNumber=" + encodeURIComponent("" + objectNumber) + "&";
        if (accessDate === null)
            throw new Error("The parameter 'accessDate' cannot be null.");
        else if (accessDate !== undefined)
            url_ += "AccessDate=" + encodeURIComponent(accessDate ? "" + accessDate.toISOString() : "") + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "Channel=" + encodeURIComponent("" + channel) + "&";
        if (salesChannel === null)
            throw new Error("The parameter 'salesChannel' cannot be null.");
        else if (salesChannel !== undefined)
            url_ += "SalesChannel=" + encodeURIComponent("" + salesChannel) + "&";
        if (expandDateSearchIfNotFound === null)
            throw new Error("The parameter 'expandDateSearchIfNotFound' cannot be null.");
        else if (expandDateSearchIfNotFound !== undefined)
            url_ += "ExpandDateSearchIfNotFound=" + encodeURIComponent("" + expandDateSearchIfNotFound) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<RealEstateObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RealEstateObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RealEstateObject>(null as any);
    }

    /**
     * @param objectNumber (optional) 
     * @param channel (optional) 
     * @return Success
     */
    getFasadRaw(objectNumber: string | undefined, channel: Channel | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/fasadRaw?";
        if (objectNumber === null)
            throw new Error("The parameter 'objectNumber' cannot be null.");
        else if (objectNumber !== undefined)
            url_ += "objectNumber=" + encodeURIComponent("" + objectNumber) + "&";
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFasadRaw(_response);
        });
    }

    protected processGetFasadRaw(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class OfferClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param ip (optional) 
     * @param no_tracking (optional) 
     * @return Success
     */
    getById(id: string, ip: string | undefined, no_tracking: boolean | undefined, signal?: AbortSignal | undefined): Promise<Offer> {
        let url_ = this.baseUrl + "/Offers/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (ip === null)
            throw new Error("The parameter 'ip' cannot be null.");
        else if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        if (no_tracking === null)
            throw new Error("The parameter 'no_tracking' cannot be null.");
        else if (no_tracking !== undefined)
            url_ += "no-tracking=" + encodeURIComponent("" + no_tracking) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<Offer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Offer.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Offer>(null as any);
    }

    /**
     * @return Success
     */
    unsubscribe(id: string, signal?: AbortSignal | undefined): Promise<Offer> {
        let url_ = this.baseUrl + "/Offers/{id}/unsubscribe";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnsubscribe(_response);
        });
    }

    protected processUnsubscribe(response: Response): Promise<Offer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Offer.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Offer>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: Offer | undefined, signal?: AbortSignal | undefined): Promise<Offer> {
        let url_ = this.baseUrl + "/Offers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<Offer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Offer.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Offer>(null as any);
    }

    /**
     * @return Success
     */
    send(offerId: string, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Offers/{offerId}/send";
        if (offerId === undefined || offerId === null)
            throw new Error("The parameter 'offerId' must be defined.");
        url_ = url_.replace("{offerId}", encodeURIComponent("" + offerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSend(_response);
        });
    }

    protected processSend(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class OrderClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param preorder (optional) 
     * @param body (optional) 
     * @return Success
     */
    create(preorder: boolean | undefined, body: Order | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/orders?";
        if (preorder === null)
            throw new Error("The parameter 'preorder' cannot be null.");
        else if (preorder !== undefined)
            url_ += "preorder=" + encodeURIComponent("" + preorder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param externalID (optional) 
     * @return Success
     */
    getByGuid(externalID: string | undefined, signal?: AbortSignal | undefined): Promise<Order> {
        let url_ = this.baseUrl + "/orders?";
        if (externalID === null)
            throw new Error("The parameter 'externalID' cannot be null.");
        else if (externalID !== undefined)
            url_ += "externalID=" + encodeURIComponent("" + externalID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByGuid(_response);
        });
    }

    protected processGetByGuid(response: Response): Promise<Order> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Order.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Order>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completionEA(elavtalID: string, body: Order | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/orders/{elavtalID}/completionEA";
        if (elavtalID === undefined || elavtalID === null)
            throw new Error("The parameter 'elavtalID' must be defined.");
        url_ = url_.replace("{elavtalID}", encodeURIComponent("" + elavtalID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompletionEA(_response);
        });
    }

    protected processCompletionEA(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completion(completionId: string, body: Order | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/orders/{completionId}/completion";
        if (completionId === undefined || completionId === null)
            throw new Error("The parameter 'completionId' must be defined.");
        url_ = url_.replace("{completionId}", encodeURIComponent("" + completionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompletion(_response);
        });
    }

    protected processCompletion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getById(id: number, signal?: AbortSignal | undefined): Promise<Order> {
        let url_ = this.baseUrl + "/orders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<Order> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Order.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Order>(null as any);
    }

    /**
     * @return Success
     */
    pdf(id: number, elavtalId: string, signal?: AbortSignal | undefined): Promise<Order> {
        let url_ = this.baseUrl + "/orders/{id}/pdf/{elavtalId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (elavtalId === undefined || elavtalId === null)
            throw new Error("The parameter 'elavtalId' must be defined.");
        url_ = url_.replace("{elavtalId}", encodeURIComponent("" + elavtalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPdf(_response);
        });
    }

    protected processPdf(response: Response): Promise<Order> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Order.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Order>(null as any);
    }

    /**
     * @return Success
     */
    getPdf(id: number, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/orders/{id}/pdf";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPdf(_response);
        });
    }

    protected processGetPdf(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    sync(id: number, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/orders/{id}/sync";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSync(_response);
        });
    }

    protected processSync(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    cancelInsurance(id: number, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/orders/{id}/cancel-insurance";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelInsurance(_response);
        });
    }

    protected processCancelInsurance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrderStatusClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param elavtalID (optional) 
     * @param company (optional) 
     * @return Success
     */
    getByDeliveryID(elavtalID: string | undefined, company: string | undefined, signal?: AbortSignal | undefined): Promise<OrderStatus> {
        let url_ = this.baseUrl + "/orders/orderStatus?";
        if (elavtalID === null)
            throw new Error("The parameter 'elavtalID' cannot be null.");
        else if (elavtalID !== undefined)
            url_ += "elavtalID=" + encodeURIComponent("" + elavtalID) + "&";
        if (company === null)
            throw new Error("The parameter 'company' cannot be null.");
        else if (company !== undefined)
            url_ += "Company=" + encodeURIComponent("" + company) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByDeliveryID(_response);
        });
    }

    protected processGetByDeliveryID(response: Response): Promise<OrderStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderStatus>(null as any);
    }
}

export class CompletionsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param companyName (optional) 
     * @return Success
     */
    getById(completionId: string, companyName: string | undefined, signal?: AbortSignal | undefined): Promise<Order> {
        let url_ = this.baseUrl + "/completions/{completionId}?";
        if (completionId === undefined || completionId === null)
            throw new Error("The parameter 'completionId' must be defined.");
        url_ = url_.replace("{completionId}", encodeURIComponent("" + completionId));
        if (companyName === null)
            throw new Error("The parameter 'companyName' cannot be null.");
        else if (companyName !== undefined)
            url_ += "companyName=" + encodeURIComponent("" + companyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<Order> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Order.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Order>(null as any);
    }
}

export class ElavtalClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param elavtalID (optional) 
     * @param company (optional) 
     * @return Success
     */
    getByGuid(elavtalID: string | undefined, company: string | undefined, signal?: AbortSignal | undefined): Promise<Order> {
        let url_ = this.baseUrl + "/orders/elavtal?";
        if (elavtalID === null)
            throw new Error("The parameter 'elavtalID' cannot be null.");
        else if (elavtalID !== undefined)
            url_ += "elavtalID=" + encodeURIComponent("" + elavtalID) + "&";
        if (company === null)
            throw new Error("The parameter 'company' cannot be null.");
        else if (company !== undefined)
            url_ += "Company=" + encodeURIComponent("" + company) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByGuid(_response);
        });
    }

    protected processGetByGuid(response: Response): Promise<Order> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Order.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Order>(null as any);
    }
}

export class PriceClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param consumption (optional) 
     * @param channel (optional) 
     * @return Success
     */
    calculate(consumption: number | undefined, channel: Channel | undefined, signal?: AbortSignal | undefined): Promise<PriceResponse> {
        let url_ = this.baseUrl + "/prices?";
        if (consumption === null)
            throw new Error("The parameter 'consumption' cannot be null.");
        else if (consumption !== undefined)
            url_ += "Consumption=" + encodeURIComponent("" + consumption) + "&";
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "Channel=" + encodeURIComponent("" + channel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculate(_response);
        });
    }

    protected processCalculate(response: Response): Promise<PriceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriceResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PriceResponse>(null as any);
    }

    /**
     * @param consumption (optional) 
     * @param channel (optional) 
     * @return Success
     */
    average(consumption: number | undefined, channel: Channel | undefined, signal?: AbortSignal | undefined): Promise<AveragePrices> {
        let url_ = this.baseUrl + "/prices/average?";
        if (consumption === null)
            throw new Error("The parameter 'consumption' cannot be null.");
        else if (consumption !== undefined)
            url_ += "Consumption=" + encodeURIComponent("" + consumption) + "&";
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "Channel=" + encodeURIComponent("" + channel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAverage(_response);
        });
    }

    protected processAverage(response: Response): Promise<AveragePrices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AveragePrices.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AveragePrices>(null as any);
    }

    /**
     * @param consumption (optional) 
     * @param channel (optional) 
     * @return Success
     */
    list(consumption: number | undefined, channel: Channel | undefined, signal?: AbortSignal | undefined): Promise<SpotPrice[]> {
        let url_ = this.baseUrl + "/prices/List?";
        if (consumption === null)
            throw new Error("The parameter 'consumption' cannot be null.");
        else if (consumption !== undefined)
            url_ += "Consumption=" + encodeURIComponent("" + consumption) + "&";
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "Channel=" + encodeURIComponent("" + channel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<SpotPrice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpotPrice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpotPrice[]>(null as any);
    }

    /**
     * @param consumption (optional) 
     * @param channel (optional) 
     * @return Success
     */
    listLatest(consumption: number | undefined, channel: Channel | undefined, signal?: AbortSignal | undefined): Promise<SpotPrice[]> {
        let url_ = this.baseUrl + "/prices/ListLatest?";
        if (consumption === null)
            throw new Error("The parameter 'consumption' cannot be null.");
        else if (consumption !== undefined)
            url_ += "Consumption=" + encodeURIComponent("" + consumption) + "&";
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "Channel=" + encodeURIComponent("" + channel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListLatest(_response);
        });
    }

    protected processListLatest(response: Response): Promise<SpotPrice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpotPrice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpotPrice[]>(null as any);
    }
}

export class RealEstateAgentClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getById(id: string, signal?: AbortSignal | undefined): Promise<RealEstateAgentModel> {
        let url_ = this.baseUrl + "/RealEstateAgent/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<RealEstateAgentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RealEstateAgentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RealEstateAgentModel>(null as any);
    }

    /**
     * @param name (optional) 
     * @param channel (optional) 
     * @param id (optional) 
     * @return Success
     */
    list(name: string | undefined, channel: Channel | undefined, id: string | undefined, signal?: AbortSignal | undefined): Promise<RealEstateAgentModel[]> {
        let url_ = this.baseUrl + "/RealEstateAgent?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "Channel=" + encodeURIComponent("" + channel) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<RealEstateAgentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RealEstateAgentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RealEstateAgentModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: RealEstateAgentModel | undefined, signal?: AbortSignal | undefined): Promise<RealEstateAgentModel> {
        let url_ = this.baseUrl + "/RealEstateAgent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<RealEstateAgentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RealEstateAgentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RealEstateAgentModel>(null as any);
    }
}

export class ReportClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    loggedIn(signal?: AbortSignal | undefined): Promise<ReportUser> {
        let url_ = this.baseUrl + "/report/loggedin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoggedIn(_response);
        });
    }

    protected processLoggedIn(response: Response): Promise<ReportUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportUser.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportUser>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param byCreatedDate (optional) 
     * @param chainId (optional) 
     * @param showElectricity (optional) 
     * @param showInsurance (optional) 
     * @param showMortgage (optional) 
     * @return Success
     */
    sales(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, byCreatedDate: boolean | undefined, chainId: string | undefined, showElectricity: boolean | undefined, showInsurance: boolean | undefined, showMortgage: boolean | undefined, signal?: AbortSignal | undefined): Promise<ReportResponse> {
        let url_ = this.baseUrl + "/report/sales?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (byCreatedDate === null)
            throw new Error("The parameter 'byCreatedDate' cannot be null.");
        else if (byCreatedDate !== undefined)
            url_ += "ByCreatedDate=" + encodeURIComponent("" + byCreatedDate) + "&";
        if (chainId === null)
            throw new Error("The parameter 'chainId' cannot be null.");
        else if (chainId !== undefined)
            url_ += "ChainId=" + encodeURIComponent("" + chainId) + "&";
        if (showElectricity === null)
            throw new Error("The parameter 'showElectricity' cannot be null.");
        else if (showElectricity !== undefined)
            url_ += "ShowElectricity=" + encodeURIComponent("" + showElectricity) + "&";
        if (showInsurance === null)
            throw new Error("The parameter 'showInsurance' cannot be null.");
        else if (showInsurance !== undefined)
            url_ += "ShowInsurance=" + encodeURIComponent("" + showInsurance) + "&";
        if (showMortgage === null)
            throw new Error("The parameter 'showMortgage' cannot be null.");
        else if (showMortgage !== undefined)
            url_ += "ShowMortgage=" + encodeURIComponent("" + showMortgage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSales(_response);
        });
    }

    protected processSales(response: Response): Promise<ReportResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportResponse>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param byCreatedDate (optional) 
     * @param chainId (optional) 
     * @param showElectricity (optional) 
     * @param showInsurance (optional) 
     * @param showMortgage (optional) 
     * @return Success
     */
    conversions(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, byCreatedDate: boolean | undefined, chainId: string | undefined, showElectricity: boolean | undefined, showInsurance: boolean | undefined, showMortgage: boolean | undefined, signal?: AbortSignal | undefined): Promise<ConversionResponseItem[]> {
        let url_ = this.baseUrl + "/report/conversions?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (byCreatedDate === null)
            throw new Error("The parameter 'byCreatedDate' cannot be null.");
        else if (byCreatedDate !== undefined)
            url_ += "ByCreatedDate=" + encodeURIComponent("" + byCreatedDate) + "&";
        if (chainId === null)
            throw new Error("The parameter 'chainId' cannot be null.");
        else if (chainId !== undefined)
            url_ += "ChainId=" + encodeURIComponent("" + chainId) + "&";
        if (showElectricity === null)
            throw new Error("The parameter 'showElectricity' cannot be null.");
        else if (showElectricity !== undefined)
            url_ += "ShowElectricity=" + encodeURIComponent("" + showElectricity) + "&";
        if (showInsurance === null)
            throw new Error("The parameter 'showInsurance' cannot be null.");
        else if (showInsurance !== undefined)
            url_ += "ShowInsurance=" + encodeURIComponent("" + showInsurance) + "&";
        if (showMortgage === null)
            throw new Error("The parameter 'showMortgage' cannot be null.");
        else if (showMortgage !== undefined)
            url_ += "ShowMortgage=" + encodeURIComponent("" + showMortgage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConversions(_response);
        });
    }

    protected processConversions(response: Response): Promise<ConversionResponseItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionResponseItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversionResponseItem[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param byCreatedDate (optional) 
     * @param chainId (optional) 
     * @param showElectricity (optional) 
     * @param showInsurance (optional) 
     * @param showMortgage (optional) 
     * @return Success
     */
    conversionsCSV(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, byCreatedDate: boolean | undefined, chainId: string | undefined, showElectricity: boolean | undefined, showInsurance: boolean | undefined, showMortgage: boolean | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/report/conversions-csv?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (byCreatedDate === null)
            throw new Error("The parameter 'byCreatedDate' cannot be null.");
        else if (byCreatedDate !== undefined)
            url_ += "ByCreatedDate=" + encodeURIComponent("" + byCreatedDate) + "&";
        if (chainId === null)
            throw new Error("The parameter 'chainId' cannot be null.");
        else if (chainId !== undefined)
            url_ += "ChainId=" + encodeURIComponent("" + chainId) + "&";
        if (showElectricity === null)
            throw new Error("The parameter 'showElectricity' cannot be null.");
        else if (showElectricity !== undefined)
            url_ += "ShowElectricity=" + encodeURIComponent("" + showElectricity) + "&";
        if (showInsurance === null)
            throw new Error("The parameter 'showInsurance' cannot be null.");
        else if (showInsurance !== undefined)
            url_ += "ShowInsurance=" + encodeURIComponent("" + showInsurance) + "&";
        if (showMortgage === null)
            throw new Error("The parameter 'showMortgage' cannot be null.");
        else if (showMortgage !== undefined)
            url_ += "ShowMortgage=" + encodeURIComponent("" + showMortgage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConversionsCSV(_response);
        });
    }

    protected processConversionsCSV(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param byCreatedDate (optional) 
     * @param chainId (optional) 
     * @param showElectricity (optional) 
     * @param showInsurance (optional) 
     * @param showMortgage (optional) 
     * @return Success
     */
    executiveReport(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, byCreatedDate: boolean | undefined, chainId: string | undefined, showElectricity: boolean | undefined, showInsurance: boolean | undefined, showMortgage: boolean | undefined, signal?: AbortSignal | undefined): Promise<ExecutiveReportResponseItem[]> {
        let url_ = this.baseUrl + "/report/executive-report?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (byCreatedDate === null)
            throw new Error("The parameter 'byCreatedDate' cannot be null.");
        else if (byCreatedDate !== undefined)
            url_ += "ByCreatedDate=" + encodeURIComponent("" + byCreatedDate) + "&";
        if (chainId === null)
            throw new Error("The parameter 'chainId' cannot be null.");
        else if (chainId !== undefined)
            url_ += "ChainId=" + encodeURIComponent("" + chainId) + "&";
        if (showElectricity === null)
            throw new Error("The parameter 'showElectricity' cannot be null.");
        else if (showElectricity !== undefined)
            url_ += "ShowElectricity=" + encodeURIComponent("" + showElectricity) + "&";
        if (showInsurance === null)
            throw new Error("The parameter 'showInsurance' cannot be null.");
        else if (showInsurance !== undefined)
            url_ += "ShowInsurance=" + encodeURIComponent("" + showInsurance) + "&";
        if (showMortgage === null)
            throw new Error("The parameter 'showMortgage' cannot be null.");
        else if (showMortgage !== undefined)
            url_ += "ShowMortgage=" + encodeURIComponent("" + showMortgage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExecutiveReport(_response);
        });
    }

    protected processExecutiveReport(response: Response): Promise<ExecutiveReportResponseItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExecutiveReportResponseItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExecutiveReportResponseItem[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param byCreatedDate (optional) 
     * @param chainId (optional) 
     * @param showElectricity (optional) 
     * @param showInsurance (optional) 
     * @param showMortgage (optional) 
     * @return Success
     */
    executiveReportCSV(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, byCreatedDate: boolean | undefined, chainId: string | undefined, showElectricity: boolean | undefined, showInsurance: boolean | undefined, showMortgage: boolean | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/report/executive-report-csv?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (byCreatedDate === null)
            throw new Error("The parameter 'byCreatedDate' cannot be null.");
        else if (byCreatedDate !== undefined)
            url_ += "ByCreatedDate=" + encodeURIComponent("" + byCreatedDate) + "&";
        if (chainId === null)
            throw new Error("The parameter 'chainId' cannot be null.");
        else if (chainId !== undefined)
            url_ += "ChainId=" + encodeURIComponent("" + chainId) + "&";
        if (showElectricity === null)
            throw new Error("The parameter 'showElectricity' cannot be null.");
        else if (showElectricity !== undefined)
            url_ += "ShowElectricity=" + encodeURIComponent("" + showElectricity) + "&";
        if (showInsurance === null)
            throw new Error("The parameter 'showInsurance' cannot be null.");
        else if (showInsurance !== undefined)
            url_ += "ShowInsurance=" + encodeURIComponent("" + showInsurance) + "&";
        if (showMortgage === null)
            throw new Error("The parameter 'showMortgage' cannot be null.");
        else if (showMortgage !== undefined)
            url_ += "ShowMortgage=" + encodeURIComponent("" + showMortgage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExecutiveReportCSV(_response);
        });
    }

    protected processExecutiveReportCSV(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param byCreatedDate (optional) 
     * @param chainId (optional) 
     * @param showElectricity (optional) 
     * @param showInsurance (optional) 
     * @param showMortgage (optional) 
     * @return Success
     */
    insuranceSalesCSV(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, byCreatedDate: boolean | undefined, chainId: string | undefined, showElectricity: boolean | undefined, showInsurance: boolean | undefined, showMortgage: boolean | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/report/insurance-sales-csv?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (byCreatedDate === null)
            throw new Error("The parameter 'byCreatedDate' cannot be null.");
        else if (byCreatedDate !== undefined)
            url_ += "ByCreatedDate=" + encodeURIComponent("" + byCreatedDate) + "&";
        if (chainId === null)
            throw new Error("The parameter 'chainId' cannot be null.");
        else if (chainId !== undefined)
            url_ += "ChainId=" + encodeURIComponent("" + chainId) + "&";
        if (showElectricity === null)
            throw new Error("The parameter 'showElectricity' cannot be null.");
        else if (showElectricity !== undefined)
            url_ += "ShowElectricity=" + encodeURIComponent("" + showElectricity) + "&";
        if (showInsurance === null)
            throw new Error("The parameter 'showInsurance' cannot be null.");
        else if (showInsurance !== undefined)
            url_ += "ShowInsurance=" + encodeURIComponent("" + showInsurance) + "&";
        if (showMortgage === null)
            throw new Error("The parameter 'showMortgage' cannot be null.");
        else if (showMortgage !== undefined)
            url_ += "ShowMortgage=" + encodeURIComponent("" + showMortgage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsuranceSalesCSV(_response);
        });
    }

    protected processInsuranceSalesCSV(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param byCreatedDate (optional) 
     * @param chainId (optional) 
     * @param showElectricity (optional) 
     * @param showInsurance (optional) 
     * @param showMortgage (optional) 
     * @return Success
     */
    insuranceSales(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, byCreatedDate: boolean | undefined, chainId: string | undefined, showElectricity: boolean | undefined, showInsurance: boolean | undefined, showMortgage: boolean | undefined, signal?: AbortSignal | undefined): Promise<SalesResponseItem[]> {
        let url_ = this.baseUrl + "/report/insurance-sales?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (byCreatedDate === null)
            throw new Error("The parameter 'byCreatedDate' cannot be null.");
        else if (byCreatedDate !== undefined)
            url_ += "ByCreatedDate=" + encodeURIComponent("" + byCreatedDate) + "&";
        if (chainId === null)
            throw new Error("The parameter 'chainId' cannot be null.");
        else if (chainId !== undefined)
            url_ += "ChainId=" + encodeURIComponent("" + chainId) + "&";
        if (showElectricity === null)
            throw new Error("The parameter 'showElectricity' cannot be null.");
        else if (showElectricity !== undefined)
            url_ += "ShowElectricity=" + encodeURIComponent("" + showElectricity) + "&";
        if (showInsurance === null)
            throw new Error("The parameter 'showInsurance' cannot be null.");
        else if (showInsurance !== undefined)
            url_ += "ShowInsurance=" + encodeURIComponent("" + showInsurance) + "&";
        if (showMortgage === null)
            throw new Error("The parameter 'showMortgage' cannot be null.");
        else if (showMortgage !== undefined)
            url_ += "ShowMortgage=" + encodeURIComponent("" + showMortgage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsuranceSales(_response);
        });
    }

    protected processInsuranceSales(response: Response): Promise<SalesResponseItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesResponseItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalesResponseItem[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param byCreatedDate (optional) 
     * @param chainId (optional) 
     * @param showElectricity (optional) 
     * @param showInsurance (optional) 
     * @param showMortgage (optional) 
     * @return Success
     */
    mortgageSalesCSV(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, byCreatedDate: boolean | undefined, chainId: string | undefined, showElectricity: boolean | undefined, showInsurance: boolean | undefined, showMortgage: boolean | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/report/mortgage-sales-csv?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (byCreatedDate === null)
            throw new Error("The parameter 'byCreatedDate' cannot be null.");
        else if (byCreatedDate !== undefined)
            url_ += "ByCreatedDate=" + encodeURIComponent("" + byCreatedDate) + "&";
        if (chainId === null)
            throw new Error("The parameter 'chainId' cannot be null.");
        else if (chainId !== undefined)
            url_ += "ChainId=" + encodeURIComponent("" + chainId) + "&";
        if (showElectricity === null)
            throw new Error("The parameter 'showElectricity' cannot be null.");
        else if (showElectricity !== undefined)
            url_ += "ShowElectricity=" + encodeURIComponent("" + showElectricity) + "&";
        if (showInsurance === null)
            throw new Error("The parameter 'showInsurance' cannot be null.");
        else if (showInsurance !== undefined)
            url_ += "ShowInsurance=" + encodeURIComponent("" + showInsurance) + "&";
        if (showMortgage === null)
            throw new Error("The parameter 'showMortgage' cannot be null.");
        else if (showMortgage !== undefined)
            url_ += "ShowMortgage=" + encodeURIComponent("" + showMortgage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMortgageSalesCSV(_response);
        });
    }

    protected processMortgageSalesCSV(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param byCreatedDate (optional) 
     * @param chainId (optional) 
     * @param showElectricity (optional) 
     * @param showInsurance (optional) 
     * @param showMortgage (optional) 
     * @return Success
     */
    mortgageSales(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, byCreatedDate: boolean | undefined, chainId: string | undefined, showElectricity: boolean | undefined, showInsurance: boolean | undefined, showMortgage: boolean | undefined, signal?: AbortSignal | undefined): Promise<SalesResponseItem[]> {
        let url_ = this.baseUrl + "/report/mortgage-sales?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (byCreatedDate === null)
            throw new Error("The parameter 'byCreatedDate' cannot be null.");
        else if (byCreatedDate !== undefined)
            url_ += "ByCreatedDate=" + encodeURIComponent("" + byCreatedDate) + "&";
        if (chainId === null)
            throw new Error("The parameter 'chainId' cannot be null.");
        else if (chainId !== undefined)
            url_ += "ChainId=" + encodeURIComponent("" + chainId) + "&";
        if (showElectricity === null)
            throw new Error("The parameter 'showElectricity' cannot be null.");
        else if (showElectricity !== undefined)
            url_ += "ShowElectricity=" + encodeURIComponent("" + showElectricity) + "&";
        if (showInsurance === null)
            throw new Error("The parameter 'showInsurance' cannot be null.");
        else if (showInsurance !== undefined)
            url_ += "ShowInsurance=" + encodeURIComponent("" + showInsurance) + "&";
        if (showMortgage === null)
            throw new Error("The parameter 'showMortgage' cannot be null.");
        else if (showMortgage !== undefined)
            url_ += "ShowMortgage=" + encodeURIComponent("" + showMortgage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMortgageSales(_response);
        });
    }

    protected processMortgageSales(response: Response): Promise<SalesResponseItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesResponseItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalesResponseItem[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param byCreatedDate (optional) 
     * @param chainId (optional) 
     * @param showElectricity (optional) 
     * @param showInsurance (optional) 
     * @param showMortgage (optional) 
     * @return Success
     */
    electricitySalesCSV(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, byCreatedDate: boolean | undefined, chainId: string | undefined, showElectricity: boolean | undefined, showInsurance: boolean | undefined, showMortgage: boolean | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/report/electricity-sales-csv?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (byCreatedDate === null)
            throw new Error("The parameter 'byCreatedDate' cannot be null.");
        else if (byCreatedDate !== undefined)
            url_ += "ByCreatedDate=" + encodeURIComponent("" + byCreatedDate) + "&";
        if (chainId === null)
            throw new Error("The parameter 'chainId' cannot be null.");
        else if (chainId !== undefined)
            url_ += "ChainId=" + encodeURIComponent("" + chainId) + "&";
        if (showElectricity === null)
            throw new Error("The parameter 'showElectricity' cannot be null.");
        else if (showElectricity !== undefined)
            url_ += "ShowElectricity=" + encodeURIComponent("" + showElectricity) + "&";
        if (showInsurance === null)
            throw new Error("The parameter 'showInsurance' cannot be null.");
        else if (showInsurance !== undefined)
            url_ += "ShowInsurance=" + encodeURIComponent("" + showInsurance) + "&";
        if (showMortgage === null)
            throw new Error("The parameter 'showMortgage' cannot be null.");
        else if (showMortgage !== undefined)
            url_ += "ShowMortgage=" + encodeURIComponent("" + showMortgage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processElectricitySalesCSV(_response);
        });
    }

    protected processElectricitySalesCSV(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param byCreatedDate (optional) 
     * @param chainId (optional) 
     * @param showElectricity (optional) 
     * @param showInsurance (optional) 
     * @param showMortgage (optional) 
     * @return Success
     */
    electricitySales(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, byCreatedDate: boolean | undefined, chainId: string | undefined, showElectricity: boolean | undefined, showInsurance: boolean | undefined, showMortgage: boolean | undefined, signal?: AbortSignal | undefined): Promise<SalesResponseItem[]> {
        let url_ = this.baseUrl + "/report/electricity-sales?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (byCreatedDate === null)
            throw new Error("The parameter 'byCreatedDate' cannot be null.");
        else if (byCreatedDate !== undefined)
            url_ += "ByCreatedDate=" + encodeURIComponent("" + byCreatedDate) + "&";
        if (chainId === null)
            throw new Error("The parameter 'chainId' cannot be null.");
        else if (chainId !== undefined)
            url_ += "ChainId=" + encodeURIComponent("" + chainId) + "&";
        if (showElectricity === null)
            throw new Error("The parameter 'showElectricity' cannot be null.");
        else if (showElectricity !== undefined)
            url_ += "ShowElectricity=" + encodeURIComponent("" + showElectricity) + "&";
        if (showInsurance === null)
            throw new Error("The parameter 'showInsurance' cannot be null.");
        else if (showInsurance !== undefined)
            url_ += "ShowInsurance=" + encodeURIComponent("" + showInsurance) + "&";
        if (showMortgage === null)
            throw new Error("The parameter 'showMortgage' cannot be null.");
        else if (showMortgage !== undefined)
            url_ += "ShowMortgage=" + encodeURIComponent("" + showMortgage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processElectricitySales(_response);
        });
    }

    protected processElectricitySales(response: Response): Promise<SalesResponseItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesResponseItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalesResponseItem[]>(null as any);
    }

    /**
     * @param ownerId (optional) 
     * @return Success
     */
    chains(ownerId: string | undefined, signal?: AbortSignal | undefined): Promise<RealEstateChainModel[]> {
        let url_ = this.baseUrl + "/report/chains?";
        if (ownerId === null)
            throw new Error("The parameter 'ownerId' cannot be null.");
        else if (ownerId !== undefined)
            url_ += "ownerId=" + encodeURIComponent("" + ownerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChains(_response);
        });
    }

    protected processChains(response: Response): Promise<RealEstateChainModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RealEstateChainModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RealEstateChainModel[]>(null as any);
    }

    /**
     * @return Success
     */
    owners(signal?: AbortSignal | undefined): Promise<RealEstateChainOwner[]> {
        let url_ = this.baseUrl + "/report/owners";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOwners(_response);
        });
    }

    protected processOwners(response: Response): Promise<RealEstateChainOwner[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RealEstateChainOwner.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RealEstateChainOwner[]>(null as any);
    }

    /**
     * @param chainId (optional) 
     * @return Success
     */
    offices(chainId: string | undefined, signal?: AbortSignal | undefined): Promise<RealEstateOfficeModel[]> {
        let url_ = this.baseUrl + "/report/offices?";
        if (chainId === null)
            throw new Error("The parameter 'chainId' cannot be null.");
        else if (chainId !== undefined)
            url_ += "chainId=" + encodeURIComponent("" + chainId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOffices(_response);
        });
    }

    protected processOffices(response: Response): Promise<RealEstateOfficeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RealEstateOfficeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RealEstateOfficeModel[]>(null as any);
    }

    /**
     * @param officeId (optional) 
     * @return Success
     */
    agents(officeId: string | undefined, signal?: AbortSignal | undefined): Promise<RealEstateAgentModel[]> {
        let url_ = this.baseUrl + "/report/agents?";
        if (officeId === null)
            throw new Error("The parameter 'officeId' cannot be null.");
        else if (officeId !== undefined)
            url_ += "officeId=" + encodeURIComponent("" + officeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAgents(_response);
        });
    }

    protected processAgents(response: Response): Promise<RealEstateAgentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RealEstateAgentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RealEstateAgentModel[]>(null as any);
    }

    /**
     * @return Success
     */
    addons(signal?: AbortSignal | undefined): Promise<AddOn[]> {
        let url_ = this.baseUrl + "/report/addons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddons(_response);
        });
    }

    protected processAddons(response: Response): Promise<AddOn[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddOn[]>(null as any);
    }

    /**
     * @return Success
     */
    users(signal?: AbortSignal | undefined): Promise<ReportUser[]> {
        let url_ = this.baseUrl + "/report/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUsers(_response);
        });
    }

    protected processUsers(response: Response): Promise<ReportUser[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportUser[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUser(body: ReportUserUpdate | undefined, signal?: AbortSignal | undefined): Promise<ReportUser> {
        let url_ = this.baseUrl + "/report/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<ReportUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportUser.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportUser>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUser(id: string, body: ReportUserUpdate | undefined, signal?: AbortSignal | undefined): Promise<ReportUser> {
        let url_ = this.baseUrl + "/report/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<ReportUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportUser.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportUser>(null as any);
    }

    /**
     * @return Success
     */
    deleteUser(id: string, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/report/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUserPermission(id: string, body: ReportUserPermissionUpdate | undefined, signal?: AbortSignal | undefined): Promise<ReportUserPermission> {
        let url_ = this.baseUrl + "/report/users/{id}/permissions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddUserPermission(_response);
        });
    }

    protected processAddUserPermission(response: Response): Promise<ReportUserPermission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportUserPermission.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportUserPermission>(null as any);
    }

    /**
     * @return Success
     */
    removeUserPermission(id: string, permissionId: string, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/report/users/{id}/permissions/{permissionId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (permissionId === undefined || permissionId === null)
            throw new Error("The parameter 'permissionId' must be defined.");
        url_ = url_.replace("{permissionId}", encodeURIComponent("" + permissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveUserPermission(_response);
        });
    }

    protected processRemoveUserPermission(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param byCreatedDate (optional) 
     * @param chainId (optional) 
     * @param showElectricity (optional) 
     * @param showInsurance (optional) 
     * @param showMortgage (optional) 
     * @param count (optional) 
     * @return Success
     */
    topOffices(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, byCreatedDate: boolean | undefined, chainId: string | undefined, showElectricity: boolean | undefined, showInsurance: boolean | undefined, showMortgage: boolean | undefined, count: number | undefined, signal?: AbortSignal | undefined): Promise<OfficeItem[]> {
        let url_ = this.baseUrl + "/report/topoffices?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (byCreatedDate === null)
            throw new Error("The parameter 'byCreatedDate' cannot be null.");
        else if (byCreatedDate !== undefined)
            url_ += "ByCreatedDate=" + encodeURIComponent("" + byCreatedDate) + "&";
        if (chainId === null)
            throw new Error("The parameter 'chainId' cannot be null.");
        else if (chainId !== undefined)
            url_ += "ChainId=" + encodeURIComponent("" + chainId) + "&";
        if (showElectricity === null)
            throw new Error("The parameter 'showElectricity' cannot be null.");
        else if (showElectricity !== undefined)
            url_ += "ShowElectricity=" + encodeURIComponent("" + showElectricity) + "&";
        if (showInsurance === null)
            throw new Error("The parameter 'showInsurance' cannot be null.");
        else if (showInsurance !== undefined)
            url_ += "ShowInsurance=" + encodeURIComponent("" + showInsurance) + "&";
        if (showMortgage === null)
            throw new Error("The parameter 'showMortgage' cannot be null.");
        else if (showMortgage !== undefined)
            url_ += "ShowMortgage=" + encodeURIComponent("" + showMortgage) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTopOffices(_response);
        });
    }

    protected processTopOffices(response: Response): Promise<OfficeItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfficeItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficeItem[]>(null as any);
    }

    /**
     * @param numberOfMonths (optional) 
     * @return Success
     */
    history(numberOfMonths: number | undefined, signal?: AbortSignal | undefined): Promise<HistoryItem[]> {
        let url_ = this.baseUrl + "/report/history?";
        if (numberOfMonths === null)
            throw new Error("The parameter 'numberOfMonths' cannot be null.");
        else if (numberOfMonths !== undefined)
            url_ += "NumberOfMonths=" + encodeURIComponent("" + numberOfMonths) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHistory(_response);
        });
    }

    protected processHistory(response: Response): Promise<HistoryItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HistoryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoryItem[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param byCreatedDate (optional) 
     * @param chainId (optional) 
     * @param showElectricity (optional) 
     * @param showInsurance (optional) 
     * @param showMortgage (optional) 
     * @param count (optional) 
     * @return Success
     */
    topAgents(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, byCreatedDate: boolean | undefined, chainId: string | undefined, showElectricity: boolean | undefined, showInsurance: boolean | undefined, showMortgage: boolean | undefined, count: number | undefined, signal?: AbortSignal | undefined): Promise<AgentItem[]> {
        let url_ = this.baseUrl + "/report/topagents?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (byCreatedDate === null)
            throw new Error("The parameter 'byCreatedDate' cannot be null.");
        else if (byCreatedDate !== undefined)
            url_ += "ByCreatedDate=" + encodeURIComponent("" + byCreatedDate) + "&";
        if (chainId === null)
            throw new Error("The parameter 'chainId' cannot be null.");
        else if (chainId !== undefined)
            url_ += "ChainId=" + encodeURIComponent("" + chainId) + "&";
        if (showElectricity === null)
            throw new Error("The parameter 'showElectricity' cannot be null.");
        else if (showElectricity !== undefined)
            url_ += "ShowElectricity=" + encodeURIComponent("" + showElectricity) + "&";
        if (showInsurance === null)
            throw new Error("The parameter 'showInsurance' cannot be null.");
        else if (showInsurance !== undefined)
            url_ += "ShowInsurance=" + encodeURIComponent("" + showInsurance) + "&";
        if (showMortgage === null)
            throw new Error("The parameter 'showMortgage' cannot be null.");
        else if (showMortgage !== undefined)
            url_ += "ShowMortgage=" + encodeURIComponent("" + showMortgage) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTopAgents(_response);
        });
    }

    protected processTopAgents(response: Response): Promise<AgentItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentItem[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param byCreatedDate (optional) 
     * @param chainId (optional) 
     * @param showElectricity (optional) 
     * @param showInsurance (optional) 
     * @param showMortgage (optional) 
     * @return Success
     */
    csvString(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, byCreatedDate: boolean | undefined, chainId: string | undefined, showElectricity: boolean | undefined, showInsurance: boolean | undefined, showMortgage: boolean | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/report/csvstring?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (byCreatedDate === null)
            throw new Error("The parameter 'byCreatedDate' cannot be null.");
        else if (byCreatedDate !== undefined)
            url_ += "ByCreatedDate=" + encodeURIComponent("" + byCreatedDate) + "&";
        if (chainId === null)
            throw new Error("The parameter 'chainId' cannot be null.");
        else if (chainId !== undefined)
            url_ += "ChainId=" + encodeURIComponent("" + chainId) + "&";
        if (showElectricity === null)
            throw new Error("The parameter 'showElectricity' cannot be null.");
        else if (showElectricity !== undefined)
            url_ += "ShowElectricity=" + encodeURIComponent("" + showElectricity) + "&";
        if (showInsurance === null)
            throw new Error("The parameter 'showInsurance' cannot be null.");
        else if (showInsurance !== undefined)
            url_ += "ShowInsurance=" + encodeURIComponent("" + showInsurance) + "&";
        if (showMortgage === null)
            throw new Error("The parameter 'showMortgage' cannot be null.");
        else if (showMortgage !== undefined)
            url_ += "ShowMortgage=" + encodeURIComponent("" + showMortgage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCsvString(_response);
        });
    }

    protected processCsvString(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SelfServiceClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param host (optional) 
     * @return Success
     */
    customer(host: string | undefined, signal?: AbortSignal | undefined): Promise<Customer> {
        let url_ = this.baseUrl + "/self-service/customer?";
        if (host === null)
            throw new Error("The parameter 'host' cannot be null.");
        else if (host !== undefined)
            url_ += "host=" + encodeURIComponent("" + host) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomer(_response);
        });
    }

    protected processCustomer(response: Response): Promise<Customer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Customer.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Customer>(null as any);
    }

    /**
     * @param host (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateCustomer(host: string | undefined, body: Customer | undefined, signal?: AbortSignal | undefined): Promise<Customer> {
        let url_ = this.baseUrl + "/self-service/customer?";
        if (host === null)
            throw new Error("The parameter 'host' cannot be null.");
        else if (host !== undefined)
            url_ += "host=" + encodeURIComponent("" + host) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCustomer(_response);
        });
    }

    protected processUpdateCustomer(response: Response): Promise<Customer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Customer.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Customer>(null as any);
    }

    /**
     * @param host (optional) 
     * @return Success
     */
    elavtal(host: string | undefined, signal?: AbortSignal | undefined): Promise<Elavtal[]> {
        let url_ = this.baseUrl + "/self-service/elavtal?";
        if (host === null)
            throw new Error("The parameter 'host' cannot be null.");
        else if (host !== undefined)
            url_ += "host=" + encodeURIComponent("" + host) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processElavtal(_response);
        });
    }

    protected processElavtal(response: Response): Promise<Elavtal[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Elavtal.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Elavtal[]>(null as any);
    }

    /**
     * @param propertyId (optional) 
     * @param host (optional) 
     * @param elavtalId (optional) 
     * @return Success
     */
    consumption(propertyId: string | undefined, host: string | undefined, elavtalId: string | undefined, signal?: AbortSignal | undefined): Promise<Consumption[]> {
        let url_ = this.baseUrl + "/self-service/consumption?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (host === null)
            throw new Error("The parameter 'host' cannot be null.");
        else if (host !== undefined)
            url_ += "host=" + encodeURIComponent("" + host) + "&";
        if (elavtalId === null)
            throw new Error("The parameter 'elavtalId' cannot be null.");
        else if (elavtalId !== undefined)
            url_ += "elavtalId=" + encodeURIComponent("" + elavtalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConsumption(_response);
        });
    }

    protected processConsumption(response: Response): Promise<Consumption[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Consumption.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Consumption[]>(null as any);
    }

    /**
     * @param propertyId (optional) 
     * @param deliveryId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return Success
     */
    consumptions(propertyId: string | undefined, deliveryId: string | undefined, startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, signal?: AbortSignal | undefined): Promise<Consumption[]> {
        let url_ = this.baseUrl + "/self-service/consumptions?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (deliveryId === null)
            throw new Error("The parameter 'deliveryId' cannot be null.");
        else if (deliveryId !== undefined)
            url_ += "deliveryId=" + encodeURIComponent("" + deliveryId) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConsumptions(_response);
        });
    }

    protected processConsumptions(response: Response): Promise<Consumption[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Consumption.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Consumption[]>(null as any);
    }

    /**
     * @param elavtalId (optional) 
     * @param consumption (optional) 
     * @return Success
     */
    fixedPrice(elavtalId: string | undefined, consumption: number | undefined, signal?: AbortSignal | undefined): Promise<FixedPrice> {
        let url_ = this.baseUrl + "/self-service/fixedPrice?";
        if (elavtalId === null)
            throw new Error("The parameter 'elavtalId' cannot be null.");
        else if (elavtalId !== undefined)
            url_ += "elavtalId=" + encodeURIComponent("" + elavtalId) + "&";
        if (consumption === null)
            throw new Error("The parameter 'consumption' cannot be null.");
        else if (consumption !== undefined)
            url_ += "consumption=" + encodeURIComponent("" + consumption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFixedPrice(_response);
        });
    }

    protected processFixedPrice(response: Response): Promise<FixedPrice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FixedPrice.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FixedPrice>(null as any);
    }

    /**
     * @param deliveryId (optional) 
     * @return Success
     */
    contracts(deliveryId: string | undefined, signal?: AbortSignal | undefined): Promise<Contract[]> {
        let url_ = this.baseUrl + "/self-service/contracts?";
        if (deliveryId === null)
            throw new Error("The parameter 'deliveryId' cannot be null.");
        else if (deliveryId !== undefined)
            url_ += "deliveryId=" + encodeURIComponent("" + deliveryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processContracts(_response);
        });
    }

    protected processContracts(response: Response): Promise<Contract[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Contract.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Contract[]>(null as any);
    }

    /**
     * @param deliveryId (optional) 
     * @return Success
     */
    estimatedVariablePrice(deliveryId: string | undefined, signal?: AbortSignal | undefined): Promise<VariablePrice> {
        let url_ = this.baseUrl + "/self-service/estimated-variable-price?";
        if (deliveryId === null)
            throw new Error("The parameter 'deliveryId' cannot be null.");
        else if (deliveryId !== undefined)
            url_ += "deliveryId=" + encodeURIComponent("" + deliveryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEstimatedVariablePrice(_response);
        });
    }

    protected processEstimatedVariablePrice(response: Response): Promise<VariablePrice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VariablePrice.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VariablePrice>(null as any);
    }

    /**
     * @param electricityArea (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param monthly (optional) 
     * @return Success
     */
    variablePrices(electricityArea: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, monthly: boolean | undefined, signal?: AbortSignal | undefined): Promise<VariablePrice[]> {
        let url_ = this.baseUrl + "/self-service/variable-prices?";
        if (electricityArea === null)
            throw new Error("The parameter 'electricityArea' cannot be null.");
        else if (electricityArea !== undefined)
            url_ += "electricityArea=" + encodeURIComponent("" + electricityArea) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (monthly === null)
            throw new Error("The parameter 'monthly' cannot be null.");
        else if (monthly !== undefined)
            url_ += "monthly=" + encodeURIComponent("" + monthly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVariablePrices(_response);
        });
    }

    protected processVariablePrices(response: Response): Promise<VariablePrice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VariablePrice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VariablePrice[]>(null as any);
    }

    /**
     * @param deliveryId (optional) 
     * @param fromDate (optional) 
     * @return Success
     */
    estimateMonth(deliveryId: string | undefined, fromDate: moment.Moment | undefined, signal?: AbortSignal | undefined): Promise<EstimatedMonth> {
        let url_ = this.baseUrl + "/self-service/estimated-month?";
        if (deliveryId === null)
            throw new Error("The parameter 'deliveryId' cannot be null.");
        else if (deliveryId !== undefined)
            url_ += "deliveryId=" + encodeURIComponent("" + deliveryId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEstimateMonth(_response);
        });
    }

    protected processEstimateMonth(response: Response): Promise<EstimatedMonth> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EstimatedMonth.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EstimatedMonth>(null as any);
    }

    /**
     * @return Success
     */
    estimationItems(signal?: AbortSignal | undefined): Promise<EstimationItem[]> {
        let url_ = this.baseUrl + "/self-service/estimation-items";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEstimationItems(_response);
        });
    }

    protected processEstimationItems(response: Response): Promise<EstimationItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EstimationItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EstimationItem[]>(null as any);
    }

    /**
     * @param page (optional) 
     * @return Success
     */
    invoices(page: number | undefined, signal?: AbortSignal | undefined): Promise<Billogram[]> {
        let url_ = this.baseUrl + "/self-service/invoices?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInvoices(_response);
        });
    }

    protected processInvoices(response: Response): Promise<Billogram[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Billogram.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Billogram[]>(null as any);
    }

    /**
     * @param page (optional) 
     * @return Success
     */
    invoicesV2(page: number | undefined, signal?: AbortSignal | undefined): Promise<Invoice[]> {
        let url_ = this.baseUrl + "/self-service/invoices-v2?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInvoicesV2(_response);
        });
    }

    protected processInvoicesV2(response: Response): Promise<Invoice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Invoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Invoice[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerForNotifications(body: Device | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/self-service/notifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterForNotifications(_response);
        });
    }

    protected processRegisterForNotifications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendNotification(body: NotificationRequest | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/self-service/notifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendNotification(_response);
        });
    }

    protected processSendNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param installationId (optional) 
     * @return Success
     */
    deleteRegistration(installationId: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/self-service/notifications?";
        if (installationId === null)
            throw new Error("The parameter 'installationId' cannot be null.");
        else if (installationId !== undefined)
            url_ += "installationId=" + encodeURIComponent("" + installationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRegistration(_response);
        });
    }

    protected processDeleteRegistration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getInstallations(signal?: AbortSignal | undefined): Promise<RegistrationDescription[]> {
        let url_ = this.baseUrl + "/self-service/notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInstallations(_response);
        });
    }

    protected processGetInstallations(response: Response): Promise<RegistrationDescription[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationDescription.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationDescription[]>(null as any);
    }
}

export class SoderbergPartnersClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param consumption (optional) 
     * @return Success
     */
    estimatedSavings(id: string, consumption: number | undefined, signal?: AbortSignal | undefined): Promise<Savings> {
        let url_ = this.baseUrl + "/soderberg-partners/{id}/estimated-savings?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (consumption === null)
            throw new Error("The parameter 'consumption' cannot be null.");
        else if (consumption !== undefined)
            url_ += "consumption=" + encodeURIComponent("" + consumption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEstimatedSavings(_response);
        });
    }

    protected processEstimatedSavings(response: Response): Promise<Savings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Savings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Savings>(null as any);
    }

    /**
     * @return Success
     */
    updateConsumptions(signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/soderberg-partners/update-consumptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateConsumptions(_response);
        });
    }

    protected processUpdateConsumptions(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAndSend(id: string, body: Order | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/soderberg-partners/{id}/update-and-send";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAndSend(_response);
        });
    }

    protected processUpdateAndSend(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndSend(body: Order | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/soderberg-partners/create-and-send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAndSend(_response);
        });
    }

    protected processCreateAndSend(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VitecClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param addOns (optional) 
     * @param contractMethod (optional) 
     * @param files (optional) 
     * @param vitecFileIds (optional) 
     * @param comment (optional) 
     * @return Success
     */
    completeOrder(id: string, addOns: AddOn[] | undefined, contractMethod: RealEstateOrderContractMethod | undefined, files: FileParameter[] | undefined, vitecFileIds: string[] | undefined, comment: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/vitec/order/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (addOns === null || addOns === undefined)
            throw new Error("The parameter 'addOns' cannot be null.");
        else
            addOns.forEach(item_ => content_.append("AddOns", item_.toString()));
        if (contractMethod === null || contractMethod === undefined)
            throw new Error("The parameter 'contractMethod' cannot be null.");
        else
            content_.append("ContractMethod", contractMethod.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (vitecFileIds === null || vitecFileIds === undefined)
            throw new Error("The parameter 'vitecFileIds' cannot be null.");
        else
            vitecFileIds.forEach(item_ => content_.append("VitecFileIds", item_.toString()));
        if (comment === null || comment === undefined)
            throw new Error("The parameter 'comment' cannot be null.");
        else
            content_.append("Comment", comment.toString());

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompleteOrder(_response);
        });
    }

    protected processCompleteOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param token (optional) 
     * @return Success
     */
    getOrder(customerId: string | undefined, token: string | undefined, signal?: AbortSignal | undefined): Promise<VitecOrder> {
        let url_ = this.baseUrl + "/vitec/order?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrder(_response);
        });
    }

    protected processGetOrder(response: Response): Promise<VitecOrder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VitecOrder.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VitecOrder>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param token (optional) 
     * @return Success
     */
    updateOrderNotInterested(customerId: string | undefined, token: string | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/vitec/order-not-interested?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateOrderNotInterested(_response);
        });
    }

    protected processUpdateOrderNotInterested(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param token (optional) 
     * @return Success
     */
    updateOrderNotAsked(customerId: string | undefined, token: string | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/vitec/order-not-asked?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateOrderNotAsked(_response);
        });
    }

    protected processUpdateOrderNotAsked(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class Address implements IAddress {
    pid?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pid = _data["pid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pid"] = this.pid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        return data;
    }
}

export interface IAddress {
    pid?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
}

export enum Channel {
    WEB = "WEB",
    FRIBERGASKOLAN = "FRIBERGASKOLAN",
    ERIK_OLSSON = "ERIK_OLSSON",
    SAF = "SAF",
    STIGTOMTA_IF = "STIGTOMTA_IF",
    NSK = "NSK",
    SWADD = "SWADD",
    BRFMATTBANDET = "BRFMATTBANDET",
    NYKVARNEL = "NYKVARNEL",
    SKANDIA_MAKLARNA = "SKANDIA_MAKLARNA",
    SKANDIA_MAKLARNA_PARTNER = "SKANDIA_MAKLARNA_PARTNER",
    ERIK_OLSSON_PARTNER = "ERIK_OLSSON_PARTNER",
    SODERBERG_PARTNERS = "SODERBERG_PARTNERS",
    AVY = "AVY",
    ERIK_OLSSON_LEAD = "ERIK_OLSSON_LEAD",
    ERA = "ERA",
    ERA_PARTNER = "ERA_PARTNER",
    MOHV = "MOHV",
    MOHV_PARTNER = "MOHV_PARTNER",
    NOTAR = "NOTAR",
    NOTAR_PARTNER = "NOTAR_PARTNER",
    MAKLARRINGEN = "MAKLARRINGEN",
    MAKLARRINGEN_PARTNER = "MAKLARRINGEN_PARTNER",
    ESNY = "ESNY",
    ESNY_PARTNER = "ESNY_PARTNER",
    SVENSKA_MAKLARHUSET = "SVENSKA_MAKLARHUSET",
    SVENSKA_MAKLARHUSET_PARTNER = "SVENSKA_MAKLARHUSET_PARTNER",
    SODERBERG_PARTNERS_PARTNER = "SODERBERG_PARTNERS_PARTNER",
    WIDERLOV = "WIDERLOV",
    WIDERLOV_PARTNER = "WIDERLOV_PARTNER",
    SODERBERG_PARTNERS_SALARY = "SODERBERG_PARTNERS_SALARY",
    SODERBERG_PARTNERS_TM = "SODERBERG_PARTNERS_TM",
    SODERBERG_PARTNERS_MORTGAGE = "SODERBERG_PARTNERS_MORTGAGE",
    BJURFORS = "BJURFORS",
    BJURFORS_PARTNER = "BJURFORS_PARTNER",
    GUTEEL = "GUTEEL",
    PADEL = "PADEL",
}

export class RealEstateChainOwner implements IRealEstateChainOwner {
    id?: string;
    name?: string | undefined;
    chains?: RealEstateChainModel[] | undefined;

    constructor(data?: IRealEstateChainOwner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["chains"])) {
                this.chains = [] as any;
                for (let item of _data["chains"])
                    this.chains!.push(RealEstateChainModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RealEstateChainOwner {
        data = typeof data === 'object' ? data : {};
        let result = new RealEstateChainOwner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.chains)) {
            data["chains"] = [];
            for (let item of this.chains)
                data["chains"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRealEstateChainOwner {
    id?: string;
    name?: string | undefined;
    chains?: RealEstateChainModel[] | undefined;
}

export class RealEstateChainModel implements IRealEstateChainModel {
    id?: string;
    name?: string | undefined;
    channel?: Channel;
    realEstateChainOwnerId?: string;
    owner?: RealEstateChainOwner;
    offices?: RealEstateOfficeModel[] | undefined;
    vitecCustomerId?: string | undefined;
    apiKey?: string | undefined;
    vitecFilesAccess?: boolean;
    mspecsSubscriberId?: string | undefined;
    contractEmail?: string | undefined;
    syncObjects?: boolean;
    signupLink?: string | undefined;

    constructor(data?: IRealEstateChainModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.channel = _data["channel"];
            this.realEstateChainOwnerId = _data["realEstateChainOwnerId"];
            this.owner = _data["owner"] ? RealEstateChainOwner.fromJS(_data["owner"]) : <any>undefined;
            if (Array.isArray(_data["offices"])) {
                this.offices = [] as any;
                for (let item of _data["offices"])
                    this.offices!.push(RealEstateOfficeModel.fromJS(item));
            }
            this.vitecCustomerId = _data["vitecCustomerId"];
            this.apiKey = _data["apiKey"];
            this.vitecFilesAccess = _data["vitecFilesAccess"];
            this.mspecsSubscriberId = _data["mspecsSubscriberId"];
            this.contractEmail = _data["contractEmail"];
            this.syncObjects = _data["syncObjects"];
            this.signupLink = _data["signupLink"];
        }
    }

    static fromJS(data: any): RealEstateChainModel {
        data = typeof data === 'object' ? data : {};
        let result = new RealEstateChainModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["channel"] = this.channel;
        data["realEstateChainOwnerId"] = this.realEstateChainOwnerId;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        if (Array.isArray(this.offices)) {
            data["offices"] = [];
            for (let item of this.offices)
                data["offices"].push(item.toJSON());
        }
        data["vitecCustomerId"] = this.vitecCustomerId;
        data["apiKey"] = this.apiKey;
        data["vitecFilesAccess"] = this.vitecFilesAccess;
        data["mspecsSubscriberId"] = this.mspecsSubscriberId;
        data["contractEmail"] = this.contractEmail;
        data["syncObjects"] = this.syncObjects;
        data["signupLink"] = this.signupLink;
        return data;
    }
}

export interface IRealEstateChainModel {
    id?: string;
    name?: string | undefined;
    channel?: Channel;
    realEstateChainOwnerId?: string;
    owner?: RealEstateChainOwner;
    offices?: RealEstateOfficeModel[] | undefined;
    vitecCustomerId?: string | undefined;
    apiKey?: string | undefined;
    vitecFilesAccess?: boolean;
    mspecsSubscriberId?: string | undefined;
    contractEmail?: string | undefined;
    syncObjects?: boolean;
    signupLink?: string | undefined;
}

export class RealEstateOfficeModel implements IRealEstateOfficeModel {
    id?: string;
    location?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    externalId?: string | undefined;
    realEstateChainId?: string;
    chain?: RealEstateChainModel;
    agents?: RealEstateAgentModel[] | undefined;
    createdOn?: moment.Moment;
    modifiedOn?: moment.Moment;
    group?: string | undefined;
    vitecCustomerId?: string | undefined;
    mspecsId?: string | undefined;

    constructor(data?: IRealEstateOfficeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.location = _data["location"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.externalId = _data["externalId"];
            this.realEstateChainId = _data["realEstateChainId"];
            this.chain = _data["chain"] ? RealEstateChainModel.fromJS(_data["chain"]) : <any>undefined;
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(RealEstateAgentModel.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.group = _data["group"];
            this.vitecCustomerId = _data["vitecCustomerId"];
            this.mspecsId = _data["mspecsId"];
        }
    }

    static fromJS(data: any): RealEstateOfficeModel {
        data = typeof data === 'object' ? data : {};
        let result = new RealEstateOfficeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["location"] = this.location;
        data["street"] = this.street;
        data["city"] = this.city;
        data["externalId"] = this.externalId;
        data["realEstateChainId"] = this.realEstateChainId;
        data["chain"] = this.chain ? this.chain.toJSON() : <any>undefined;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["group"] = this.group;
        data["vitecCustomerId"] = this.vitecCustomerId;
        data["mspecsId"] = this.mspecsId;
        return data;
    }
}

export interface IRealEstateOfficeModel {
    id?: string;
    location?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    externalId?: string | undefined;
    realEstateChainId?: string;
    chain?: RealEstateChainModel;
    agents?: RealEstateAgentModel[] | undefined;
    createdOn?: moment.Moment;
    modifiedOn?: moment.Moment;
    group?: string | undefined;
    vitecCustomerId?: string | undefined;
    mspecsId?: string | undefined;
}

export class RealEstateAgentModel implements IRealEstateAgentModel {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    realEstateCompany?: string | undefined;
    channel?: Channel;
    bannerId?: string | undefined;
    externalId?: string | undefined;
    officeId?: string | undefined;
    office?: RealEstateOfficeModel;
    offices?: RealEstateOfficeModel[] | undefined;
    chainId?: string | undefined;
    chain?: RealEstateChainModel;
    createdOn?: moment.Moment;
    modifiedOn?: moment.Moment;
    mspecsId?: string | undefined;

    constructor(data?: IRealEstateAgentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.realEstateCompany = _data["realEstateCompany"];
            this.channel = _data["channel"];
            this.bannerId = _data["bannerId"];
            this.externalId = _data["externalId"];
            this.officeId = _data["officeId"];
            this.office = _data["office"] ? RealEstateOfficeModel.fromJS(_data["office"]) : <any>undefined;
            if (Array.isArray(_data["offices"])) {
                this.offices = [] as any;
                for (let item of _data["offices"])
                    this.offices!.push(RealEstateOfficeModel.fromJS(item));
            }
            this.chainId = _data["chainId"];
            this.chain = _data["chain"] ? RealEstateChainModel.fromJS(_data["chain"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.mspecsId = _data["mspecsId"];
        }
    }

    static fromJS(data: any): RealEstateAgentModel {
        data = typeof data === 'object' ? data : {};
        let result = new RealEstateAgentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["realEstateCompany"] = this.realEstateCompany;
        data["channel"] = this.channel;
        data["bannerId"] = this.bannerId;
        data["externalId"] = this.externalId;
        data["officeId"] = this.officeId;
        data["office"] = this.office ? this.office.toJSON() : <any>undefined;
        if (Array.isArray(this.offices)) {
            data["offices"] = [];
            for (let item of this.offices)
                data["offices"].push(item.toJSON());
        }
        data["chainId"] = this.chainId;
        data["chain"] = this.chain ? this.chain.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["mspecsId"] = this.mspecsId;
        return data;
    }
}

export interface IRealEstateAgentModel {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    realEstateCompany?: string | undefined;
    channel?: Channel;
    bannerId?: string | undefined;
    externalId?: string | undefined;
    officeId?: string | undefined;
    office?: RealEstateOfficeModel;
    offices?: RealEstateOfficeModel[] | undefined;
    chainId?: string | undefined;
    chain?: RealEstateChainModel;
    createdOn?: moment.Moment;
    modifiedOn?: moment.Moment;
    mspecsId?: string | undefined;
}

export class RealEstateObjectFileDbModel implements IRealEstateObjectFileDbModel {
    id?: string;
    externalId?: string | undefined;
    name?: string | undefined;
    extension?: string | undefined;
    modifiedOn?: moment.Moment;
    realEstateObjectId?: string;
    realEstateObject?: RealEstateObjectDbModel;

    constructor(data?: IRealEstateObjectFileDbModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.realEstateObjectId = _data["realEstateObjectId"];
            this.realEstateObject = _data["realEstateObject"] ? RealEstateObjectDbModel.fromJS(_data["realEstateObject"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RealEstateObjectFileDbModel {
        data = typeof data === 'object' ? data : {};
        let result = new RealEstateObjectFileDbModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["realEstateObjectId"] = this.realEstateObjectId;
        data["realEstateObject"] = this.realEstateObject ? this.realEstateObject.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRealEstateObjectFileDbModel {
    id?: string;
    externalId?: string | undefined;
    name?: string | undefined;
    extension?: string | undefined;
    modifiedOn?: moment.Moment;
    realEstateObjectId?: string;
    realEstateObject?: RealEstateObjectDbModel;
}

export enum RealEstateObjectStatus {
    NEW = "NEW",
    HANDLED = "HANDLED",
    ORDER_CREATED = "ORDER_CREATED",
}

export enum Housing {
    LAGENHET = "LAGENHET",
    RADHUS = "RADHUS",
    VILLA = "VILLA",
    FRITIDSHUS = "FRITIDSHUS",
}

export class RealEstateObjectDbModel implements IRealEstateObjectDbModel {
    id?: string;
    externalId?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    salesDate?: moment.Moment | undefined;
    startDate?: moment.Moment | undefined;
    agent?: RealEstateAgentModel;
    office?: RealEstateOfficeModel;
    chainId?: string;
    chain?: RealEstateChainModel;
    files?: RealEstateObjectFileDbModel[] | undefined;
    vitecObjectId?: string | undefined;
    vitecObjectNumber?: string | undefined;
    status?: string | undefined;
    statusText?: string | undefined;
    createdOn?: moment.Moment;
    modifiedOn?: moment.Moment;
    internalStatus?: RealEstateObjectStatus;
    housing?: Housing;
    readonly auditEntityId?: string | undefined;

    constructor(data?: IRealEstateObjectDbModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.street = _data["street"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.salesDate = _data["salesDate"] ? moment(_data["salesDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.agent = _data["agent"] ? RealEstateAgentModel.fromJS(_data["agent"]) : <any>undefined;
            this.office = _data["office"] ? RealEstateOfficeModel.fromJS(_data["office"]) : <any>undefined;
            this.chainId = _data["chainId"];
            this.chain = _data["chain"] ? RealEstateChainModel.fromJS(_data["chain"]) : <any>undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(RealEstateObjectFileDbModel.fromJS(item));
            }
            this.vitecObjectId = _data["vitecObjectId"];
            this.vitecObjectNumber = _data["vitecObjectNumber"];
            this.status = _data["status"];
            this.statusText = _data["statusText"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.internalStatus = _data["internalStatus"];
            this.housing = _data["housing"];
            (<any>this).auditEntityId = _data["auditEntityId"];
        }
    }

    static fromJS(data: any): RealEstateObjectDbModel {
        data = typeof data === 'object' ? data : {};
        let result = new RealEstateObjectDbModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["street"] = this.street;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["salesDate"] = this.salesDate ? this.salesDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["office"] = this.office ? this.office.toJSON() : <any>undefined;
        data["chainId"] = this.chainId;
        data["chain"] = this.chain ? this.chain.toJSON() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["vitecObjectId"] = this.vitecObjectId;
        data["vitecObjectNumber"] = this.vitecObjectNumber;
        data["status"] = this.status;
        data["statusText"] = this.statusText;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["internalStatus"] = this.internalStatus;
        data["housing"] = this.housing;
        data["auditEntityId"] = this.auditEntityId;
        return data;
    }
}

export interface IRealEstateObjectDbModel {
    id?: string;
    externalId?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    salesDate?: moment.Moment | undefined;
    startDate?: moment.Moment | undefined;
    agent?: RealEstateAgentModel;
    office?: RealEstateOfficeModel;
    chainId?: string;
    chain?: RealEstateChainModel;
    files?: RealEstateObjectFileDbModel[] | undefined;
    vitecObjectId?: string | undefined;
    vitecObjectNumber?: string | undefined;
    status?: string | undefined;
    statusText?: string | undefined;
    createdOn?: moment.Moment;
    modifiedOn?: moment.Moment;
    internalStatus?: RealEstateObjectStatus;
    housing?: Housing;
    auditEntityId?: string | undefined;
}

export enum InvoiceDataStatus {
    NEW = "NEW",
    BILLED = "BILLED",
    SENT = "SENT",
}

export class CompanySettingsBillogramModel implements ICompanySettingsBillogramModel {
    enabled?: boolean;
    username?: string | undefined;
    password?: string | undefined;
    bankGiro?: string | undefined;
    emailOverride?: string | undefined;
    defaultBannerId?: string | undefined;
    itemTitleConsuming?: string | undefined;
    itemTitleProducing?: string | undefined;
    useElectricityCollection?: boolean;

    constructor(data?: ICompanySettingsBillogramModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.bankGiro = _data["bankGiro"];
            this.emailOverride = _data["emailOverride"];
            this.defaultBannerId = _data["defaultBannerId"];
            this.itemTitleConsuming = _data["itemTitleConsuming"];
            this.itemTitleProducing = _data["itemTitleProducing"];
            this.useElectricityCollection = _data["useElectricityCollection"];
        }
    }

    static fromJS(data: any): CompanySettingsBillogramModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySettingsBillogramModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["username"] = this.username;
        data["password"] = this.password;
        data["bankGiro"] = this.bankGiro;
        data["emailOverride"] = this.emailOverride;
        data["defaultBannerId"] = this.defaultBannerId;
        data["itemTitleConsuming"] = this.itemTitleConsuming;
        data["itemTitleProducing"] = this.itemTitleProducing;
        data["useElectricityCollection"] = this.useElectricityCollection;
        return data;
    }
}

export interface ICompanySettingsBillogramModel {
    enabled?: boolean;
    username?: string | undefined;
    password?: string | undefined;
    bankGiro?: string | undefined;
    emailOverride?: string | undefined;
    defaultBannerId?: string | undefined;
    itemTitleConsuming?: string | undefined;
    itemTitleProducing?: string | undefined;
    useElectricityCollection?: boolean;
}

export class CompanySettingsCommunicationModel implements ICompanySettingsCommunicationModel {
    emailOverride?: string | undefined;
    sendGridApiKey?: string | undefined;
    authenticatedDomains?: string[] | undefined;
    smsOverride?: string | undefined;

    constructor(data?: ICompanySettingsCommunicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailOverride = _data["emailOverride"];
            this.sendGridApiKey = _data["sendGridApiKey"];
            if (Array.isArray(_data["authenticatedDomains"])) {
                this.authenticatedDomains = [] as any;
                for (let item of _data["authenticatedDomains"])
                    this.authenticatedDomains!.push(item);
            }
            this.smsOverride = _data["smsOverride"];
        }
    }

    static fromJS(data: any): CompanySettingsCommunicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySettingsCommunicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailOverride"] = this.emailOverride;
        data["sendGridApiKey"] = this.sendGridApiKey;
        if (Array.isArray(this.authenticatedDomains)) {
            data["authenticatedDomains"] = [];
            for (let item of this.authenticatedDomains)
                data["authenticatedDomains"].push(item);
        }
        data["smsOverride"] = this.smsOverride;
        return data;
    }
}

export interface ICompanySettingsCommunicationModel {
    emailOverride?: string | undefined;
    sendGridApiKey?: string | undefined;
    authenticatedDomains?: string[] | undefined;
    smsOverride?: string | undefined;
}

export enum InvoiceDeliveryMethod {
    MAIL = "MAIL",
    SMS = "SMS",
    EINVOICE = "EINVOICE",
    LETTER = "LETTER",
    DYNAMICDISTRIBUTION = "DYNAMICDISTRIBUTION",
    DO_NOT_NOTIFY = "DO_NOT_NOTIFY",
    EDI = "EDI",
}

export class CompanySettingsInvoicing implements ICompanySettingsInvoicing {
    invoiceOverdueNotificationDelay?: number | undefined;
    defaultInvoiceDeliveryMethod?: InvoiceDeliveryMethod;

    constructor(data?: ICompanySettingsInvoicing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceOverdueNotificationDelay = _data["invoiceOverdueNotificationDelay"];
            this.defaultInvoiceDeliveryMethod = _data["defaultInvoiceDeliveryMethod"];
        }
    }

    static fromJS(data: any): CompanySettingsInvoicing {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySettingsInvoicing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceOverdueNotificationDelay"] = this.invoiceOverdueNotificationDelay;
        data["defaultInvoiceDeliveryMethod"] = this.defaultInvoiceDeliveryMethod;
        return data;
    }
}

export interface ICompanySettingsInvoicing {
    invoiceOverdueNotificationDelay?: number | undefined;
    defaultInvoiceDeliveryMethod?: InvoiceDeliveryMethod;
}

export enum PropertyType {
    CONSUMING = "CONSUMING",
    PRODUCING = "PRODUCING",
}

export class CompanySettingsInvoiceAttachmentFooterRowModel implements ICompanySettingsInvoiceAttachmentFooterRowModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    title?: string | undefined;
    text?: string | undefined;
    sortIndex?: number;
    propertyType?: PropertyType;
    companySettingsInvoiceAttachmentId?: string;

    constructor(data?: ICompanySettingsInvoiceAttachmentFooterRowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.title = _data["title"];
            this.text = _data["text"];
            this.sortIndex = _data["sortIndex"];
            this.propertyType = _data["propertyType"];
            this.companySettingsInvoiceAttachmentId = _data["companySettingsInvoiceAttachmentId"];
        }
    }

    static fromJS(data: any): CompanySettingsInvoiceAttachmentFooterRowModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySettingsInvoiceAttachmentFooterRowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["text"] = this.text;
        data["sortIndex"] = this.sortIndex;
        data["propertyType"] = this.propertyType;
        data["companySettingsInvoiceAttachmentId"] = this.companySettingsInvoiceAttachmentId;
        return data;
    }
}

export interface ICompanySettingsInvoiceAttachmentFooterRowModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    title?: string | undefined;
    text?: string | undefined;
    sortIndex?: number;
    propertyType?: PropertyType;
    companySettingsInvoiceAttachmentId?: string;
}

export class CompanySettingsInvoiceAttachmentModel implements ICompanySettingsInvoiceAttachmentModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    company?: CompanyModel;
    companyId?: string;
    includeVat?: boolean;
    titleConsumtion?: string | undefined;
    titleProduction?: string | undefined;
    propertyInfoTitle?: string | undefined;
    detailedSummery?: boolean;
    energySourceImages?: string[] | undefined;
    footerRows?: CompanySettingsInvoiceAttachmentFooterRowModel[] | undefined;

    constructor(data?: ICompanySettingsInvoiceAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.companyId = _data["companyId"];
            this.includeVat = _data["includeVat"];
            this.titleConsumtion = _data["titleConsumtion"];
            this.titleProduction = _data["titleProduction"];
            this.propertyInfoTitle = _data["propertyInfoTitle"];
            this.detailedSummery = _data["detailedSummery"];
            if (Array.isArray(_data["energySourceImages"])) {
                this.energySourceImages = [] as any;
                for (let item of _data["energySourceImages"])
                    this.energySourceImages!.push(item);
            }
            if (Array.isArray(_data["footerRows"])) {
                this.footerRows = [] as any;
                for (let item of _data["footerRows"])
                    this.footerRows!.push(CompanySettingsInvoiceAttachmentFooterRowModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanySettingsInvoiceAttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySettingsInvoiceAttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["includeVat"] = this.includeVat;
        data["titleConsumtion"] = this.titleConsumtion;
        data["titleProduction"] = this.titleProduction;
        data["propertyInfoTitle"] = this.propertyInfoTitle;
        data["detailedSummery"] = this.detailedSummery;
        if (Array.isArray(this.energySourceImages)) {
            data["energySourceImages"] = [];
            for (let item of this.energySourceImages)
                data["energySourceImages"].push(item);
        }
        if (Array.isArray(this.footerRows)) {
            data["footerRows"] = [];
            for (let item of this.footerRows)
                data["footerRows"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompanySettingsInvoiceAttachmentModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    company?: CompanyModel;
    companyId?: string;
    includeVat?: boolean;
    titleConsumtion?: string | undefined;
    titleProduction?: string | undefined;
    propertyInfoTitle?: string | undefined;
    detailedSummery?: boolean;
    energySourceImages?: string[] | undefined;
    footerRows?: CompanySettingsInvoiceAttachmentFooterRowModel[] | undefined;
}

export class CompanySettingsCallback implements ICompanySettingsCallback {
    id?: string;
    url?: string | undefined;
    entities?: string[] | undefined;

    constructor(data?: ICompanySettingsCallback) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(item);
            }
        }
    }

    static fromJS(data: any): CompanySettingsCallback {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySettingsCallback();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item);
        }
        return data;
    }
}

export interface ICompanySettingsCallback {
    id?: string;
    url?: string | undefined;
    entities?: string[] | undefined;
}

export enum CommunicationType {
    InvoiceOverdue = "InvoiceOverdue",
    DeliveryStarted = "DeliveryStarted",
    Confirmation = "Confirmation",
    DeliveryReady = "DeliveryReady",
    BoundBySupplier = "BoundBySupplier",
    DeliveryCompletion = "DeliveryCompletion",
    PartOfRentCollectiveMeasurement = "PartOfRentCollectiveMeasurement",
}

export enum SupplierChangeType {
    SupplierChange = "SupplierChange",
    Move = "Move",
    ObligationToReceive = "ObligationToReceive",
    RetailerTermination = "RetailerTermination",
}

export class CommunicationTemplateModel implements ICommunicationTemplateModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    salesChannels?: SalesChannelModel[] | undefined;
    type?: CommunicationType;
    supplierChangeTypes?: SupplierChangeType[] | undefined;
    smsEnabled?: boolean;
    smsTemplate?: string | undefined;
    smsSubject?: string | undefined;
    emailEnabled?: boolean;
    emailTemplateId?: string | undefined;

    constructor(data?: ICommunicationTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            if (Array.isArray(_data["salesChannels"])) {
                this.salesChannels = [] as any;
                for (let item of _data["salesChannels"])
                    this.salesChannels!.push(SalesChannelModel.fromJS(item));
            }
            this.type = _data["type"];
            if (Array.isArray(_data["supplierChangeTypes"])) {
                this.supplierChangeTypes = [] as any;
                for (let item of _data["supplierChangeTypes"])
                    this.supplierChangeTypes!.push(item);
            }
            this.smsEnabled = _data["smsEnabled"];
            this.smsTemplate = _data["smsTemplate"];
            this.smsSubject = _data["smsSubject"];
            this.emailEnabled = _data["emailEnabled"];
            this.emailTemplateId = _data["emailTemplateId"];
        }
    }

    static fromJS(data: any): CommunicationTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.salesChannels)) {
            data["salesChannels"] = [];
            for (let item of this.salesChannels)
                data["salesChannels"].push(item.toJSON());
        }
        data["type"] = this.type;
        if (Array.isArray(this.supplierChangeTypes)) {
            data["supplierChangeTypes"] = [];
            for (let item of this.supplierChangeTypes)
                data["supplierChangeTypes"].push(item);
        }
        data["smsEnabled"] = this.smsEnabled;
        data["smsTemplate"] = this.smsTemplate;
        data["smsSubject"] = this.smsSubject;
        data["emailEnabled"] = this.emailEnabled;
        data["emailTemplateId"] = this.emailTemplateId;
        return data;
    }
}

export interface ICommunicationTemplateModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    salesChannels?: SalesChannelModel[] | undefined;
    type?: CommunicationType;
    supplierChangeTypes?: SupplierChangeType[] | undefined;
    smsEnabled?: boolean;
    smsTemplate?: string | undefined;
    smsSubject?: string | undefined;
    emailEnabled?: boolean;
    emailTemplateId?: string | undefined;
}

export class AccountingDimensionModel implements IAccountingDimensionModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    dimensionId?: number;
    name?: string | undefined;

    constructor(data?: IAccountingDimensionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.dimensionId = _data["dimensionId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AccountingDimensionModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountingDimensionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["dimensionId"] = this.dimensionId;
        data["name"] = this.name;
        return data;
    }
}

export interface IAccountingDimensionModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    dimensionId?: number;
    name?: string | undefined;
}

export enum CustomerType {
    Private = "Private",
    Business = "Business",
}

export enum PersonalIdType {
    PERSONAL_IDENTITY_NUMBER = "PERSONAL_IDENTITY_NUMBER",
    ORGANISATION_REGISTRATION_NUMBER = "ORGANISATION_REGISTRATION_NUMBER",
    COORDINATION_NUMBER = "COORDINATION_NUMBER",
    PERSONAL_ID_NOT_AVAILABLE = "PERSONAL_ID_NOT_AVAILABLE",
}

export enum RecurringPaymentType {
    NONE = "NONE",
    AUTOGIRO = "AUTOGIRO",
}

export class CustomerModel implements ICustomerModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    customerType?: CustomerType;
    pid?: string | undefined;
    personalIdType?: PersonalIdType;
    birthDate?: moment.Moment | undefined;
    additionalPersonalId?: string | undefined;
    street?: string | undefined;
    coAddress?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    billogramCustomerId?: number | undefined;
    efaktura_Recipient_Identifier?: string | undefined;
    recurringPaymentType?: RecurringPaymentType;
    edi_electronic_id?: string | undefined;
    edi_operator?: string | undefined;
    edi_reference?: string | undefined;
    useInvoiceCollection?: boolean;
    invoiceDeliveryMethod?: InvoiceDeliveryMethod;
    searchData?: string | undefined;
    entityData?: string | undefined;
    entityType?: string | undefined;
    regardingName?: string | undefined;

    constructor(data?: ICustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.customerType = _data["customerType"];
            this.pid = _data["pid"];
            this.personalIdType = _data["personalIdType"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.additionalPersonalId = _data["additionalPersonalId"];
            this.street = _data["street"];
            this.coAddress = _data["coAddress"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.mobile = _data["mobile"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.billogramCustomerId = _data["billogramCustomerId"];
            this.efaktura_Recipient_Identifier = _data["efaktura_Recipient_Identifier"];
            this.recurringPaymentType = _data["recurringPaymentType"];
            this.edi_electronic_id = _data["edi_electronic_id"];
            this.edi_operator = _data["edi_operator"];
            this.edi_reference = _data["edi_reference"];
            this.useInvoiceCollection = _data["useInvoiceCollection"];
            this.invoiceDeliveryMethod = _data["invoiceDeliveryMethod"];
            this.searchData = _data["searchData"];
            this.entityData = _data["entityData"];
            this.entityType = _data["entityType"];
            this.regardingName = _data["regardingName"];
        }
    }

    static fromJS(data: any): CustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["customerType"] = this.customerType;
        data["pid"] = this.pid;
        data["personalIdType"] = this.personalIdType;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["additionalPersonalId"] = this.additionalPersonalId;
        data["street"] = this.street;
        data["coAddress"] = this.coAddress;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["mobile"] = this.mobile;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["billogramCustomerId"] = this.billogramCustomerId;
        data["efaktura_Recipient_Identifier"] = this.efaktura_Recipient_Identifier;
        data["recurringPaymentType"] = this.recurringPaymentType;
        data["edi_electronic_id"] = this.edi_electronic_id;
        data["edi_operator"] = this.edi_operator;
        data["edi_reference"] = this.edi_reference;
        data["useInvoiceCollection"] = this.useInvoiceCollection;
        data["invoiceDeliveryMethod"] = this.invoiceDeliveryMethod;
        data["searchData"] = this.searchData;
        data["entityData"] = this.entityData;
        data["entityType"] = this.entityType;
        data["regardingName"] = this.regardingName;
        return data;
    }
}

export interface ICustomerModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    customerType?: CustomerType;
    pid?: string | undefined;
    personalIdType?: PersonalIdType;
    birthDate?: moment.Moment | undefined;
    additionalPersonalId?: string | undefined;
    street?: string | undefined;
    coAddress?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    billogramCustomerId?: number | undefined;
    efaktura_Recipient_Identifier?: string | undefined;
    recurringPaymentType?: RecurringPaymentType;
    edi_electronic_id?: string | undefined;
    edi_operator?: string | undefined;
    edi_reference?: string | undefined;
    useInvoiceCollection?: boolean;
    invoiceDeliveryMethod?: InvoiceDeliveryMethod;
    searchData?: string | undefined;
    entityData?: string | undefined;
    entityType?: string | undefined;
    regardingName?: string | undefined;
}

export enum PaymentStatus {
    UNPAID = "UNPAID",
    PAID = "PAID",
    ENDED = "ENDED",
    CREDITED = "CREDITED",
    DELETED = "DELETED",
    UNKNOWN = "UNKNOWN",
    CONFIRMED_LOSS = "CONFIRMED_LOSS",
}

export class PriceModel implements IPriceModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    fromDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    monthly?: number;

    constructor(data?: IPriceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.monthly = _data["monthly"];
        }
    }

    static fromJS(data: any): PriceModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["monthly"] = this.monthly;
        return data;
    }
}

export interface IPriceModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    fromDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    monthly?: number;
}

export enum ContractPriceType {
    FIXED_PRICE = "FIXED_PRICE",
    VARIABLE_PRICE = "VARIABLE_PRICE",
}

export enum ContractDebitType {
    MONTHLY = "MONTHLY",
    HOURLY = "HOURLY",
}

export class ContractTypeModel implements IContractTypeModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    name?: string | undefined;
    publicName?: string | undefined;
    bindingPeriod?: number;
    noticePeriod?: number;
    prices?: PriceModel[] | undefined;
    contractPriceType?: ContractPriceType;
    contractDebitType?: ContractDebitType;

    constructor(data?: IContractTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.name = _data["name"];
            this.publicName = _data["publicName"];
            this.bindingPeriod = _data["bindingPeriod"];
            this.noticePeriod = _data["noticePeriod"];
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(PriceModel.fromJS(item));
            }
            this.contractPriceType = _data["contractPriceType"];
            this.contractDebitType = _data["contractDebitType"];
        }
    }

    static fromJS(data: any): ContractTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["publicName"] = this.publicName;
        data["bindingPeriod"] = this.bindingPeriod;
        data["noticePeriod"] = this.noticePeriod;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        data["contractPriceType"] = this.contractPriceType;
        data["contractDebitType"] = this.contractDebitType;
        return data;
    }
}

export interface IContractTypeModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    name?: string | undefined;
    publicName?: string | undefined;
    bindingPeriod?: number;
    noticePeriod?: number;
    prices?: PriceModel[] | undefined;
    contractPriceType?: ContractPriceType;
    contractDebitType?: ContractDebitType;
}

export class PriceKWh implements IPriceKWh {
    sE1?: number;
    sE2?: number;
    sE3?: number;
    sE4?: number;
    certificate?: number;
    environment?: number;
    tradeFee?: number;

    constructor(data?: IPriceKWh) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sE1 = _data["sE1"];
            this.sE2 = _data["sE2"];
            this.sE3 = _data["sE3"];
            this.sE4 = _data["sE4"];
            this.certificate = _data["certificate"];
            this.environment = _data["environment"];
            this.tradeFee = _data["tradeFee"];
        }
    }

    static fromJS(data: any): PriceKWh {
        data = typeof data === 'object' ? data : {};
        let result = new PriceKWh();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sE1"] = this.sE1;
        data["sE2"] = this.sE2;
        data["sE3"] = this.sE3;
        data["sE4"] = this.sE4;
        data["certificate"] = this.certificate;
        data["environment"] = this.environment;
        data["tradeFee"] = this.tradeFee;
        return data;
    }
}

export interface IPriceKWh {
    sE1?: number;
    sE2?: number;
    sE3?: number;
    sE4?: number;
    certificate?: number;
    environment?: number;
    tradeFee?: number;
}

export class Tag implements ITag {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: ITag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Tag {
        data = typeof data === 'object' ? data : {};
        let result = new Tag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ITag {
    key?: string | undefined;
    value?: string | undefined;
}

export class Contract implements IContract {
    id?: string;
    fromDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    elavtalId?: string;
    contractType?: ContractTypeModel;
    contractTypeId?: string;
    fixedPriceKWh?: PriceKWh;
    fixedPriceMonthly?: number | undefined;
    initialContract?: boolean;
    invoiceText?: string | undefined;
    salesChannelId?: string;
    salesChannel?: SalesChannelModel;
    salesDate?: moment.Moment | undefined;
    salesPerson?: string | undefined;
    signedFromIp?: string | undefined;
    tags?: Tag[] | undefined;
    companyId?: string;
    company?: CompanyModel;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;

    constructor(data?: IContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.elavtalId = _data["elavtalId"];
            this.contractType = _data["contractType"] ? ContractTypeModel.fromJS(_data["contractType"]) : <any>undefined;
            this.contractTypeId = _data["contractTypeId"];
            this.fixedPriceKWh = _data["fixedPriceKWh"] ? PriceKWh.fromJS(_data["fixedPriceKWh"]) : <any>undefined;
            this.fixedPriceMonthly = _data["fixedPriceMonthly"];
            this.initialContract = _data["initialContract"];
            this.invoiceText = _data["invoiceText"];
            this.salesChannelId = _data["salesChannelId"];
            this.salesChannel = _data["salesChannel"] ? SalesChannelModel.fromJS(_data["salesChannel"]) : <any>undefined;
            this.salesDate = _data["salesDate"] ? moment(_data["salesDate"].toString()) : <any>undefined;
            this.salesPerson = _data["salesPerson"];
            this.signedFromIp = _data["signedFromIp"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(Tag.fromJS(item));
            }
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): Contract {
        data = typeof data === 'object' ? data : {};
        let result = new Contract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["elavtalId"] = this.elavtalId;
        data["contractType"] = this.contractType ? this.contractType.toJSON() : <any>undefined;
        data["contractTypeId"] = this.contractTypeId;
        data["fixedPriceKWh"] = this.fixedPriceKWh ? this.fixedPriceKWh.toJSON() : <any>undefined;
        data["fixedPriceMonthly"] = this.fixedPriceMonthly;
        data["initialContract"] = this.initialContract;
        data["invoiceText"] = this.invoiceText;
        data["salesChannelId"] = this.salesChannelId;
        data["salesChannel"] = this.salesChannel ? this.salesChannel.toJSON() : <any>undefined;
        data["salesDate"] = this.salesDate ? this.salesDate.toISOString() : <any>undefined;
        data["salesPerson"] = this.salesPerson;
        data["signedFromIp"] = this.signedFromIp;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IContract {
    id?: string;
    fromDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    elavtalId?: string;
    contractType?: ContractTypeModel;
    contractTypeId?: string;
    fixedPriceKWh?: PriceKWh;
    fixedPriceMonthly?: number | undefined;
    initialContract?: boolean;
    invoiceText?: string | undefined;
    salesChannelId?: string;
    salesChannel?: SalesChannelModel;
    salesDate?: moment.Moment | undefined;
    salesPerson?: string | undefined;
    signedFromIp?: string | undefined;
    tags?: Tag[] | undefined;
    companyId?: string;
    company?: CompanyModel;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
}

export class InvoiceDataRowModel implements IInvoiceDataRowModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    invoiceDataId?: string;
    contractId?: string | undefined;
    contract?: Contract;
    price?: number;
    quantity?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    amount?: number;
    vatAmount?: number;

    constructor(data?: IInvoiceDataRowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.invoiceDataId = _data["invoiceDataId"];
            this.contractId = _data["contractId"];
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : <any>undefined;
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.vatAmount = _data["vatAmount"];
        }
    }

    static fromJS(data: any): InvoiceDataRowModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDataRowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["invoiceDataId"] = this.invoiceDataId;
        data["contractId"] = this.contractId;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["vatAmount"] = this.vatAmount;
        return data;
    }
}

export interface IInvoiceDataRowModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    invoiceDataId?: string;
    contractId?: string | undefined;
    contract?: Contract;
    price?: number;
    quantity?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    amount?: number;
    vatAmount?: number;
}

export class InvoiceDataModel implements IInvoiceDataModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    invoiceDataStatus?: InvoiceDataStatus;
    elavtalId?: string;
    elavtal?: Elavtal;
    rows?: InvoiceDataRowModel[] | undefined;
    invoiceId?: string | undefined;
    invoice?: InvoiceModel;
    amountExkludingVat?: number;
    vatAmount?: number;
    amountIncludingVat?: number;
    consumption?: number;
    rounding?: number;
    dateOfInvoice?: moment.Moment;
    dueDate?: moment.Moment | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    finalInvoice?: boolean;
    invoicingId?: string;
    invoiceCreated?: boolean;

    constructor(data?: IInvoiceDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.invoiceDataStatus = _data["invoiceDataStatus"];
            this.elavtalId = _data["elavtalId"];
            this.elavtal = _data["elavtal"] ? Elavtal.fromJS(_data["elavtal"]) : <any>undefined;
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(InvoiceDataRowModel.fromJS(item));
            }
            this.invoiceId = _data["invoiceId"];
            this.invoice = _data["invoice"] ? InvoiceModel.fromJS(_data["invoice"]) : <any>undefined;
            this.amountExkludingVat = _data["amountExkludingVat"];
            this.vatAmount = _data["vatAmount"];
            this.amountIncludingVat = _data["amountIncludingVat"];
            this.consumption = _data["consumption"];
            this.rounding = _data["rounding"];
            this.dateOfInvoice = _data["dateOfInvoice"] ? moment(_data["dateOfInvoice"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.finalInvoice = _data["finalInvoice"];
            this.invoicingId = _data["invoicingId"];
            this.invoiceCreated = _data["invoiceCreated"];
        }
    }

    static fromJS(data: any): InvoiceDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["invoiceDataStatus"] = this.invoiceDataStatus;
        data["elavtalId"] = this.elavtalId;
        data["elavtal"] = this.elavtal ? this.elavtal.toJSON() : <any>undefined;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["invoiceId"] = this.invoiceId;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["amountExkludingVat"] = this.amountExkludingVat;
        data["vatAmount"] = this.vatAmount;
        data["amountIncludingVat"] = this.amountIncludingVat;
        data["consumption"] = this.consumption;
        data["rounding"] = this.rounding;
        data["dateOfInvoice"] = this.dateOfInvoice ? this.dateOfInvoice.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["finalInvoice"] = this.finalInvoice;
        data["invoicingId"] = this.invoicingId;
        data["invoiceCreated"] = this.invoiceCreated;
        return data;
    }
}

export interface IInvoiceDataModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    invoiceDataStatus?: InvoiceDataStatus;
    elavtalId?: string;
    elavtal?: Elavtal;
    rows?: InvoiceDataRowModel[] | undefined;
    invoiceId?: string | undefined;
    invoice?: InvoiceModel;
    amountExkludingVat?: number;
    vatAmount?: number;
    amountIncludingVat?: number;
    consumption?: number;
    rounding?: number;
    dateOfInvoice?: moment.Moment;
    dueDate?: moment.Moment | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    finalInvoice?: boolean;
    invoicingId?: string;
    invoiceCreated?: boolean;
}

export enum DeliveryMethod {
    UNKNOWN = "UNKNOWN",
    EMAIL = "EMAIL",
    SMS = "SMS",
    LETTER = "LETTER",
    EFAKTURA = "EFAKTURA",
}

export enum InvoiceStatus {
    NEW = "NEW",
    SENT = "SENT",
    SENDING = "SENDING",
}

export class InvoiceModel implements IInvoiceModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    customerId?: string | undefined;
    customer?: CustomerModel;
    paymentStatus?: PaymentStatus;
    paymentDescription?: string | undefined;
    url?: string | undefined;
    recipientUrl?: string | undefined;
    invoiceDatas?: InvoiceDataModel[] | undefined;
    invoiceNumber?: string | undefined;
    bankGiro?: string | undefined;
    ocr?: string | undefined;
    amount?: number;
    rounding?: number;
    reminderFee?: number;
    interestFee?: number;
    dateOfInvoice?: moment.Moment;
    dueDate?: moment.Moment | undefined;
    respiteDate?: moment.Moment | undefined;
    overdueNotificationSent?: boolean;
    deliveryMethod?: DeliveryMethod;
    deliveryRecipient?: string | undefined;
    rows?: InvoiceRowModel[] | undefined;
    status?: InvoiceStatus;
    invoicingId?: string;
    regardingName?: string | undefined;

    constructor(data?: IInvoiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.paymentStatus = _data["paymentStatus"];
            this.paymentDescription = _data["paymentDescription"];
            this.url = _data["url"];
            this.recipientUrl = _data["recipientUrl"];
            if (Array.isArray(_data["invoiceDatas"])) {
                this.invoiceDatas = [] as any;
                for (let item of _data["invoiceDatas"])
                    this.invoiceDatas!.push(InvoiceDataModel.fromJS(item));
            }
            this.invoiceNumber = _data["invoiceNumber"];
            this.bankGiro = _data["bankGiro"];
            this.ocr = _data["ocr"];
            this.amount = _data["amount"];
            this.rounding = _data["rounding"];
            this.reminderFee = _data["reminderFee"];
            this.interestFee = _data["interestFee"];
            this.dateOfInvoice = _data["dateOfInvoice"] ? moment(_data["dateOfInvoice"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.respiteDate = _data["respiteDate"] ? moment(_data["respiteDate"].toString()) : <any>undefined;
            this.overdueNotificationSent = _data["overdueNotificationSent"];
            this.deliveryMethod = _data["deliveryMethod"];
            this.deliveryRecipient = _data["deliveryRecipient"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(InvoiceRowModel.fromJS(item));
            }
            this.status = _data["status"];
            this.invoicingId = _data["invoicingId"];
            this.regardingName = _data["regardingName"];
        }
    }

    static fromJS(data: any): InvoiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["paymentStatus"] = this.paymentStatus;
        data["paymentDescription"] = this.paymentDescription;
        data["url"] = this.url;
        data["recipientUrl"] = this.recipientUrl;
        if (Array.isArray(this.invoiceDatas)) {
            data["invoiceDatas"] = [];
            for (let item of this.invoiceDatas)
                data["invoiceDatas"].push(item.toJSON());
        }
        data["invoiceNumber"] = this.invoiceNumber;
        data["bankGiro"] = this.bankGiro;
        data["ocr"] = this.ocr;
        data["amount"] = this.amount;
        data["rounding"] = this.rounding;
        data["reminderFee"] = this.reminderFee;
        data["interestFee"] = this.interestFee;
        data["dateOfInvoice"] = this.dateOfInvoice ? this.dateOfInvoice.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["respiteDate"] = this.respiteDate ? this.respiteDate.toISOString() : <any>undefined;
        data["overdueNotificationSent"] = this.overdueNotificationSent;
        data["deliveryMethod"] = this.deliveryMethod;
        data["deliveryRecipient"] = this.deliveryRecipient;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["invoicingId"] = this.invoicingId;
        data["regardingName"] = this.regardingName;
        return data;
    }
}

export interface IInvoiceModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    customerId?: string | undefined;
    customer?: CustomerModel;
    paymentStatus?: PaymentStatus;
    paymentDescription?: string | undefined;
    url?: string | undefined;
    recipientUrl?: string | undefined;
    invoiceDatas?: InvoiceDataModel[] | undefined;
    invoiceNumber?: string | undefined;
    bankGiro?: string | undefined;
    ocr?: string | undefined;
    amount?: number;
    rounding?: number;
    reminderFee?: number;
    interestFee?: number;
    dateOfInvoice?: moment.Moment;
    dueDate?: moment.Moment | undefined;
    respiteDate?: moment.Moment | undefined;
    overdueNotificationSent?: boolean;
    deliveryMethod?: DeliveryMethod;
    deliveryRecipient?: string | undefined;
    rows?: InvoiceRowModel[] | undefined;
    status?: InvoiceStatus;
    invoicingId?: string;
    regardingName?: string | undefined;
}

export class InvoiceRowModel implements IInvoiceRowModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    heading?: string | undefined;
    description?: string | undefined;
    unit?: string | undefined;
    quantity?: number;
    price?: number;
    amount?: number;
    vatAmount?: number;
    incomeAccount?: string | undefined;
    vatAccount?: string | undefined;
    invoiceId?: string;
    invoice?: InvoiceModel;
    invoiceDataId?: string | undefined;
    invoiceData?: InvoiceDataModel;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    accountingObjects?: AccountingObjectModel[] | undefined;
    invoiceItemId?: string | undefined;
    invoicePriceGroupId?: string | undefined;
    articleId?: string | undefined;

    constructor(data?: IInvoiceRowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.heading = _data["heading"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.amount = _data["amount"];
            this.vatAmount = _data["vatAmount"];
            this.incomeAccount = _data["incomeAccount"];
            this.vatAccount = _data["vatAccount"];
            this.invoiceId = _data["invoiceId"];
            this.invoice = _data["invoice"] ? InvoiceModel.fromJS(_data["invoice"]) : <any>undefined;
            this.invoiceDataId = _data["invoiceDataId"];
            this.invoiceData = _data["invoiceData"] ? InvoiceDataModel.fromJS(_data["invoiceData"]) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["accountingObjects"])) {
                this.accountingObjects = [] as any;
                for (let item of _data["accountingObjects"])
                    this.accountingObjects!.push(AccountingObjectModel.fromJS(item));
            }
            this.invoiceItemId = _data["invoiceItemId"];
            this.invoicePriceGroupId = _data["invoicePriceGroupId"];
            this.articleId = _data["articleId"];
        }
    }

    static fromJS(data: any): InvoiceRowModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceRowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["heading"] = this.heading;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["amount"] = this.amount;
        data["vatAmount"] = this.vatAmount;
        data["incomeAccount"] = this.incomeAccount;
        data["vatAccount"] = this.vatAccount;
        data["invoiceId"] = this.invoiceId;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["invoiceDataId"] = this.invoiceDataId;
        data["invoiceData"] = this.invoiceData ? this.invoiceData.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.accountingObjects)) {
            data["accountingObjects"] = [];
            for (let item of this.accountingObjects)
                data["accountingObjects"].push(item.toJSON());
        }
        data["invoiceItemId"] = this.invoiceItemId;
        data["invoicePriceGroupId"] = this.invoicePriceGroupId;
        data["articleId"] = this.articleId;
        return data;
    }
}

export interface IInvoiceRowModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    heading?: string | undefined;
    description?: string | undefined;
    unit?: string | undefined;
    quantity?: number;
    price?: number;
    amount?: number;
    vatAmount?: number;
    incomeAccount?: string | undefined;
    vatAccount?: string | undefined;
    invoiceId?: string;
    invoice?: InvoiceModel;
    invoiceDataId?: string | undefined;
    invoiceData?: InvoiceDataModel;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    accountingObjects?: AccountingObjectModel[] | undefined;
    invoiceItemId?: string | undefined;
    invoicePriceGroupId?: string | undefined;
    articleId?: string | undefined;
}

export class AccountingObjectModel implements IAccountingObjectModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    objectId?: number;
    name?: string | undefined;
    dimensionId?: string;
    dimension?: AccountingDimensionModel;
    deliveries?: Elavtal[] | undefined;
    invoiceRows?: InvoiceRowModel[] | undefined;
    salesChannels?: SalesChannelModel[] | undefined;

    constructor(data?: IAccountingObjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.objectId = _data["objectId"];
            this.name = _data["name"];
            this.dimensionId = _data["dimensionId"];
            this.dimension = _data["dimension"] ? AccountingDimensionModel.fromJS(_data["dimension"]) : <any>undefined;
            if (Array.isArray(_data["deliveries"])) {
                this.deliveries = [] as any;
                for (let item of _data["deliveries"])
                    this.deliveries!.push(Elavtal.fromJS(item));
            }
            if (Array.isArray(_data["invoiceRows"])) {
                this.invoiceRows = [] as any;
                for (let item of _data["invoiceRows"])
                    this.invoiceRows!.push(InvoiceRowModel.fromJS(item));
            }
            if (Array.isArray(_data["salesChannels"])) {
                this.salesChannels = [] as any;
                for (let item of _data["salesChannels"])
                    this.salesChannels!.push(SalesChannelModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountingObjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountingObjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["objectId"] = this.objectId;
        data["name"] = this.name;
        data["dimensionId"] = this.dimensionId;
        data["dimension"] = this.dimension ? this.dimension.toJSON() : <any>undefined;
        if (Array.isArray(this.deliveries)) {
            data["deliveries"] = [];
            for (let item of this.deliveries)
                data["deliveries"].push(item.toJSON());
        }
        if (Array.isArray(this.invoiceRows)) {
            data["invoiceRows"] = [];
            for (let item of this.invoiceRows)
                data["invoiceRows"].push(item.toJSON());
        }
        if (Array.isArray(this.salesChannels)) {
            data["salesChannels"] = [];
            for (let item of this.salesChannels)
                data["salesChannels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountingObjectModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    objectId?: number;
    name?: string | undefined;
    dimensionId?: string;
    dimension?: AccountingDimensionModel;
    deliveries?: Elavtal[] | undefined;
    invoiceRows?: InvoiceRowModel[] | undefined;
    salesChannels?: SalesChannelModel[] | undefined;
}

export class SalesChannelModel implements ISalesChannelModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    name?: string | undefined;
    channelIndex?: number;
    communicationTemplates?: CommunicationTemplateModel[] | undefined;
    accountingObjects?: AccountingObjectModel[] | undefined;

    constructor(data?: ISalesChannelModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.name = _data["name"];
            this.channelIndex = _data["channelIndex"];
            if (Array.isArray(_data["communicationTemplates"])) {
                this.communicationTemplates = [] as any;
                for (let item of _data["communicationTemplates"])
                    this.communicationTemplates!.push(CommunicationTemplateModel.fromJS(item));
            }
            if (Array.isArray(_data["accountingObjects"])) {
                this.accountingObjects = [] as any;
                for (let item of _data["accountingObjects"])
                    this.accountingObjects!.push(AccountingObjectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesChannelModel {
        data = typeof data === 'object' ? data : {};
        let result = new SalesChannelModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["channelIndex"] = this.channelIndex;
        if (Array.isArray(this.communicationTemplates)) {
            data["communicationTemplates"] = [];
            for (let item of this.communicationTemplates)
                data["communicationTemplates"].push(item.toJSON());
        }
        if (Array.isArray(this.accountingObjects)) {
            data["accountingObjects"] = [];
            for (let item of this.accountingObjects)
                data["accountingObjects"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISalesChannelModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    name?: string | undefined;
    channelIndex?: number;
    communicationTemplates?: CommunicationTemplateModel[] | undefined;
    accountingObjects?: AccountingObjectModel[] | undefined;
}

export class AutoCompletionTemplate implements IAutoCompletionTemplate {
    salesChannelId?: string;
    salesChannel?: SalesChannelModel;
    communicationTemplateId?: string;
    communicationTemplate?: CommunicationTemplateModel;

    constructor(data?: IAutoCompletionTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesChannelId = _data["salesChannelId"];
            this.salesChannel = _data["salesChannel"] ? SalesChannelModel.fromJS(_data["salesChannel"]) : <any>undefined;
            this.communicationTemplateId = _data["communicationTemplateId"];
            this.communicationTemplate = _data["communicationTemplate"] ? CommunicationTemplateModel.fromJS(_data["communicationTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AutoCompletionTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new AutoCompletionTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesChannelId"] = this.salesChannelId;
        data["salesChannel"] = this.salesChannel ? this.salesChannel.toJSON() : <any>undefined;
        data["communicationTemplateId"] = this.communicationTemplateId;
        data["communicationTemplate"] = this.communicationTemplate ? this.communicationTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAutoCompletionTemplate {
    salesChannelId?: string;
    salesChannel?: SalesChannelModel;
    communicationTemplateId?: string;
    communicationTemplate?: CommunicationTemplateModel;
}

export class CompanyModel implements ICompanyModel {
    callbackUrl?: string | undefined;
    handleWarrantMove?: boolean;
    handleWarrantMoveReplies?: boolean;
    handleWarrantNetOwnerReplies?: boolean;
    handleWarrantNetOwner?: boolean;
    handleWarrantSupplierReplies?: boolean;
    autoSendWarrantMail?: boolean;
    autoStartChangeProcessOnNewDeliveries?: boolean;
    autoStartChangeProcessMinDaysUntilStart?: number | undefined;
    autoStartChangeProcessMaxDaysUntilStart?: number | undefined;
    autoStartChangeProcessMinDaysAfterSales?: number | undefined;
    handleWarrantSupplier?: boolean;
    warrantMail?: string | undefined;
    warrantChangedStartDateMail?: string | undefined;
    warrantSender?: string | undefined;
    warrantCompanyName?: string | undefined;
    warrantCompanyLegalName?: string | undefined;
    warrantNetOwnerTemplateId?: string | undefined;
    warrantMoveTemplateId?: string | undefined;
    warrantChangedStartDateTemplateId?: string | undefined;
    warrantSupplierTemplateId?: string | undefined;
    warrantDailyRemainderTemplateId?: string | undefined;
    genericMailTemplateId?: string | undefined;
    useCompletionFlow?: boolean;
    completionUrl?: string | undefined;
    sendSmsFrom?: string | undefined;
    sendDeliveryStartSMS?: boolean;
    sendDeliveryHasStartedSMS?: boolean;
    sendConfirmationSMS?: boolean;
    sendElavtalsServiceSMS?: boolean;
    sendConfirmationEmail?: boolean;
    standardConfirmationMailTemplateId?: string | undefined;
    sendMailFromAdress?: string | undefined;
    sendMailFromName?: string | undefined;
    useEdiel?: boolean;
    edielId?: string | undefined;
    useEdiEncryption?: boolean;
    balanceResponsibleEdielId?: string | undefined;
    getActorinfoWhenPropertyCreated?: boolean;
    minimumAmountToCreateInvoice?: number;
    useAutomaticCompletion?: boolean;
    id?: string;
    name?: string | undefined;
    legalName?: string | undefined;
    companyId?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    modifiedBy?: string;
    createdBy?: string;
    billogramSettings?: CompanySettingsBillogramModel;
    communicationSettings!: CompanySettingsCommunicationModel;
    invoicingSettings!: CompanySettingsInvoicing;
    invoiceAttachmentSettingsId?: string | undefined;
    invoiceAttachmentSettings?: CompanySettingsInvoiceAttachmentModel;
    callbackSettings?: CompanySettingsCallback[] | undefined;
    autoCompletionTemplates?: AutoCompletionTemplate[] | undefined;

    constructor(data?: ICompanyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.communicationSettings = new CompanySettingsCommunicationModel();
            this.invoicingSettings = new CompanySettingsInvoicing();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callbackUrl = _data["callbackUrl"];
            this.handleWarrantMove = _data["handleWarrantMove"];
            this.handleWarrantMoveReplies = _data["handleWarrantMoveReplies"];
            this.handleWarrantNetOwnerReplies = _data["handleWarrantNetOwnerReplies"];
            this.handleWarrantNetOwner = _data["handleWarrantNetOwner"];
            this.handleWarrantSupplierReplies = _data["handleWarrantSupplierReplies"];
            this.autoSendWarrantMail = _data["autoSendWarrantMail"];
            this.autoStartChangeProcessOnNewDeliveries = _data["autoStartChangeProcessOnNewDeliveries"];
            this.autoStartChangeProcessMinDaysUntilStart = _data["autoStartChangeProcessMinDaysUntilStart"];
            this.autoStartChangeProcessMaxDaysUntilStart = _data["autoStartChangeProcessMaxDaysUntilStart"];
            this.autoStartChangeProcessMinDaysAfterSales = _data["autoStartChangeProcessMinDaysAfterSales"];
            this.handleWarrantSupplier = _data["handleWarrantSupplier"];
            this.warrantMail = _data["warrantMail"];
            this.warrantChangedStartDateMail = _data["warrantChangedStartDateMail"];
            this.warrantSender = _data["warrantSender"];
            this.warrantCompanyName = _data["warrantCompanyName"];
            this.warrantCompanyLegalName = _data["warrantCompanyLegalName"];
            this.warrantNetOwnerTemplateId = _data["warrantNetOwnerTemplateId"];
            this.warrantMoveTemplateId = _data["warrantMoveTemplateId"];
            this.warrantChangedStartDateTemplateId = _data["warrantChangedStartDateTemplateId"];
            this.warrantSupplierTemplateId = _data["warrantSupplierTemplateId"];
            this.warrantDailyRemainderTemplateId = _data["warrantDailyRemainderTemplateId"];
            this.genericMailTemplateId = _data["genericMailTemplateId"];
            this.useCompletionFlow = _data["useCompletionFlow"];
            this.completionUrl = _data["completionUrl"];
            this.sendSmsFrom = _data["sendSmsFrom"];
            this.sendDeliveryStartSMS = _data["sendDeliveryStartSMS"];
            this.sendDeliveryHasStartedSMS = _data["sendDeliveryHasStartedSMS"];
            this.sendConfirmationSMS = _data["sendConfirmationSMS"];
            this.sendElavtalsServiceSMS = _data["sendElavtalsServiceSMS"];
            this.sendConfirmationEmail = _data["sendConfirmationEmail"];
            this.standardConfirmationMailTemplateId = _data["standardConfirmationMailTemplateId"];
            this.sendMailFromAdress = _data["sendMailFromAdress"];
            this.sendMailFromName = _data["sendMailFromName"];
            this.useEdiel = _data["useEdiel"];
            this.edielId = _data["edielId"];
            this.useEdiEncryption = _data["useEdiEncryption"];
            this.balanceResponsibleEdielId = _data["balanceResponsibleEdielId"];
            this.getActorinfoWhenPropertyCreated = _data["getActorinfoWhenPropertyCreated"];
            this.minimumAmountToCreateInvoice = _data["minimumAmountToCreateInvoice"];
            this.useAutomaticCompletion = _data["useAutomaticCompletion"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.legalName = _data["legalName"];
            this.companyId = _data["companyId"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdBy = _data["createdBy"];
            this.billogramSettings = _data["billogramSettings"] ? CompanySettingsBillogramModel.fromJS(_data["billogramSettings"]) : <any>undefined;
            this.communicationSettings = _data["communicationSettings"] ? CompanySettingsCommunicationModel.fromJS(_data["communicationSettings"]) : new CompanySettingsCommunicationModel();
            this.invoicingSettings = _data["invoicingSettings"] ? CompanySettingsInvoicing.fromJS(_data["invoicingSettings"]) : new CompanySettingsInvoicing();
            this.invoiceAttachmentSettingsId = _data["invoiceAttachmentSettingsId"];
            this.invoiceAttachmentSettings = _data["invoiceAttachmentSettings"] ? CompanySettingsInvoiceAttachmentModel.fromJS(_data["invoiceAttachmentSettings"]) : <any>undefined;
            if (Array.isArray(_data["callbackSettings"])) {
                this.callbackSettings = [] as any;
                for (let item of _data["callbackSettings"])
                    this.callbackSettings!.push(CompanySettingsCallback.fromJS(item));
            }
            if (Array.isArray(_data["autoCompletionTemplates"])) {
                this.autoCompletionTemplates = [] as any;
                for (let item of _data["autoCompletionTemplates"])
                    this.autoCompletionTemplates!.push(AutoCompletionTemplate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callbackUrl"] = this.callbackUrl;
        data["handleWarrantMove"] = this.handleWarrantMove;
        data["handleWarrantMoveReplies"] = this.handleWarrantMoveReplies;
        data["handleWarrantNetOwnerReplies"] = this.handleWarrantNetOwnerReplies;
        data["handleWarrantNetOwner"] = this.handleWarrantNetOwner;
        data["handleWarrantSupplierReplies"] = this.handleWarrantSupplierReplies;
        data["autoSendWarrantMail"] = this.autoSendWarrantMail;
        data["autoStartChangeProcessOnNewDeliveries"] = this.autoStartChangeProcessOnNewDeliveries;
        data["autoStartChangeProcessMinDaysUntilStart"] = this.autoStartChangeProcessMinDaysUntilStart;
        data["autoStartChangeProcessMaxDaysUntilStart"] = this.autoStartChangeProcessMaxDaysUntilStart;
        data["autoStartChangeProcessMinDaysAfterSales"] = this.autoStartChangeProcessMinDaysAfterSales;
        data["handleWarrantSupplier"] = this.handleWarrantSupplier;
        data["warrantMail"] = this.warrantMail;
        data["warrantChangedStartDateMail"] = this.warrantChangedStartDateMail;
        data["warrantSender"] = this.warrantSender;
        data["warrantCompanyName"] = this.warrantCompanyName;
        data["warrantCompanyLegalName"] = this.warrantCompanyLegalName;
        data["warrantNetOwnerTemplateId"] = this.warrantNetOwnerTemplateId;
        data["warrantMoveTemplateId"] = this.warrantMoveTemplateId;
        data["warrantChangedStartDateTemplateId"] = this.warrantChangedStartDateTemplateId;
        data["warrantSupplierTemplateId"] = this.warrantSupplierTemplateId;
        data["warrantDailyRemainderTemplateId"] = this.warrantDailyRemainderTemplateId;
        data["genericMailTemplateId"] = this.genericMailTemplateId;
        data["useCompletionFlow"] = this.useCompletionFlow;
        data["completionUrl"] = this.completionUrl;
        data["sendSmsFrom"] = this.sendSmsFrom;
        data["sendDeliveryStartSMS"] = this.sendDeliveryStartSMS;
        data["sendDeliveryHasStartedSMS"] = this.sendDeliveryHasStartedSMS;
        data["sendConfirmationSMS"] = this.sendConfirmationSMS;
        data["sendElavtalsServiceSMS"] = this.sendElavtalsServiceSMS;
        data["sendConfirmationEmail"] = this.sendConfirmationEmail;
        data["standardConfirmationMailTemplateId"] = this.standardConfirmationMailTemplateId;
        data["sendMailFromAdress"] = this.sendMailFromAdress;
        data["sendMailFromName"] = this.sendMailFromName;
        data["useEdiel"] = this.useEdiel;
        data["edielId"] = this.edielId;
        data["useEdiEncryption"] = this.useEdiEncryption;
        data["balanceResponsibleEdielId"] = this.balanceResponsibleEdielId;
        data["getActorinfoWhenPropertyCreated"] = this.getActorinfoWhenPropertyCreated;
        data["minimumAmountToCreateInvoice"] = this.minimumAmountToCreateInvoice;
        data["useAutomaticCompletion"] = this.useAutomaticCompletion;
        data["id"] = this.id;
        data["name"] = this.name;
        data["legalName"] = this.legalName;
        data["companyId"] = this.companyId;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdBy"] = this.createdBy;
        data["billogramSettings"] = this.billogramSettings ? this.billogramSettings.toJSON() : <any>undefined;
        data["communicationSettings"] = this.communicationSettings ? this.communicationSettings.toJSON() : <any>undefined;
        data["invoicingSettings"] = this.invoicingSettings ? this.invoicingSettings.toJSON() : <any>undefined;
        data["invoiceAttachmentSettingsId"] = this.invoiceAttachmentSettingsId;
        data["invoiceAttachmentSettings"] = this.invoiceAttachmentSettings ? this.invoiceAttachmentSettings.toJSON() : <any>undefined;
        if (Array.isArray(this.callbackSettings)) {
            data["callbackSettings"] = [];
            for (let item of this.callbackSettings)
                data["callbackSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.autoCompletionTemplates)) {
            data["autoCompletionTemplates"] = [];
            for (let item of this.autoCompletionTemplates)
                data["autoCompletionTemplates"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompanyModel {
    callbackUrl?: string | undefined;
    handleWarrantMove?: boolean;
    handleWarrantMoveReplies?: boolean;
    handleWarrantNetOwnerReplies?: boolean;
    handleWarrantNetOwner?: boolean;
    handleWarrantSupplierReplies?: boolean;
    autoSendWarrantMail?: boolean;
    autoStartChangeProcessOnNewDeliveries?: boolean;
    autoStartChangeProcessMinDaysUntilStart?: number | undefined;
    autoStartChangeProcessMaxDaysUntilStart?: number | undefined;
    autoStartChangeProcessMinDaysAfterSales?: number | undefined;
    handleWarrantSupplier?: boolean;
    warrantMail?: string | undefined;
    warrantChangedStartDateMail?: string | undefined;
    warrantSender?: string | undefined;
    warrantCompanyName?: string | undefined;
    warrantCompanyLegalName?: string | undefined;
    warrantNetOwnerTemplateId?: string | undefined;
    warrantMoveTemplateId?: string | undefined;
    warrantChangedStartDateTemplateId?: string | undefined;
    warrantSupplierTemplateId?: string | undefined;
    warrantDailyRemainderTemplateId?: string | undefined;
    genericMailTemplateId?: string | undefined;
    useCompletionFlow?: boolean;
    completionUrl?: string | undefined;
    sendSmsFrom?: string | undefined;
    sendDeliveryStartSMS?: boolean;
    sendDeliveryHasStartedSMS?: boolean;
    sendConfirmationSMS?: boolean;
    sendElavtalsServiceSMS?: boolean;
    sendConfirmationEmail?: boolean;
    standardConfirmationMailTemplateId?: string | undefined;
    sendMailFromAdress?: string | undefined;
    sendMailFromName?: string | undefined;
    useEdiel?: boolean;
    edielId?: string | undefined;
    useEdiEncryption?: boolean;
    balanceResponsibleEdielId?: string | undefined;
    getActorinfoWhenPropertyCreated?: boolean;
    minimumAmountToCreateInvoice?: number;
    useAutomaticCompletion?: boolean;
    id?: string;
    name?: string | undefined;
    legalName?: string | undefined;
    companyId?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    modifiedBy?: string;
    createdBy?: string;
    billogramSettings?: CompanySettingsBillogramModel;
    communicationSettings: CompanySettingsCommunicationModel;
    invoicingSettings: CompanySettingsInvoicing;
    invoiceAttachmentSettingsId?: string | undefined;
    invoiceAttachmentSettings?: CompanySettingsInvoiceAttachmentModel;
    callbackSettings?: CompanySettingsCallback[] | undefined;
    autoCompletionTemplates?: AutoCompletionTemplate[] | undefined;
}

export enum EAHousing {
    APARTMENT = "APARTMENT",
    TERRACED = "TERRACED",
    HOUSE = "HOUSE",
    APPARTMENT = "APPARTMENT",
}

export class Meter implements IMeter {
    id?: string;
    externalMeterId?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    propertyId?: string;
    property?: PropertyModel;

    constructor(data?: IMeter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalMeterId = _data["externalMeterId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.propertyId = _data["propertyId"];
            this.property = _data["property"] ? PropertyModel.fromJS(_data["property"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Meter {
        data = typeof data === 'object' ? data : {};
        let result = new Meter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalMeterId"] = this.externalMeterId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["propertyId"] = this.propertyId;
        data["property"] = this.property ? this.property.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMeter {
    id?: string;
    externalMeterId?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    propertyId?: string;
    property?: PropertyModel;
}

export enum Quality {
    OK = "OK",
    ESTIMATED = "ESTIMATED",
    CALCULATED = "CALCULATED",
}

export class InvoiceDatakWhModel implements IInvoiceDatakWhModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    invoiceDataId?: string;
    contractId?: string | undefined;
    contract?: Contract;
    price?: number;
    quantity?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    amount?: number;
    vatAmount?: number;
    invoiceConsumption?: InvoiceConsumptionModel;
    invoiceConsumptionId?: string | undefined;
    originalInvoiceConsumptionId?: string | undefined;
    priceKWh?: PriceKWh;
    supplementCharge?: number;

    constructor(data?: IInvoiceDatakWhModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.invoiceDataId = _data["invoiceDataId"];
            this.contractId = _data["contractId"];
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : <any>undefined;
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.vatAmount = _data["vatAmount"];
            this.invoiceConsumption = _data["invoiceConsumption"] ? InvoiceConsumptionModel.fromJS(_data["invoiceConsumption"]) : <any>undefined;
            this.invoiceConsumptionId = _data["invoiceConsumptionId"];
            this.originalInvoiceConsumptionId = _data["originalInvoiceConsumptionId"];
            this.priceKWh = _data["priceKWh"] ? PriceKWh.fromJS(_data["priceKWh"]) : <any>undefined;
            this.supplementCharge = _data["supplementCharge"];
        }
    }

    static fromJS(data: any): InvoiceDatakWhModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDatakWhModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["invoiceDataId"] = this.invoiceDataId;
        data["contractId"] = this.contractId;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["vatAmount"] = this.vatAmount;
        data["invoiceConsumption"] = this.invoiceConsumption ? this.invoiceConsumption.toJSON() : <any>undefined;
        data["invoiceConsumptionId"] = this.invoiceConsumptionId;
        data["originalInvoiceConsumptionId"] = this.originalInvoiceConsumptionId;
        data["priceKWh"] = this.priceKWh ? this.priceKWh.toJSON() : <any>undefined;
        data["supplementCharge"] = this.supplementCharge;
        return data;
    }
}

export interface IInvoiceDatakWhModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    invoiceDataId?: string;
    contractId?: string | undefined;
    contract?: Contract;
    price?: number;
    quantity?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    amount?: number;
    vatAmount?: number;
    invoiceConsumption?: InvoiceConsumptionModel;
    invoiceConsumptionId?: string | undefined;
    originalInvoiceConsumptionId?: string | undefined;
    priceKWh?: PriceKWh;
    supplementCharge?: number;
}

export enum InvoiceConsumptionInstallationStatus {
    OPEN = "OPEN",
    CLOSED = "CLOSED",
    PARTIALLY_CLOSED = "PARTIALLY_CLOSED",
}

export class InvoiceConsumptionModel implements IInvoiceConsumptionModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    quantity?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    quality?: Quality;
    endingConsumption?: boolean;
    archived?: boolean;
    isBilled?: boolean;
    isZeroCorrection?: boolean;
    invoiceDatas?: InvoiceDatakWhModel[] | undefined;
    propertyId?: string | undefined;
    property?: PropertyModel;
    meterId?: string | undefined;
    elavtalId?: string;
    elavtal?: Elavtal;
    installationStatus?: InvoiceConsumptionInstallationStatus;
    daysWithConsumption?: number;
    latestPeriodQuantityCreated?: moment.Moment | undefined;

    constructor(data?: IInvoiceConsumptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.quality = _data["quality"];
            this.endingConsumption = _data["endingConsumption"];
            this.archived = _data["archived"];
            this.isBilled = _data["isBilled"];
            this.isZeroCorrection = _data["isZeroCorrection"];
            if (Array.isArray(_data["invoiceDatas"])) {
                this.invoiceDatas = [] as any;
                for (let item of _data["invoiceDatas"])
                    this.invoiceDatas!.push(InvoiceDatakWhModel.fromJS(item));
            }
            this.propertyId = _data["propertyId"];
            this.property = _data["property"] ? PropertyModel.fromJS(_data["property"]) : <any>undefined;
            this.meterId = _data["meterId"];
            this.elavtalId = _data["elavtalId"];
            this.elavtal = _data["elavtal"] ? Elavtal.fromJS(_data["elavtal"]) : <any>undefined;
            this.installationStatus = _data["installationStatus"];
            this.daysWithConsumption = _data["daysWithConsumption"];
            this.latestPeriodQuantityCreated = _data["latestPeriodQuantityCreated"] ? moment(_data["latestPeriodQuantityCreated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceConsumptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceConsumptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["quality"] = this.quality;
        data["endingConsumption"] = this.endingConsumption;
        data["archived"] = this.archived;
        data["isBilled"] = this.isBilled;
        data["isZeroCorrection"] = this.isZeroCorrection;
        if (Array.isArray(this.invoiceDatas)) {
            data["invoiceDatas"] = [];
            for (let item of this.invoiceDatas)
                data["invoiceDatas"].push(item.toJSON());
        }
        data["propertyId"] = this.propertyId;
        data["property"] = this.property ? this.property.toJSON() : <any>undefined;
        data["meterId"] = this.meterId;
        data["elavtalId"] = this.elavtalId;
        data["elavtal"] = this.elavtal ? this.elavtal.toJSON() : <any>undefined;
        data["installationStatus"] = this.installationStatus;
        data["daysWithConsumption"] = this.daysWithConsumption;
        data["latestPeriodQuantityCreated"] = this.latestPeriodQuantityCreated ? this.latestPeriodQuantityCreated.toISOString() : <any>undefined;
        return data;
    }
}

export interface IInvoiceConsumptionModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    quantity?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    quality?: Quality;
    endingConsumption?: boolean;
    archived?: boolean;
    isBilled?: boolean;
    isZeroCorrection?: boolean;
    invoiceDatas?: InvoiceDatakWhModel[] | undefined;
    propertyId?: string | undefined;
    property?: PropertyModel;
    meterId?: string | undefined;
    elavtalId?: string;
    elavtal?: Elavtal;
    installationStatus?: InvoiceConsumptionInstallationStatus;
    daysWithConsumption?: number;
    latestPeriodQuantityCreated?: moment.Moment | undefined;
}

export enum MeasureQuality {
    OK = "OK",
    Temporary = "Temporary",
    Non_existent = "Non_existent",
    Estimated = "Estimated",
    Incomplete = "Incomplete",
    Adjusted = "Adjusted",
    SystemEstimated = "SystemEstimated",
    Manual = "Manual",
}

export enum QuantityType {
    Consumption = "Consumption",
    Production = "Production",
}

export enum Direction {
    OUTGOING = "OUTGOING",
    INCOMING = "INCOMING",
}

export enum MarketCommunicationErrorCode {
    UNKNOWN = "UNKNOWN",
    SUPPLIER_CHANGE_NOT_FOUND = "SUPPLIER_CHANGE_NOT_FOUND",
    RETAILER_SWITCH_LOG_NOT_FOUND = "RETAILER_SWITCH_LOG_NOT_FOUND",
    RECIPIENT_NOT_FOUND = "RECIPIENT_NOT_FOUND",
    PROPERTY_NOT_FOUND = "PROPERTY_NOT_FOUND",
    COULD_NOT_CREATE_OBLIGATIONTORECIEVE = "COULD_NOT_CREATE_OBLIGATIONTORECIEVE",
    FAILED_TO_SEND_CONTRL = "FAILED_TO_SEND_CONTRL",
    FAILED_TO_SEND_APERAK = "FAILED_TO_SEND_APERAK",
    UNKNOWN_INTERCHANGE_REFERENCE = "UNKNOWN_INTERCHANGE_REFERENCE",
    SUPPLIER_CHANGE_LOG_NOT_FOUND = "SUPPLIER_CHANGE_LOG_NOT_FOUND",
    MULTIPLE_CONTRL_MESSAGES_IN_INTERCHANGE = "MULTIPLE_CONTRL_MESSAGES_IN_INTERCHANGE",
    UNSUPPORTED_PRODAT_TYPE = "UNSUPPORTED_PRODAT_TYPE",
    UNSUPPORTED_PRODAT_SUBTYPE = "UNSUPPORTED_PRODAT_SUBTYPE",
    EDILOGDETAIL_UNHANDLED = "EDILOGDETAIL_UNHANDLED",
    DELIVERY_NOT_FOUND = "DELIVERY_NOT_FOUND",
    UNSUPPORTED_MESSAGE_TYPE = "UNSUPPORTED_MESSAGE_TYPE",
    UNKNOWN_EDIEL_RECIPIENT = "UNKNOWN_EDIEL_RECIPIENT",
    MULTIPLE_PROPERTIES_FOUND = "MULTIPLE_PROPERTIES_FOUND",
    UNSUPPORTED_UTILTS_MESSAGE_TYPE = "UNSUPPORTED_UTILTS_MESSAGE_TYPE",
    UNSUPPORTED_APERAK_MESSAGE_FUNCTION = "UNSUPPORTED_APERAK_MESSAGE_FUNCTION",
    UNABLE_TO_CREATE_EDIEL_MESSAGE = "UNABLE_TO_CREATE_EDIEL_MESSAGE",
    DUPLICATE_INTERCHANGE_REFERENCE = "DUPLICATE_INTERCHANGE_REFERENCE",
    CUSTOMER_NOT_FOUND = "CUSTOMER_NOT_FOUND",
    ILLEGAL_PROPERTY_TYPE_FOR_OPERATION = "ILLEGAL_PROPERTY_TYPE_FOR_OPERATION",
    SMTP_COMMUNICATION_FAILURE = "SMTP_COMMUNICATION_FAILURE",
}

export class EdiLogDetail implements IEdiLogDetail {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    messageSubType?: string | undefined;
    referenceId?: string | undefined;
    ediLogPostId?: string;
    ediLogPost?: EdiLogPost;
    propertyId?: string | undefined;
    messageAttribute?: string | undefined;
    messageId?: string | undefined;
    messageDetailId?: string | undefined;
    aperakStatus?: boolean | undefined;
    utiltsErrStatus?: boolean | undefined;
    handled?: boolean;
    errorCode?: MarketCommunicationErrorCode;

    constructor(data?: IEdiLogDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.messageSubType = _data["messageSubType"];
            this.referenceId = _data["referenceId"];
            this.ediLogPostId = _data["ediLogPostId"];
            this.ediLogPost = _data["ediLogPost"] ? EdiLogPost.fromJS(_data["ediLogPost"]) : <any>undefined;
            this.propertyId = _data["propertyId"];
            this.messageAttribute = _data["messageAttribute"];
            this.messageId = _data["messageId"];
            this.messageDetailId = _data["messageDetailId"];
            this.aperakStatus = _data["aperakStatus"];
            this.utiltsErrStatus = _data["utiltsErrStatus"];
            this.handled = _data["handled"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): EdiLogDetail {
        data = typeof data === 'object' ? data : {};
        let result = new EdiLogDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["messageSubType"] = this.messageSubType;
        data["referenceId"] = this.referenceId;
        data["ediLogPostId"] = this.ediLogPostId;
        data["ediLogPost"] = this.ediLogPost ? this.ediLogPost.toJSON() : <any>undefined;
        data["propertyId"] = this.propertyId;
        data["messageAttribute"] = this.messageAttribute;
        data["messageId"] = this.messageId;
        data["messageDetailId"] = this.messageDetailId;
        data["aperakStatus"] = this.aperakStatus;
        data["utiltsErrStatus"] = this.utiltsErrStatus;
        data["handled"] = this.handled;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IEdiLogDetail {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    messageSubType?: string | undefined;
    referenceId?: string | undefined;
    ediLogPostId?: string;
    ediLogPost?: EdiLogPost;
    propertyId?: string | undefined;
    messageAttribute?: string | undefined;
    messageId?: string | undefined;
    messageDetailId?: string | undefined;
    aperakStatus?: boolean | undefined;
    utiltsErrStatus?: boolean | undefined;
    handled?: boolean;
    errorCode?: MarketCommunicationErrorCode;
}

export class EdiLogPost implements IEdiLogPost {
    id?: string;
    logged?: moment.Moment;
    direction?: Direction;
    dateOfPreparation?: string | undefined;
    timeOfPreparation?: string | undefined;
    interchangeReference?: string | undefined;
    messageType?: string | undefined;
    senderId?: string | undefined;
    senderEmailAddress?: string | undefined;
    recipientId?: string | undefined;
    recipientEmailAddress?: string | undefined;
    fileName?: string | undefined;
    message?: string | undefined;
    handled?: boolean;
    errorCode?: MarketCommunicationErrorCode;
    controlStatus?: boolean | undefined;
    messageSubType?: string | undefined;
    periodQuantitiesPlanned?: PeriodQuantityPlannedModel[] | undefined;
    details?: EdiLogDetail[] | undefined;

    constructor(data?: IEdiLogPost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.logged = _data["logged"] ? moment(_data["logged"].toString()) : <any>undefined;
            this.direction = _data["direction"];
            this.dateOfPreparation = _data["dateOfPreparation"];
            this.timeOfPreparation = _data["timeOfPreparation"];
            this.interchangeReference = _data["interchangeReference"];
            this.messageType = _data["messageType"];
            this.senderId = _data["senderId"];
            this.senderEmailAddress = _data["senderEmailAddress"];
            this.recipientId = _data["recipientId"];
            this.recipientEmailAddress = _data["recipientEmailAddress"];
            this.fileName = _data["fileName"];
            this.message = _data["message"];
            this.handled = _data["handled"];
            this.errorCode = _data["errorCode"];
            this.controlStatus = _data["controlStatus"];
            this.messageSubType = _data["messageSubType"];
            if (Array.isArray(_data["periodQuantitiesPlanned"])) {
                this.periodQuantitiesPlanned = [] as any;
                for (let item of _data["periodQuantitiesPlanned"])
                    this.periodQuantitiesPlanned!.push(PeriodQuantityPlannedModel.fromJS(item));
            }
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(EdiLogDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EdiLogPost {
        data = typeof data === 'object' ? data : {};
        let result = new EdiLogPost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>undefined;
        data["direction"] = this.direction;
        data["dateOfPreparation"] = this.dateOfPreparation;
        data["timeOfPreparation"] = this.timeOfPreparation;
        data["interchangeReference"] = this.interchangeReference;
        data["messageType"] = this.messageType;
        data["senderId"] = this.senderId;
        data["senderEmailAddress"] = this.senderEmailAddress;
        data["recipientId"] = this.recipientId;
        data["recipientEmailAddress"] = this.recipientEmailAddress;
        data["fileName"] = this.fileName;
        data["message"] = this.message;
        data["handled"] = this.handled;
        data["errorCode"] = this.errorCode;
        data["controlStatus"] = this.controlStatus;
        data["messageSubType"] = this.messageSubType;
        if (Array.isArray(this.periodQuantitiesPlanned)) {
            data["periodQuantitiesPlanned"] = [];
            for (let item of this.periodQuantitiesPlanned)
                data["periodQuantitiesPlanned"].push(item.toJSON());
        }
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEdiLogPost {
    id?: string;
    logged?: moment.Moment;
    direction?: Direction;
    dateOfPreparation?: string | undefined;
    timeOfPreparation?: string | undefined;
    interchangeReference?: string | undefined;
    messageType?: string | undefined;
    senderId?: string | undefined;
    senderEmailAddress?: string | undefined;
    recipientId?: string | undefined;
    recipientEmailAddress?: string | undefined;
    fileName?: string | undefined;
    message?: string | undefined;
    handled?: boolean;
    errorCode?: MarketCommunicationErrorCode;
    controlStatus?: boolean | undefined;
    messageSubType?: string | undefined;
    periodQuantitiesPlanned?: PeriodQuantityPlannedModel[] | undefined;
    details?: EdiLogDetail[] | undefined;
}

export class PeriodQuantityPlannedModel implements IPeriodQuantityPlannedModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    periodStartTime?: moment.Moment;
    periodEndTime?: moment.Moment;
    resolution?: string | undefined;
    unit?: string | undefined;
    quantity?: number;
    quality?: MeasureQuality;
    type?: QuantityType;
    transactionReference?: string | undefined;
    propertyId?: string | undefined;
    property?: PropertyModel;
    ediLogPostId?: string | undefined;
    ediLog?: EdiLogPost;

    constructor(data?: IPeriodQuantityPlannedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.periodStartTime = _data["periodStartTime"] ? moment(_data["periodStartTime"].toString()) : <any>undefined;
            this.periodEndTime = _data["periodEndTime"] ? moment(_data["periodEndTime"].toString()) : <any>undefined;
            this.resolution = _data["resolution"];
            this.unit = _data["unit"];
            this.quantity = _data["quantity"];
            this.quality = _data["quality"];
            this.type = _data["type"];
            this.transactionReference = _data["transactionReference"];
            this.propertyId = _data["propertyId"];
            this.property = _data["property"] ? PropertyModel.fromJS(_data["property"]) : <any>undefined;
            this.ediLogPostId = _data["ediLogPostId"];
            this.ediLog = _data["ediLog"] ? EdiLogPost.fromJS(_data["ediLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PeriodQuantityPlannedModel {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodQuantityPlannedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["periodStartTime"] = this.periodStartTime ? this.periodStartTime.toISOString() : <any>undefined;
        data["periodEndTime"] = this.periodEndTime ? this.periodEndTime.toISOString() : <any>undefined;
        data["resolution"] = this.resolution;
        data["unit"] = this.unit;
        data["quantity"] = this.quantity;
        data["quality"] = this.quality;
        data["type"] = this.type;
        data["transactionReference"] = this.transactionReference;
        data["propertyId"] = this.propertyId;
        data["property"] = this.property ? this.property.toJSON() : <any>undefined;
        data["ediLogPostId"] = this.ediLogPostId;
        data["ediLog"] = this.ediLog ? this.ediLog.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPeriodQuantityPlannedModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    periodStartTime?: moment.Moment;
    periodEndTime?: moment.Moment;
    resolution?: string | undefined;
    unit?: string | undefined;
    quantity?: number;
    quality?: MeasureQuality;
    type?: QuantityType;
    transactionReference?: string | undefined;
    propertyId?: string | undefined;
    property?: PropertyModel;
    ediLogPostId?: string | undefined;
    ediLog?: EdiLogPost;
}

export enum MeasureMethod {
    UNKNOWN = "UNKNOWN",
    PROFILE = "PROFILE",
    HOUR = "HOUR",
    DEFINED_BY_METERING_POINT_ADMIN = "DEFINED_BY_METERING_POINT_ADMIN",
    FIFTEEN_MINUTES = "FIFTEEN_MINUTES",
}

export enum ObservationLength {
    UNKNOWN = "UNKNOWN",
    FIFTEEN_MINUTES = "FIFTEEN_MINUTES",
    ONE_HOUR = "ONE_HOUR",
    ONE_MONTH = "ONE_MONTH",
    ONE_YEAR = "ONE_YEAR",
}

export enum SettlementMethod {
    UNKNOWN = "UNKNOWN",
    PROFILED_SETTLEMENT = "PROFILED_SETTLEMENT",
    HOURLY_BASED_SETTLEMENT = "HOURLY_BASED_SETTLEMENT",
}

export enum InstallationStatus {
    UNKNOWN = "UNKNOWN",
    CLOSED = "CLOSED",
    OPEN = "OPEN",
}

export enum MeterReadingFrequency {
    UNKNOWN = "UNKNOWN",
    DAILY = "DAILY",
    WEEKLY = "WEEKLY",
    MONTHLY = "MONTHLY",
    QUARTERLY = "QUARTERLY",
}

export enum MeterInfoOrigin {
    NET_OWNER = "NET_OWNER",
    MANUAL = "MANUAL",
}

export class MeterInfoModel implements IMeterInfoModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    timeStamp?: moment.Moment;
    lineItemReference?: string | undefined;
    meterNumber?: string | undefined;
    meterTimeframe?: string | undefined;
    productCode?: string | undefined;
    constant?: number;
    measureMethod?: MeasureMethod;
    observationLength?: ObservationLength;
    settlementMethod?: SettlementMethod;
    numberOfDigits?: number;
    status?: InstallationStatus;
    readingFrequency?: MeterReadingFrequency;
    propertyId?: string;
    property?: PropertyModel;
    origin?: MeterInfoOrigin;

    constructor(data?: IMeterInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.timeStamp = _data["timeStamp"] ? moment(_data["timeStamp"].toString()) : <any>undefined;
            this.lineItemReference = _data["lineItemReference"];
            this.meterNumber = _data["meterNumber"];
            this.meterTimeframe = _data["meterTimeframe"];
            this.productCode = _data["productCode"];
            this.constant = _data["constant"];
            this.measureMethod = _data["measureMethod"];
            this.observationLength = _data["observationLength"];
            this.settlementMethod = _data["settlementMethod"];
            this.numberOfDigits = _data["numberOfDigits"];
            this.status = _data["status"];
            this.readingFrequency = _data["readingFrequency"];
            this.propertyId = _data["propertyId"];
            this.property = _data["property"] ? PropertyModel.fromJS(_data["property"]) : <any>undefined;
            this.origin = _data["origin"];
        }
    }

    static fromJS(data: any): MeterInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new MeterInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["lineItemReference"] = this.lineItemReference;
        data["meterNumber"] = this.meterNumber;
        data["meterTimeframe"] = this.meterTimeframe;
        data["productCode"] = this.productCode;
        data["constant"] = this.constant;
        data["measureMethod"] = this.measureMethod;
        data["observationLength"] = this.observationLength;
        data["settlementMethod"] = this.settlementMethod;
        data["numberOfDigits"] = this.numberOfDigits;
        data["status"] = this.status;
        data["readingFrequency"] = this.readingFrequency;
        data["propertyId"] = this.propertyId;
        data["property"] = this.property ? this.property.toJSON() : <any>undefined;
        data["origin"] = this.origin;
        return data;
    }
}

export interface IMeterInfoModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    timeStamp?: moment.Moment;
    lineItemReference?: string | undefined;
    meterNumber?: string | undefined;
    meterTimeframe?: string | undefined;
    productCode?: string | undefined;
    constant?: number;
    measureMethod?: MeasureMethod;
    observationLength?: ObservationLength;
    settlementMethod?: SettlementMethod;
    numberOfDigits?: number;
    status?: InstallationStatus;
    readingFrequency?: MeterReadingFrequency;
    propertyId?: string;
    property?: PropertyModel;
    origin?: MeterInfoOrigin;
}

export enum PropertyEventType {
    UNDEFINED = "UNDEFINED",
    METER_OPENED = "METER_OPENED",
    METER_CLOSED = "METER_CLOSED",
    METER_CHANGED = "METER_CHANGED",
    METERINFO_UPDATED = "METERINFO_UPDATED",
    PROPERTY_ADDRESS_UPDATED = "PROPERTY_ADDRESS_UPDATED",
    MEASURING_METHOD_UPDATED = "MEASURING_METHOD_UPDATED",
    SETTLEMENT_METHOD_UPDATED = "SETTLEMENT_METHOD_UPDATED",
}

export class PropertyEventModel implements IPropertyEventModel {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    eventType?: PropertyEventType;
    timestamp?: moment.Moment;
    propertyId?: string;
    property?: PropertyModel;

    constructor(data?: IPropertyEventModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.eventType = _data["eventType"];
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
            this.propertyId = _data["propertyId"];
            this.property = _data["property"] ? PropertyModel.fromJS(_data["property"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyEventModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyEventModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["eventType"] = this.eventType;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["propertyId"] = this.propertyId;
        data["property"] = this.property ? this.property.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyEventModel {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    eventType?: PropertyEventType;
    timestamp?: moment.Moment;
    propertyId?: string;
    property?: PropertyModel;
}

export class MissingPeriodModel implements IMissingPeriodModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    propertyId?: string;
    startTime?: moment.Moment;
    endTime?: moment.Moment;

    constructor(data?: IMissingPeriodModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.propertyId = _data["propertyId"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MissingPeriodModel {
        data = typeof data === 'object' ? data : {};
        let result = new MissingPeriodModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["propertyId"] = this.propertyId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMissingPeriodModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    propertyId?: string;
    startTime?: moment.Moment;
    endTime?: moment.Moment;
}

export enum PropertyStatus {
    DRAFT = "DRAFT",
    CONFIRMED = "CONFIRMED",
    ARCHIVED = "ARCHIVED",
}

export enum NetActorType {
    NetOwner = "NetOwner",
    Supplier = "Supplier",
}

export class NetOwner implements INetOwner {
    type?: NetActorType;
    phoneNumberCustomerSupportMove?: string | undefined;
    id?: string;
    name?: string | undefined;
    edielId?: string | undefined;
    prodatCommunicationAddress?: string | undefined;
    prodatSubAddress?: string | undefined;
    prodatInterchangePartyId?: string | undefined;
    utiltsCommunicationAddress?: string | undefined;
    utiltsSubAddress?: string | undefined;
    utiltsInterchangePartyId?: string | undefined;
    warrantEmail?: string | undefined;
    warrantEmailManual?: string | undefined;
    phoneNumberCustomerSupport?: string | undefined;
    createdOn?: moment.Moment;
    modifiedOn?: moment.Moment;
    digitalIdRequired?: boolean | undefined;

    constructor(data?: INetOwner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.phoneNumberCustomerSupportMove = _data["phoneNumberCustomerSupportMove"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.edielId = _data["edielId"];
            this.prodatCommunicationAddress = _data["prodatCommunicationAddress"];
            this.prodatSubAddress = _data["prodatSubAddress"];
            this.prodatInterchangePartyId = _data["prodatInterchangePartyId"];
            this.utiltsCommunicationAddress = _data["utiltsCommunicationAddress"];
            this.utiltsSubAddress = _data["utiltsSubAddress"];
            this.utiltsInterchangePartyId = _data["utiltsInterchangePartyId"];
            this.warrantEmail = _data["warrantEmail"];
            this.warrantEmailManual = _data["warrantEmailManual"];
            this.phoneNumberCustomerSupport = _data["phoneNumberCustomerSupport"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.digitalIdRequired = _data["digitalIdRequired"];
        }
    }

    static fromJS(data: any): NetOwner {
        data = typeof data === 'object' ? data : {};
        let result = new NetOwner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["phoneNumberCustomerSupportMove"] = this.phoneNumberCustomerSupportMove;
        data["id"] = this.id;
        data["name"] = this.name;
        data["edielId"] = this.edielId;
        data["prodatCommunicationAddress"] = this.prodatCommunicationAddress;
        data["prodatSubAddress"] = this.prodatSubAddress;
        data["prodatInterchangePartyId"] = this.prodatInterchangePartyId;
        data["utiltsCommunicationAddress"] = this.utiltsCommunicationAddress;
        data["utiltsSubAddress"] = this.utiltsSubAddress;
        data["utiltsInterchangePartyId"] = this.utiltsInterchangePartyId;
        data["warrantEmail"] = this.warrantEmail;
        data["warrantEmailManual"] = this.warrantEmailManual;
        data["phoneNumberCustomerSupport"] = this.phoneNumberCustomerSupport;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["digitalIdRequired"] = this.digitalIdRequired;
        return data;
    }
}

export interface INetOwner {
    type?: NetActorType;
    phoneNumberCustomerSupportMove?: string | undefined;
    id?: string;
    name?: string | undefined;
    edielId?: string | undefined;
    prodatCommunicationAddress?: string | undefined;
    prodatSubAddress?: string | undefined;
    prodatInterchangePartyId?: string | undefined;
    utiltsCommunicationAddress?: string | undefined;
    utiltsSubAddress?: string | undefined;
    utiltsInterchangePartyId?: string | undefined;
    warrantEmail?: string | undefined;
    warrantEmailManual?: string | undefined;
    phoneNumberCustomerSupport?: string | undefined;
    createdOn?: moment.Moment;
    modifiedOn?: moment.Moment;
    digitalIdRequired?: boolean | undefined;
}

export class AggregatedQuantityModel implements IAggregatedQuantityModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    planned?: boolean;
    periodStartTime?: moment.Moment;
    periodEndTime?: moment.Moment;
    resolution?: string | undefined;
    unit?: string | undefined;
    quantity?: number;
    type?: QuantityType;
    transactionReference?: string | undefined;
    numberOfMeasuringPoints?: number;
    productCharacteristic?: string | undefined;
    productType?: string | undefined;
    identityType?: string | undefined;
    levelOfDetails?: string | undefined;
    businessActivityPhase?: string | undefined;
    netAreaId?: string | undefined;
    netArea?: NetArea;
    ediLogPostId?: string | undefined;
    ediLog?: EdiLogPost;

    constructor(data?: IAggregatedQuantityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.planned = _data["planned"];
            this.periodStartTime = _data["periodStartTime"] ? moment(_data["periodStartTime"].toString()) : <any>undefined;
            this.periodEndTime = _data["periodEndTime"] ? moment(_data["periodEndTime"].toString()) : <any>undefined;
            this.resolution = _data["resolution"];
            this.unit = _data["unit"];
            this.quantity = _data["quantity"];
            this.type = _data["type"];
            this.transactionReference = _data["transactionReference"];
            this.numberOfMeasuringPoints = _data["numberOfMeasuringPoints"];
            this.productCharacteristic = _data["productCharacteristic"];
            this.productType = _data["productType"];
            this.identityType = _data["identityType"];
            this.levelOfDetails = _data["levelOfDetails"];
            this.businessActivityPhase = _data["businessActivityPhase"];
            this.netAreaId = _data["netAreaId"];
            this.netArea = _data["netArea"] ? NetArea.fromJS(_data["netArea"]) : <any>undefined;
            this.ediLogPostId = _data["ediLogPostId"];
            this.ediLog = _data["ediLog"] ? EdiLogPost.fromJS(_data["ediLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AggregatedQuantityModel {
        data = typeof data === 'object' ? data : {};
        let result = new AggregatedQuantityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["planned"] = this.planned;
        data["periodStartTime"] = this.periodStartTime ? this.periodStartTime.toISOString() : <any>undefined;
        data["periodEndTime"] = this.periodEndTime ? this.periodEndTime.toISOString() : <any>undefined;
        data["resolution"] = this.resolution;
        data["unit"] = this.unit;
        data["quantity"] = this.quantity;
        data["type"] = this.type;
        data["transactionReference"] = this.transactionReference;
        data["numberOfMeasuringPoints"] = this.numberOfMeasuringPoints;
        data["productCharacteristic"] = this.productCharacteristic;
        data["productType"] = this.productType;
        data["identityType"] = this.identityType;
        data["levelOfDetails"] = this.levelOfDetails;
        data["businessActivityPhase"] = this.businessActivityPhase;
        data["netAreaId"] = this.netAreaId;
        data["netArea"] = this.netArea ? this.netArea.toJSON() : <any>undefined;
        data["ediLogPostId"] = this.ediLogPostId;
        data["ediLog"] = this.ediLog ? this.ediLog.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAggregatedQuantityModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    planned?: boolean;
    periodStartTime?: moment.Moment;
    periodEndTime?: moment.Moment;
    resolution?: string | undefined;
    unit?: string | undefined;
    quantity?: number;
    type?: QuantityType;
    transactionReference?: string | undefined;
    numberOfMeasuringPoints?: number;
    productCharacteristic?: string | undefined;
    productType?: string | undefined;
    identityType?: string | undefined;
    levelOfDetails?: string | undefined;
    businessActivityPhase?: string | undefined;
    netAreaId?: string | undefined;
    netArea?: NetArea;
    ediLogPostId?: string | undefined;
    ediLog?: EdiLogPost;
}

export class NetArea implements INetArea {
    id?: string;
    name?: string | undefined;
    code?: string | undefined;
    electricityArea?: number;
    netOwnerId?: string;
    netOwner?: NetOwner;
    aggregatedQuantities?: AggregatedQuantityModel[] | undefined;

    constructor(data?: INetArea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.electricityArea = _data["electricityArea"];
            this.netOwnerId = _data["netOwnerId"];
            this.netOwner = _data["netOwner"] ? NetOwner.fromJS(_data["netOwner"]) : <any>undefined;
            if (Array.isArray(_data["aggregatedQuantities"])) {
                this.aggregatedQuantities = [] as any;
                for (let item of _data["aggregatedQuantities"])
                    this.aggregatedQuantities!.push(AggregatedQuantityModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NetArea {
        data = typeof data === 'object' ? data : {};
        let result = new NetArea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["electricityArea"] = this.electricityArea;
        data["netOwnerId"] = this.netOwnerId;
        data["netOwner"] = this.netOwner ? this.netOwner.toJSON() : <any>undefined;
        if (Array.isArray(this.aggregatedQuantities)) {
            data["aggregatedQuantities"] = [];
            for (let item of this.aggregatedQuantities)
                data["aggregatedQuantities"].push(item.toJSON());
        }
        return data;
    }
}

export interface INetArea {
    id?: string;
    name?: string | undefined;
    code?: string | undefined;
    electricityArea?: number;
    netOwnerId?: string;
    netOwner?: NetOwner;
    aggregatedQuantities?: AggregatedQuantityModel[] | undefined;
}

export class PropertyModel implements IPropertyModel {
    ean?: string | undefined;
    street?: string | undefined;
    publicStreet?: string | undefined;
    lmvNumber?: string | undefined;
    internalPropertyNumber?: string | undefined;
    propertyOwner?: string | undefined;
    housingCooperative?: string | undefined;
    area?: number;
    zipCode?: string | undefined;
    city?: string | undefined;
    consumption?: number;
    housing?: EAHousing;
    netAreaId?: string | undefined;
    meter?: Meter[] | undefined;
    invoiceConsumption?: InvoiceConsumptionModel[] | undefined;
    periodQuantitiesPlanned?: PeriodQuantityPlannedModel[] | undefined;
    meterInfo?: MeterInfoModel[] | undefined;
    propertyEvents?: PropertyEventModel[] | undefined;
    missingPeriods?: MissingPeriodModel[] | undefined;
    hasMissingQuantities?: boolean;
    lastCheckedForMissingQuantities?: moment.Moment;
    externalId?: string | undefined;
    status?: PropertyStatus;
    type?: PropertyType;
    connectedConsumingPropertyId?: string | undefined;
    id?: string;
    netArea?: NetArea;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    modifiedBy?: string;
    createdBy?: string;
    companyId?: string;
    company?: CompanyModel;
    entityType?: string | undefined;
    deleted?: boolean;
    searchData?: string | undefined;
    entityData?: string | undefined;

    constructor(data?: IPropertyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ean = _data["ean"];
            this.street = _data["street"];
            this.publicStreet = _data["publicStreet"];
            this.lmvNumber = _data["lmvNumber"];
            this.internalPropertyNumber = _data["internalPropertyNumber"];
            this.propertyOwner = _data["propertyOwner"];
            this.housingCooperative = _data["housingCooperative"];
            this.area = _data["area"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.consumption = _data["consumption"];
            this.housing = _data["housing"];
            this.netAreaId = _data["netAreaId"];
            if (Array.isArray(_data["meter"])) {
                this.meter = [] as any;
                for (let item of _data["meter"])
                    this.meter!.push(Meter.fromJS(item));
            }
            if (Array.isArray(_data["invoiceConsumption"])) {
                this.invoiceConsumption = [] as any;
                for (let item of _data["invoiceConsumption"])
                    this.invoiceConsumption!.push(InvoiceConsumptionModel.fromJS(item));
            }
            if (Array.isArray(_data["periodQuantitiesPlanned"])) {
                this.periodQuantitiesPlanned = [] as any;
                for (let item of _data["periodQuantitiesPlanned"])
                    this.periodQuantitiesPlanned!.push(PeriodQuantityPlannedModel.fromJS(item));
            }
            if (Array.isArray(_data["meterInfo"])) {
                this.meterInfo = [] as any;
                for (let item of _data["meterInfo"])
                    this.meterInfo!.push(MeterInfoModel.fromJS(item));
            }
            if (Array.isArray(_data["propertyEvents"])) {
                this.propertyEvents = [] as any;
                for (let item of _data["propertyEvents"])
                    this.propertyEvents!.push(PropertyEventModel.fromJS(item));
            }
            if (Array.isArray(_data["missingPeriods"])) {
                this.missingPeriods = [] as any;
                for (let item of _data["missingPeriods"])
                    this.missingPeriods!.push(MissingPeriodModel.fromJS(item));
            }
            this.hasMissingQuantities = _data["hasMissingQuantities"];
            this.lastCheckedForMissingQuantities = _data["lastCheckedForMissingQuantities"] ? moment(_data["lastCheckedForMissingQuantities"].toString()) : <any>undefined;
            this.externalId = _data["externalId"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.connectedConsumingPropertyId = _data["connectedConsumingPropertyId"];
            this.id = _data["id"];
            this.netArea = _data["netArea"] ? NetArea.fromJS(_data["netArea"]) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdBy = _data["createdBy"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.entityType = _data["entityType"];
            this.deleted = _data["deleted"];
            this.searchData = _data["searchData"];
            this.entityData = _data["entityData"];
        }
    }

    static fromJS(data: any): PropertyModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ean"] = this.ean;
        data["street"] = this.street;
        data["publicStreet"] = this.publicStreet;
        data["lmvNumber"] = this.lmvNumber;
        data["internalPropertyNumber"] = this.internalPropertyNumber;
        data["propertyOwner"] = this.propertyOwner;
        data["housingCooperative"] = this.housingCooperative;
        data["area"] = this.area;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["consumption"] = this.consumption;
        data["housing"] = this.housing;
        data["netAreaId"] = this.netAreaId;
        if (Array.isArray(this.meter)) {
            data["meter"] = [];
            for (let item of this.meter)
                data["meter"].push(item.toJSON());
        }
        if (Array.isArray(this.invoiceConsumption)) {
            data["invoiceConsumption"] = [];
            for (let item of this.invoiceConsumption)
                data["invoiceConsumption"].push(item.toJSON());
        }
        if (Array.isArray(this.periodQuantitiesPlanned)) {
            data["periodQuantitiesPlanned"] = [];
            for (let item of this.periodQuantitiesPlanned)
                data["periodQuantitiesPlanned"].push(item.toJSON());
        }
        if (Array.isArray(this.meterInfo)) {
            data["meterInfo"] = [];
            for (let item of this.meterInfo)
                data["meterInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.propertyEvents)) {
            data["propertyEvents"] = [];
            for (let item of this.propertyEvents)
                data["propertyEvents"].push(item.toJSON());
        }
        if (Array.isArray(this.missingPeriods)) {
            data["missingPeriods"] = [];
            for (let item of this.missingPeriods)
                data["missingPeriods"].push(item.toJSON());
        }
        data["hasMissingQuantities"] = this.hasMissingQuantities;
        data["lastCheckedForMissingQuantities"] = this.lastCheckedForMissingQuantities ? this.lastCheckedForMissingQuantities.toISOString() : <any>undefined;
        data["externalId"] = this.externalId;
        data["status"] = this.status;
        data["type"] = this.type;
        data["connectedConsumingPropertyId"] = this.connectedConsumingPropertyId;
        data["id"] = this.id;
        data["netArea"] = this.netArea ? this.netArea.toJSON() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdBy"] = this.createdBy;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["deleted"] = this.deleted;
        data["searchData"] = this.searchData;
        data["entityData"] = this.entityData;
        return data;
    }
}

export interface IPropertyModel {
    ean?: string | undefined;
    street?: string | undefined;
    publicStreet?: string | undefined;
    lmvNumber?: string | undefined;
    internalPropertyNumber?: string | undefined;
    propertyOwner?: string | undefined;
    housingCooperative?: string | undefined;
    area?: number;
    zipCode?: string | undefined;
    city?: string | undefined;
    consumption?: number;
    housing?: EAHousing;
    netAreaId?: string | undefined;
    meter?: Meter[] | undefined;
    invoiceConsumption?: InvoiceConsumptionModel[] | undefined;
    periodQuantitiesPlanned?: PeriodQuantityPlannedModel[] | undefined;
    meterInfo?: MeterInfoModel[] | undefined;
    propertyEvents?: PropertyEventModel[] | undefined;
    missingPeriods?: MissingPeriodModel[] | undefined;
    hasMissingQuantities?: boolean;
    lastCheckedForMissingQuantities?: moment.Moment;
    externalId?: string | undefined;
    status?: PropertyStatus;
    type?: PropertyType;
    connectedConsumingPropertyId?: string | undefined;
    id?: string;
    netArea?: NetArea;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    modifiedBy?: string;
    createdBy?: string;
    companyId?: string;
    company?: CompanyModel;
    entityType?: string | undefined;
    deleted?: boolean;
    searchData?: string | undefined;
    entityData?: string | undefined;
}

export enum Elavtalsstatus {
    Ny = "Ny",
    KlarForFullmakt = "KlarForFullmakt",
    FullmaktPagar = "FullmaktPagar",
    KlarForLevbyte = "KlarForLevbyte",
    LevbytePagar = "LevbytePagar",
    LevbyteKlart = "LevbyteKlart",
    LeveransPagar = "LeveransPagar",
    Avbruten = "Avbruten",
    KompletteringPagar = "KompletteringPagar",
    KlarForKomplettering = "KlarForKomplettering",
    KlarForAvtalsService = "KlarForAvtalsService",
    AvtalsServicePagar = "AvtalsServicePagar",
    LeveransAvslutad = "LeveransAvslutad",
    KlarForLevFullmakt = "KlarForLevFullmakt",
    LevFullmaktPagar = "LevFullmaktPagar",
    FullmaktUppskjuten = "FullmaktUppskjuten",
}

export enum TypedTagType {
    REASON_FOR_TERMINATION = "REASON_FOR_TERMINATION",
}

export class TypedTagModel implements ITypedTagModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string | undefined;
    company?: CompanyModel;
    name?: string | undefined;
    parentTagId?: string | undefined;
    parentTag?: TypedTagModel;
    type?: TypedTagType;

    constructor(data?: ITypedTagModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.name = _data["name"];
            this.parentTagId = _data["parentTagId"];
            this.parentTag = _data["parentTag"] ? TypedTagModel.fromJS(_data["parentTag"]) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): TypedTagModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedTagModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["parentTagId"] = this.parentTagId;
        data["parentTag"] = this.parentTag ? this.parentTag.toJSON() : <any>undefined;
        data["type"] = this.type;
        return data;
    }
}

export interface ITypedTagModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string | undefined;
    company?: CompanyModel;
    name?: string | undefined;
    parentTagId?: string | undefined;
    parentTag?: TypedTagModel;
    type?: TypedTagType;
}

export class FileModel implements IFileModel {
    id?: string;
    createdOn?: moment.Moment;
    fileName?: string | undefined;
    contentType?: string | undefined;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdBy?: string;
    companyId?: string;
    url?: string | undefined;

    constructor(data?: IFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdBy = _data["createdBy"];
            this.companyId = _data["companyId"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): FileModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdBy"] = this.createdBy;
        data["companyId"] = this.companyId;
        data["url"] = this.url;
        return data;
    }
}

export interface IFileModel {
    id?: string;
    createdOn?: moment.Moment;
    fileName?: string | undefined;
    contentType?: string | undefined;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdBy?: string;
    companyId?: string;
    url?: string | undefined;
}

export class Supplier implements ISupplier {
    type?: NetActorType;
    id?: string;
    name?: string | undefined;
    edielId?: string | undefined;
    prodatCommunicationAddress?: string | undefined;
    prodatSubAddress?: string | undefined;
    prodatInterchangePartyId?: string | undefined;
    utiltsCommunicationAddress?: string | undefined;
    utiltsSubAddress?: string | undefined;
    utiltsInterchangePartyId?: string | undefined;
    warrantEmail?: string | undefined;
    warrantEmailManual?: string | undefined;
    phoneNumberCustomerSupport?: string | undefined;
    createdOn?: moment.Moment;
    modifiedOn?: moment.Moment;
    digitalIdRequired?: boolean | undefined;

    constructor(data?: ISupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.edielId = _data["edielId"];
            this.prodatCommunicationAddress = _data["prodatCommunicationAddress"];
            this.prodatSubAddress = _data["prodatSubAddress"];
            this.prodatInterchangePartyId = _data["prodatInterchangePartyId"];
            this.utiltsCommunicationAddress = _data["utiltsCommunicationAddress"];
            this.utiltsSubAddress = _data["utiltsSubAddress"];
            this.utiltsInterchangePartyId = _data["utiltsInterchangePartyId"];
            this.warrantEmail = _data["warrantEmail"];
            this.warrantEmailManual = _data["warrantEmailManual"];
            this.phoneNumberCustomerSupport = _data["phoneNumberCustomerSupport"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.digitalIdRequired = _data["digitalIdRequired"];
        }
    }

    static fromJS(data: any): Supplier {
        data = typeof data === 'object' ? data : {};
        let result = new Supplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        data["name"] = this.name;
        data["edielId"] = this.edielId;
        data["prodatCommunicationAddress"] = this.prodatCommunicationAddress;
        data["prodatSubAddress"] = this.prodatSubAddress;
        data["prodatInterchangePartyId"] = this.prodatInterchangePartyId;
        data["utiltsCommunicationAddress"] = this.utiltsCommunicationAddress;
        data["utiltsSubAddress"] = this.utiltsSubAddress;
        data["utiltsInterchangePartyId"] = this.utiltsInterchangePartyId;
        data["warrantEmail"] = this.warrantEmail;
        data["warrantEmailManual"] = this.warrantEmailManual;
        data["phoneNumberCustomerSupport"] = this.phoneNumberCustomerSupport;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["digitalIdRequired"] = this.digitalIdRequired;
        return data;
    }
}

export interface ISupplier {
    type?: NetActorType;
    id?: string;
    name?: string | undefined;
    edielId?: string | undefined;
    prodatCommunicationAddress?: string | undefined;
    prodatSubAddress?: string | undefined;
    prodatInterchangePartyId?: string | undefined;
    utiltsCommunicationAddress?: string | undefined;
    utiltsSubAddress?: string | undefined;
    utiltsInterchangePartyId?: string | undefined;
    warrantEmail?: string | undefined;
    warrantEmailManual?: string | undefined;
    phoneNumberCustomerSupport?: string | undefined;
    createdOn?: moment.Moment;
    modifiedOn?: moment.Moment;
    digitalIdRequired?: boolean | undefined;
}

export class ElavtalBillogramExtensionsBanner implements IElavtalBillogramExtensionsBanner {
    id?: string;
    bannerId?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;

    constructor(data?: IElavtalBillogramExtensionsBanner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bannerId = _data["bannerId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ElavtalBillogramExtensionsBanner {
        data = typeof data === 'object' ? data : {};
        let result = new ElavtalBillogramExtensionsBanner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bannerId"] = this.bannerId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IElavtalBillogramExtensionsBanner {
    id?: string;
    bannerId?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
}

export class ElavtalBillogramExtensions implements IElavtalBillogramExtensions {
    id?: string;
    elavtalId?: string;
    banners?: ElavtalBillogramExtensionsBanner[] | undefined;

    constructor(data?: IElavtalBillogramExtensions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.elavtalId = _data["elavtalId"];
            if (Array.isArray(_data["banners"])) {
                this.banners = [] as any;
                for (let item of _data["banners"])
                    this.banners!.push(ElavtalBillogramExtensionsBanner.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElavtalBillogramExtensions {
        data = typeof data === 'object' ? data : {};
        let result = new ElavtalBillogramExtensions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["elavtalId"] = this.elavtalId;
        if (Array.isArray(this.banners)) {
            data["banners"] = [];
            for (let item of this.banners)
                data["banners"].push(item.toJSON());
        }
        return data;
    }
}

export interface IElavtalBillogramExtensions {
    id?: string;
    elavtalId?: string;
    banners?: ElavtalBillogramExtensionsBanner[] | undefined;
}

export class InvoiceDataItemModel implements IInvoiceDataItemModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    invoiceDataId?: string;
    contractId?: string | undefined;
    contract?: Contract;
    price?: number;
    quantity?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    amount?: number;
    vatAmount?: number;
    invoiceItem?: InvoiceItemModel;
    invoiceItemId?: string | undefined;

    constructor(data?: IInvoiceDataItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.invoiceDataId = _data["invoiceDataId"];
            this.contractId = _data["contractId"];
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : <any>undefined;
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.vatAmount = _data["vatAmount"];
            this.invoiceItem = _data["invoiceItem"] ? InvoiceItemModel.fromJS(_data["invoiceItem"]) : <any>undefined;
            this.invoiceItemId = _data["invoiceItemId"];
        }
    }

    static fromJS(data: any): InvoiceDataItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDataItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["invoiceDataId"] = this.invoiceDataId;
        data["contractId"] = this.contractId;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["vatAmount"] = this.vatAmount;
        data["invoiceItem"] = this.invoiceItem ? this.invoiceItem.toJSON() : <any>undefined;
        data["invoiceItemId"] = this.invoiceItemId;
        return data;
    }
}

export interface IInvoiceDataItemModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    invoiceDataId?: string;
    contractId?: string | undefined;
    contract?: Contract;
    price?: number;
    quantity?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    amount?: number;
    vatAmount?: number;
    invoiceItem?: InvoiceItemModel;
    invoiceItemId?: string | undefined;
}

export enum ArticleUnit {
    DAY = "DAY",
    MONTH = "MONTH",
    YEAR = "YEAR",
    KWH = "KWH",
}

export class ArticleModel implements IArticleModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    name?: string | undefined;
    description?: string | undefined;
    price?: number;
    incomeAccount?: string | undefined;
    vatAccount?: string | undefined;
    vat?: boolean;
    unit?: ArticleUnit;
    systemArticle?: boolean;
    excludeAccountingObjects?: boolean;

    constructor(data?: IArticleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.incomeAccount = _data["incomeAccount"];
            this.vatAccount = _data["vatAccount"];
            this.vat = _data["vat"];
            this.unit = _data["unit"];
            this.systemArticle = _data["systemArticle"];
            this.excludeAccountingObjects = _data["excludeAccountingObjects"];
        }
    }

    static fromJS(data: any): ArticleModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["incomeAccount"] = this.incomeAccount;
        data["vatAccount"] = this.vatAccount;
        data["vat"] = this.vat;
        data["unit"] = this.unit;
        data["systemArticle"] = this.systemArticle;
        data["excludeAccountingObjects"] = this.excludeAccountingObjects;
        return data;
    }
}

export interface IArticleModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    name?: string | undefined;
    description?: string | undefined;
    price?: number;
    incomeAccount?: string | undefined;
    vatAccount?: string | undefined;
    vat?: boolean;
    unit?: ArticleUnit;
    systemArticle?: boolean;
    excludeAccountingObjects?: boolean;
}

export class InvoiceItemModel implements IInvoiceItemModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    name?: string | undefined;
    description?: string | undefined;
    vat?: boolean;
    price?: number;
    quantity?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    isBilled?: boolean;
    incomeAccount?: string | undefined;
    vatAccount?: string | undefined;
    invoiceDatas?: InvoiceDataItemModel[] | undefined;
    customerId?: string;
    customer?: CustomerModel;
    propertyId?: string | undefined;
    property?: PropertyModel;
    elavtalId?: string | undefined;
    elavtal?: Elavtal;
    articleId?: string | undefined;
    article?: ArticleModel;

    constructor(data?: IInvoiceItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.vat = _data["vat"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.isBilled = _data["isBilled"];
            this.incomeAccount = _data["incomeAccount"];
            this.vatAccount = _data["vatAccount"];
            if (Array.isArray(_data["invoiceDatas"])) {
                this.invoiceDatas = [] as any;
                for (let item of _data["invoiceDatas"])
                    this.invoiceDatas!.push(InvoiceDataItemModel.fromJS(item));
            }
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.propertyId = _data["propertyId"];
            this.property = _data["property"] ? PropertyModel.fromJS(_data["property"]) : <any>undefined;
            this.elavtalId = _data["elavtalId"];
            this.elavtal = _data["elavtal"] ? Elavtal.fromJS(_data["elavtal"]) : <any>undefined;
            this.articleId = _data["articleId"];
            this.article = _data["article"] ? ArticleModel.fromJS(_data["article"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["vat"] = this.vat;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isBilled"] = this.isBilled;
        data["incomeAccount"] = this.incomeAccount;
        data["vatAccount"] = this.vatAccount;
        if (Array.isArray(this.invoiceDatas)) {
            data["invoiceDatas"] = [];
            for (let item of this.invoiceDatas)
                data["invoiceDatas"].push(item.toJSON());
        }
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["propertyId"] = this.propertyId;
        data["property"] = this.property ? this.property.toJSON() : <any>undefined;
        data["elavtalId"] = this.elavtalId;
        data["elavtal"] = this.elavtal ? this.elavtal.toJSON() : <any>undefined;
        data["articleId"] = this.articleId;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvoiceItemModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    name?: string | undefined;
    description?: string | undefined;
    vat?: boolean;
    price?: number;
    quantity?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    isBilled?: boolean;
    incomeAccount?: string | undefined;
    vatAccount?: string | undefined;
    invoiceDatas?: InvoiceDataItemModel[] | undefined;
    customerId?: string;
    customer?: CustomerModel;
    propertyId?: string | undefined;
    property?: PropertyModel;
    elavtalId?: string | undefined;
    elavtal?: Elavtal;
    articleId?: string | undefined;
    article?: ArticleModel;
}

export class ContactTypeModel implements IContactTypeModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    name?: string | undefined;

    constructor(data?: IContactTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ContactTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IContactTypeModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    name?: string | undefined;
}

export class DeliveryContactModel implements IDeliveryContactModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    deliveryId?: string;
    delivery?: Elavtal;
    customerId?: string;
    customer?: CustomerModel;
    contactTypeId?: string;
    contactType?: ContactTypeModel;

    constructor(data?: IDeliveryContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.deliveryId = _data["deliveryId"];
            this.delivery = _data["delivery"] ? Elavtal.fromJS(_data["delivery"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.contactTypeId = _data["contactTypeId"];
            this.contactType = _data["contactType"] ? ContactTypeModel.fromJS(_data["contactType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeliveryContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["deliveryId"] = this.deliveryId;
        data["delivery"] = this.delivery ? this.delivery.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["contactTypeId"] = this.contactTypeId;
        data["contactType"] = this.contactType ? this.contactType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeliveryContactModel {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    deliveryId?: string;
    delivery?: Elavtal;
    customerId?: string;
    customer?: CustomerModel;
    contactTypeId?: string;
    contactType?: ContactTypeModel;
}

export enum ChangeOfMeasuringMethodRequestStatus {
    NEW = "NEW",
    SENT = "SENT",
    RECEIVED = "RECEIVED",
    COMPLETED = "COMPLETED",
    CANCELED = "CANCELED",
    ERROR = "ERROR",
}

export class ChangeMeasuringMethodRequest implements IChangeMeasuringMethodRequest {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    requestedMeasuringMethod?: MeasureMethod;
    requestStatus?: ChangeOfMeasuringMethodRequestStatus;
    direction?: Direction;
    requestedStartDate?: moment.Moment;
    elavtalId?: string;
    elavtal?: Elavtal;

    constructor(data?: IChangeMeasuringMethodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.requestedMeasuringMethod = _data["requestedMeasuringMethod"];
            this.requestStatus = _data["requestStatus"];
            this.direction = _data["direction"];
            this.requestedStartDate = _data["requestedStartDate"] ? moment(_data["requestedStartDate"].toString()) : <any>undefined;
            this.elavtalId = _data["elavtalId"];
            this.elavtal = _data["elavtal"] ? Elavtal.fromJS(_data["elavtal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangeMeasuringMethodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeMeasuringMethodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["requestedMeasuringMethod"] = this.requestedMeasuringMethod;
        data["requestStatus"] = this.requestStatus;
        data["direction"] = this.direction;
        data["requestedStartDate"] = this.requestedStartDate ? this.requestedStartDate.toISOString() : <any>undefined;
        data["elavtalId"] = this.elavtalId;
        data["elavtal"] = this.elavtal ? this.elavtal.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChangeMeasuringMethodRequest {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    requestedMeasuringMethod?: MeasureMethod;
    requestStatus?: ChangeOfMeasuringMethodRequestStatus;
    direction?: Direction;
    requestedStartDate?: moment.Moment;
    elavtalId?: string;
    elavtal?: Elavtal;
}

export class Elavtal implements IElavtal {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    customerId?: string;
    customer?: CustomerModel;
    propertyId?: string;
    property?: PropertyModel;
    currentFirstName?: string | undefined;
    currentLastName?: string | undefined;
    supplierChangeType?: SupplierChangeType;
    elavtalsstatus?: Elavtalsstatus;
    statusDescription?: string | undefined;
    signedFromIp?: string | undefined;
    orderId?: string;
    requiresHourlyMeasuring?: boolean;
    hasProductionContract?: boolean;
    completionId?: string | undefined;
    salesChannelId?: string;
    salesChannel?: SalesChannelModel;
    salesDate?: moment.Moment | undefined;
    salesPerson?: string | undefined;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    stoppedForBillingToDate?: moment.Moment | undefined;
    reasonForTerminationTagId?: string | undefined;
    reasonForTerminationTag?: TypedTagModel;
    warrantLink?: string | undefined;
    warrantFileId?: string | undefined;
    warrantFile?: FileModel;
    tags?: Tag[] | undefined;
    previousSupplierId?: string | undefined;
    previousSupplier?: Supplier;
    billogramExtensions?: ElavtalBillogramExtensions;
    contracts?: Contract[] | undefined;
    invoiceItems?: InvoiceItemModel[] | undefined;
    signatureId?: string | undefined;
    accountingObjects?: AccountingObjectModel[] | undefined;
    contacts?: DeliveryContactModel[] | undefined;
    changeMeasuringMethodRequests?: ChangeMeasuringMethodRequest[] | undefined;
    searchData?: string | undefined;
    entityData?: string | undefined;
    entityType?: string | undefined;
    regardingName?: string | undefined;

    constructor(data?: IElavtal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyModel.fromJS(_data["company"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.propertyId = _data["propertyId"];
            this.property = _data["property"] ? PropertyModel.fromJS(_data["property"]) : <any>undefined;
            this.currentFirstName = _data["currentFirstName"];
            this.currentLastName = _data["currentLastName"];
            this.supplierChangeType = _data["supplierChangeType"];
            this.elavtalsstatus = _data["elavtalsstatus"];
            this.statusDescription = _data["statusDescription"];
            this.signedFromIp = _data["signedFromIp"];
            this.orderId = _data["orderId"];
            this.requiresHourlyMeasuring = _data["requiresHourlyMeasuring"];
            this.hasProductionContract = _data["hasProductionContract"];
            this.completionId = _data["completionId"];
            this.salesChannelId = _data["salesChannelId"];
            this.salesChannel = _data["salesChannel"] ? SalesChannelModel.fromJS(_data["salesChannel"]) : <any>undefined;
            this.salesDate = _data["salesDate"] ? moment(_data["salesDate"].toString()) : <any>undefined;
            this.salesPerson = _data["salesPerson"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.stoppedForBillingToDate = _data["stoppedForBillingToDate"] ? moment(_data["stoppedForBillingToDate"].toString()) : <any>undefined;
            this.reasonForTerminationTagId = _data["reasonForTerminationTagId"];
            this.reasonForTerminationTag = _data["reasonForTerminationTag"] ? TypedTagModel.fromJS(_data["reasonForTerminationTag"]) : <any>undefined;
            this.warrantLink = _data["warrantLink"];
            this.warrantFileId = _data["warrantFileId"];
            this.warrantFile = _data["warrantFile"] ? FileModel.fromJS(_data["warrantFile"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(Tag.fromJS(item));
            }
            this.previousSupplierId = _data["previousSupplierId"];
            this.previousSupplier = _data["previousSupplier"] ? Supplier.fromJS(_data["previousSupplier"]) : <any>undefined;
            this.billogramExtensions = _data["billogramExtensions"] ? ElavtalBillogramExtensions.fromJS(_data["billogramExtensions"]) : <any>undefined;
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(Contract.fromJS(item));
            }
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(InvoiceItemModel.fromJS(item));
            }
            this.signatureId = _data["signatureId"];
            if (Array.isArray(_data["accountingObjects"])) {
                this.accountingObjects = [] as any;
                for (let item of _data["accountingObjects"])
                    this.accountingObjects!.push(AccountingObjectModel.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(DeliveryContactModel.fromJS(item));
            }
            if (Array.isArray(_data["changeMeasuringMethodRequests"])) {
                this.changeMeasuringMethodRequests = [] as any;
                for (let item of _data["changeMeasuringMethodRequests"])
                    this.changeMeasuringMethodRequests!.push(ChangeMeasuringMethodRequest.fromJS(item));
            }
            this.searchData = _data["searchData"];
            this.entityData = _data["entityData"];
            this.entityType = _data["entityType"];
            this.regardingName = _data["regardingName"];
        }
    }

    static fromJS(data: any): Elavtal {
        data = typeof data === 'object' ? data : {};
        let result = new Elavtal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["propertyId"] = this.propertyId;
        data["property"] = this.property ? this.property.toJSON() : <any>undefined;
        data["currentFirstName"] = this.currentFirstName;
        data["currentLastName"] = this.currentLastName;
        data["supplierChangeType"] = this.supplierChangeType;
        data["elavtalsstatus"] = this.elavtalsstatus;
        data["statusDescription"] = this.statusDescription;
        data["signedFromIp"] = this.signedFromIp;
        data["orderId"] = this.orderId;
        data["requiresHourlyMeasuring"] = this.requiresHourlyMeasuring;
        data["hasProductionContract"] = this.hasProductionContract;
        data["completionId"] = this.completionId;
        data["salesChannelId"] = this.salesChannelId;
        data["salesChannel"] = this.salesChannel ? this.salesChannel.toJSON() : <any>undefined;
        data["salesDate"] = this.salesDate ? this.salesDate.toISOString() : <any>undefined;
        data["salesPerson"] = this.salesPerson;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["stoppedForBillingToDate"] = this.stoppedForBillingToDate ? this.stoppedForBillingToDate.toISOString() : <any>undefined;
        data["reasonForTerminationTagId"] = this.reasonForTerminationTagId;
        data["reasonForTerminationTag"] = this.reasonForTerminationTag ? this.reasonForTerminationTag.toJSON() : <any>undefined;
        data["warrantLink"] = this.warrantLink;
        data["warrantFileId"] = this.warrantFileId;
        data["warrantFile"] = this.warrantFile ? this.warrantFile.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["previousSupplierId"] = this.previousSupplierId;
        data["previousSupplier"] = this.previousSupplier ? this.previousSupplier.toJSON() : <any>undefined;
        data["billogramExtensions"] = this.billogramExtensions ? this.billogramExtensions.toJSON() : <any>undefined;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        data["signatureId"] = this.signatureId;
        if (Array.isArray(this.accountingObjects)) {
            data["accountingObjects"] = [];
            for (let item of this.accountingObjects)
                data["accountingObjects"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.changeMeasuringMethodRequests)) {
            data["changeMeasuringMethodRequests"] = [];
            for (let item of this.changeMeasuringMethodRequests)
                data["changeMeasuringMethodRequests"].push(item.toJSON());
        }
        data["searchData"] = this.searchData;
        data["entityData"] = this.entityData;
        data["entityType"] = this.entityType;
        data["regardingName"] = this.regardingName;
        return data;
    }
}

export interface IElavtal {
    id?: string;
    modifiedOn?: moment.Moment;
    modifiedBy?: string;
    createdOn?: moment.Moment;
    createdBy?: string;
    deleted?: boolean;
    externalId?: string | undefined;
    companyId?: string;
    company?: CompanyModel;
    customerId?: string;
    customer?: CustomerModel;
    propertyId?: string;
    property?: PropertyModel;
    currentFirstName?: string | undefined;
    currentLastName?: string | undefined;
    supplierChangeType?: SupplierChangeType;
    elavtalsstatus?: Elavtalsstatus;
    statusDescription?: string | undefined;
    signedFromIp?: string | undefined;
    orderId?: string;
    requiresHourlyMeasuring?: boolean;
    hasProductionContract?: boolean;
    completionId?: string | undefined;
    salesChannelId?: string;
    salesChannel?: SalesChannelModel;
    salesDate?: moment.Moment | undefined;
    salesPerson?: string | undefined;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    stoppedForBillingToDate?: moment.Moment | undefined;
    reasonForTerminationTagId?: string | undefined;
    reasonForTerminationTag?: TypedTagModel;
    warrantLink?: string | undefined;
    warrantFileId?: string | undefined;
    warrantFile?: FileModel;
    tags?: Tag[] | undefined;
    previousSupplierId?: string | undefined;
    previousSupplier?: Supplier;
    billogramExtensions?: ElavtalBillogramExtensions;
    contracts?: Contract[] | undefined;
    invoiceItems?: InvoiceItemModel[] | undefined;
    signatureId?: string | undefined;
    accountingObjects?: AccountingObjectModel[] | undefined;
    contacts?: DeliveryContactModel[] | undefined;
    changeMeasuringMethodRequests?: ChangeMeasuringMethodRequest[] | undefined;
    searchData?: string | undefined;
    entityData?: string | undefined;
    entityType?: string | undefined;
    regardingName?: string | undefined;
}

export class InvoiceDataRow implements IInvoiceDataRow {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    invoiceDataId?: string;
    contractId?: string | undefined;
    contract?: Contract;
    price?: number;
    quantity?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    amount?: number;
    vatAmount?: number;

    constructor(data?: IInvoiceDataRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.invoiceDataId = _data["invoiceDataId"];
            this.contractId = _data["contractId"];
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : <any>undefined;
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.vatAmount = _data["vatAmount"];
        }
    }

    static fromJS(data: any): InvoiceDataRow {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDataRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["invoiceDataId"] = this.invoiceDataId;
        data["contractId"] = this.contractId;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["vatAmount"] = this.vatAmount;
        return data;
    }
}

export interface IInvoiceDataRow {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    invoiceDataId?: string;
    contractId?: string | undefined;
    contract?: Contract;
    price?: number;
    quantity?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    amount?: number;
    vatAmount?: number;
}

export class AccountingDimension implements IAccountingDimension {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    dimensionId?: number;
    name?: string | undefined;

    constructor(data?: IAccountingDimension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.dimensionId = _data["dimensionId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AccountingDimension {
        data = typeof data === 'object' ? data : {};
        let result = new AccountingDimension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["dimensionId"] = this.dimensionId;
        data["name"] = this.name;
        return data;
    }
}

export interface IAccountingDimension {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    dimensionId?: number;
    name?: string | undefined;
}

export class AccountingObject implements IAccountingObject {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    objectId?: number;
    name?: string | undefined;
    dimension?: AccountingDimension;

    constructor(data?: IAccountingObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.objectId = _data["objectId"];
            this.name = _data["name"];
            this.dimension = _data["dimension"] ? AccountingDimension.fromJS(_data["dimension"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountingObject {
        data = typeof data === 'object' ? data : {};
        let result = new AccountingObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["objectId"] = this.objectId;
        data["name"] = this.name;
        data["dimension"] = this.dimension ? this.dimension.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccountingObject {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    objectId?: number;
    name?: string | undefined;
    dimension?: AccountingDimension;
}

export class InvoiceRow implements IInvoiceRow {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    heading?: string | undefined;
    description?: string | undefined;
    unit?: string | undefined;
    incomeAccount?: string | undefined;
    vatAccount?: string | undefined;
    quantity?: number;
    price?: number;
    amount?: number;
    vatAmount?: number;
    accountingObjects?: AccountingObject[] | undefined;

    constructor(data?: IInvoiceRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.heading = _data["heading"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.incomeAccount = _data["incomeAccount"];
            this.vatAccount = _data["vatAccount"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.amount = _data["amount"];
            this.vatAmount = _data["vatAmount"];
            if (Array.isArray(_data["accountingObjects"])) {
                this.accountingObjects = [] as any;
                for (let item of _data["accountingObjects"])
                    this.accountingObjects!.push(AccountingObject.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceRow {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["heading"] = this.heading;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["incomeAccount"] = this.incomeAccount;
        data["vatAccount"] = this.vatAccount;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["amount"] = this.amount;
        data["vatAmount"] = this.vatAmount;
        if (Array.isArray(this.accountingObjects)) {
            data["accountingObjects"] = [];
            for (let item of this.accountingObjects)
                data["accountingObjects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvoiceRow {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    heading?: string | undefined;
    description?: string | undefined;
    unit?: string | undefined;
    incomeAccount?: string | undefined;
    vatAccount?: string | undefined;
    quantity?: number;
    price?: number;
    amount?: number;
    vatAmount?: number;
    accountingObjects?: AccountingObject[] | undefined;
}

export class Customer implements ICustomer {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    customerType?: CustomerType;
    pid?: string | undefined;
    personalIdType?: PersonalIdType;
    birthDate?: moment.Moment | undefined;
    additionalPersonalId?: string | undefined;
    street?: string | undefined;
    coAddress?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    billogramCustomerId?: number | undefined;
    efaktura_Recipient_Identifier?: string | undefined;
    recurringPaymentType?: RecurringPaymentType;
    edi_electronic_id?: string | undefined;
    edi_operator?: string | undefined;
    edi_reference?: string | undefined;
    useInvoiceCollection?: boolean;
    invoiceDeliveryMethod?: InvoiceDeliveryMethod;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.customerType = _data["customerType"];
            this.pid = _data["pid"];
            this.personalIdType = _data["personalIdType"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.additionalPersonalId = _data["additionalPersonalId"];
            this.street = _data["street"];
            this.coAddress = _data["coAddress"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.mobile = _data["mobile"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.billogramCustomerId = _data["billogramCustomerId"];
            this.efaktura_Recipient_Identifier = _data["efaktura_Recipient_Identifier"];
            this.recurringPaymentType = _data["recurringPaymentType"];
            this.edi_electronic_id = _data["edi_electronic_id"];
            this.edi_operator = _data["edi_operator"];
            this.edi_reference = _data["edi_reference"];
            this.useInvoiceCollection = _data["useInvoiceCollection"];
            this.invoiceDeliveryMethod = _data["invoiceDeliveryMethod"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["customerType"] = this.customerType;
        data["pid"] = this.pid;
        data["personalIdType"] = this.personalIdType;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["additionalPersonalId"] = this.additionalPersonalId;
        data["street"] = this.street;
        data["coAddress"] = this.coAddress;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["mobile"] = this.mobile;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["billogramCustomerId"] = this.billogramCustomerId;
        data["efaktura_Recipient_Identifier"] = this.efaktura_Recipient_Identifier;
        data["recurringPaymentType"] = this.recurringPaymentType;
        data["edi_electronic_id"] = this.edi_electronic_id;
        data["edi_operator"] = this.edi_operator;
        data["edi_reference"] = this.edi_reference;
        data["useInvoiceCollection"] = this.useInvoiceCollection;
        data["invoiceDeliveryMethod"] = this.invoiceDeliveryMethod;
        return data;
    }
}

export interface ICustomer {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    customerType?: CustomerType;
    pid?: string | undefined;
    personalIdType?: PersonalIdType;
    birthDate?: moment.Moment | undefined;
    additionalPersonalId?: string | undefined;
    street?: string | undefined;
    coAddress?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    billogramCustomerId?: number | undefined;
    efaktura_Recipient_Identifier?: string | undefined;
    recurringPaymentType?: RecurringPaymentType;
    edi_electronic_id?: string | undefined;
    edi_operator?: string | undefined;
    edi_reference?: string | undefined;
    useInvoiceCollection?: boolean;
    invoiceDeliveryMethod?: InvoiceDeliveryMethod;
}

export class Invoice implements IInvoice {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    paymentStatus?: PaymentStatus;
    paymentDescription?: string | undefined;
    url?: string | undefined;
    recipientUrl?: string | undefined;
    invoiceDatas?: InvoiceData[] | undefined;
    invoiceNumber?: string | undefined;
    bankGiro?: string | undefined;
    ocr?: string | undefined;
    amount?: number;
    rounding?: number;
    reminderFee?: number;
    interestFee?: number;
    dateOfInvoice?: moment.Moment;
    dueDate?: moment.Moment | undefined;
    respiteDate?: moment.Moment | undefined;
    overdueNotificationSent?: boolean;
    rows?: InvoiceRow[] | undefined;
    status?: InvoiceStatus;
    customer?: Customer;
    invoicingId?: string;

    constructor(data?: IInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.paymentStatus = _data["paymentStatus"];
            this.paymentDescription = _data["paymentDescription"];
            this.url = _data["url"];
            this.recipientUrl = _data["recipientUrl"];
            if (Array.isArray(_data["invoiceDatas"])) {
                this.invoiceDatas = [] as any;
                for (let item of _data["invoiceDatas"])
                    this.invoiceDatas!.push(InvoiceData.fromJS(item));
            }
            this.invoiceNumber = _data["invoiceNumber"];
            this.bankGiro = _data["bankGiro"];
            this.ocr = _data["ocr"];
            this.amount = _data["amount"];
            this.rounding = _data["rounding"];
            this.reminderFee = _data["reminderFee"];
            this.interestFee = _data["interestFee"];
            this.dateOfInvoice = _data["dateOfInvoice"] ? moment(_data["dateOfInvoice"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.respiteDate = _data["respiteDate"] ? moment(_data["respiteDate"].toString()) : <any>undefined;
            this.overdueNotificationSent = _data["overdueNotificationSent"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(InvoiceRow.fromJS(item));
            }
            this.status = _data["status"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.invoicingId = _data["invoicingId"];
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["paymentStatus"] = this.paymentStatus;
        data["paymentDescription"] = this.paymentDescription;
        data["url"] = this.url;
        data["recipientUrl"] = this.recipientUrl;
        if (Array.isArray(this.invoiceDatas)) {
            data["invoiceDatas"] = [];
            for (let item of this.invoiceDatas)
                data["invoiceDatas"].push(item.toJSON());
        }
        data["invoiceNumber"] = this.invoiceNumber;
        data["bankGiro"] = this.bankGiro;
        data["ocr"] = this.ocr;
        data["amount"] = this.amount;
        data["rounding"] = this.rounding;
        data["reminderFee"] = this.reminderFee;
        data["interestFee"] = this.interestFee;
        data["dateOfInvoice"] = this.dateOfInvoice ? this.dateOfInvoice.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["respiteDate"] = this.respiteDate ? this.respiteDate.toISOString() : <any>undefined;
        data["overdueNotificationSent"] = this.overdueNotificationSent;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["invoicingId"] = this.invoicingId;
        return data;
    }
}

export interface IInvoice {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    paymentStatus?: PaymentStatus;
    paymentDescription?: string | undefined;
    url?: string | undefined;
    recipientUrl?: string | undefined;
    invoiceDatas?: InvoiceData[] | undefined;
    invoiceNumber?: string | undefined;
    bankGiro?: string | undefined;
    ocr?: string | undefined;
    amount?: number;
    rounding?: number;
    reminderFee?: number;
    interestFee?: number;
    dateOfInvoice?: moment.Moment;
    dueDate?: moment.Moment | undefined;
    respiteDate?: moment.Moment | undefined;
    overdueNotificationSent?: boolean;
    rows?: InvoiceRow[] | undefined;
    status?: InvoiceStatus;
    customer?: Customer;
    invoicingId?: string;
}

export class InvoiceData implements IInvoiceData {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    invoiceDataStatus?: InvoiceDataStatus;
    elavtalId?: string;
    elavtal?: Elavtal;
    rows?: InvoiceDataRow[] | undefined;
    invoiceDataCollectionId?: string | undefined;
    amountExkludingVat?: number;
    vatAmount?: number;
    amountIncludingVat?: number;
    consumption?: number;
    rounding?: number;
    dateOfInvoice?: moment.Moment;
    dueDate?: moment.Moment | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    finalInvoice?: boolean;
    invoicingId?: string;
    invoiceCreated?: boolean;
    invoiceId?: string | undefined;
    invoice?: Invoice;

    constructor(data?: IInvoiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.externalId = _data["externalId"];
            this.invoiceDataStatus = _data["invoiceDataStatus"];
            this.elavtalId = _data["elavtalId"];
            this.elavtal = _data["elavtal"] ? Elavtal.fromJS(_data["elavtal"]) : <any>undefined;
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(InvoiceDataRow.fromJS(item));
            }
            this.invoiceDataCollectionId = _data["invoiceDataCollectionId"];
            this.amountExkludingVat = _data["amountExkludingVat"];
            this.vatAmount = _data["vatAmount"];
            this.amountIncludingVat = _data["amountIncludingVat"];
            this.consumption = _data["consumption"];
            this.rounding = _data["rounding"];
            this.dateOfInvoice = _data["dateOfInvoice"] ? moment(_data["dateOfInvoice"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.finalInvoice = _data["finalInvoice"];
            this.invoicingId = _data["invoicingId"];
            this.invoiceCreated = _data["invoiceCreated"];
            this.invoiceId = _data["invoiceId"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceData {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["externalId"] = this.externalId;
        data["invoiceDataStatus"] = this.invoiceDataStatus;
        data["elavtalId"] = this.elavtalId;
        data["elavtal"] = this.elavtal ? this.elavtal.toJSON() : <any>undefined;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["invoiceDataCollectionId"] = this.invoiceDataCollectionId;
        data["amountExkludingVat"] = this.amountExkludingVat;
        data["vatAmount"] = this.vatAmount;
        data["amountIncludingVat"] = this.amountIncludingVat;
        data["consumption"] = this.consumption;
        data["rounding"] = this.rounding;
        data["dateOfInvoice"] = this.dateOfInvoice ? this.dateOfInvoice.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["finalInvoice"] = this.finalInvoice;
        data["invoicingId"] = this.invoicingId;
        data["invoiceCreated"] = this.invoiceCreated;
        data["invoiceId"] = this.invoiceId;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvoiceData {
    id?: string;
    modifiedOn?: moment.Moment;
    createdOn?: moment.Moment;
    deleted?: boolean;
    externalId?: string | undefined;
    invoiceDataStatus?: InvoiceDataStatus;
    elavtalId?: string;
    elavtal?: Elavtal;
    rows?: InvoiceDataRow[] | undefined;
    invoiceDataCollectionId?: string | undefined;
    amountExkludingVat?: number;
    vatAmount?: number;
    amountIncludingVat?: number;
    consumption?: number;
    rounding?: number;
    dateOfInvoice?: moment.Moment;
    dueDate?: moment.Moment | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    finalInvoice?: boolean;
    invoicingId?: string;
    invoiceCreated?: boolean;
    invoiceId?: string | undefined;
    invoice?: Invoice;
}

export enum InvoicingStatus {
    INVOICE_DATA_PROCESSING = "INVOICE_DATA_PROCESSING",
    INVOICE_DATA_COMPLETE = "INVOICE_DATA_COMPLETE",
    INVOICE_DATA_INCOMPLETE = "INVOICE_DATA_INCOMPLETE",
    INVOICE_PROCESSING = "INVOICE_PROCESSING",
    INVOICE_COMPLETE = "INVOICE_COMPLETE",
    INVOICE_INCOMPLETE = "INVOICE_INCOMPLETE",
    INVOICE_SEND_PROCESSING = "INVOICE_SEND_PROCESSING",
    INVOICE_SEND_COMPLETE = "INVOICE_SEND_COMPLETE",
    INVOICE_SEND_INCOMPLETE = "INVOICE_SEND_INCOMPLETE",
}

export class Invoicing implements IInvoicing {
    invoicingDate?: moment.Moment;
    dueDate?: moment.Moment | undefined;
    comment?: string | undefined;
    id?: string;
    createdOn?: moment.Moment;
    invoiceData?: InvoiceData[] | undefined;
    numberOfElavtal?: number;
    numberOfInvoiceDatas?: number;
    numberOfInvoiceDataErrors?: number;
    numberOfBilledInvoiceDatas?: number;
    numberOfInvoices?: number;
    numberOfInvoiceErrors?: number;
    numberOfSentInvoices?: number;
    numberOfInvoiceSendErrors?: number;
    totalAmount?: number;
    totalConsumption?: number;
    completedOn?: moment.Moment | undefined;
    status?: InvoicingStatus;

    constructor(data?: IInvoicing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoicingDate = _data["invoicingDate"] ? moment(_data["invoicingDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["invoiceData"])) {
                this.invoiceData = [] as any;
                for (let item of _data["invoiceData"])
                    this.invoiceData!.push(InvoiceData.fromJS(item));
            }
            this.numberOfElavtal = _data["numberOfElavtal"];
            this.numberOfInvoiceDatas = _data["numberOfInvoiceDatas"];
            this.numberOfInvoiceDataErrors = _data["numberOfInvoiceDataErrors"];
            this.numberOfBilledInvoiceDatas = _data["numberOfBilledInvoiceDatas"];
            this.numberOfInvoices = _data["numberOfInvoices"];
            this.numberOfInvoiceErrors = _data["numberOfInvoiceErrors"];
            this.numberOfSentInvoices = _data["numberOfSentInvoices"];
            this.numberOfInvoiceSendErrors = _data["numberOfInvoiceSendErrors"];
            this.totalAmount = _data["totalAmount"];
            this.totalConsumption = _data["totalConsumption"];
            this.completedOn = _data["completedOn"] ? moment(_data["completedOn"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): Invoicing {
        data = typeof data === 'object' ? data : {};
        let result = new Invoicing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoicingDate"] = this.invoicingDate ? this.invoicingDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        if (Array.isArray(this.invoiceData)) {
            data["invoiceData"] = [];
            for (let item of this.invoiceData)
                data["invoiceData"].push(item.toJSON());
        }
        data["numberOfElavtal"] = this.numberOfElavtal;
        data["numberOfInvoiceDatas"] = this.numberOfInvoiceDatas;
        data["numberOfInvoiceDataErrors"] = this.numberOfInvoiceDataErrors;
        data["numberOfBilledInvoiceDatas"] = this.numberOfBilledInvoiceDatas;
        data["numberOfInvoices"] = this.numberOfInvoices;
        data["numberOfInvoiceErrors"] = this.numberOfInvoiceErrors;
        data["numberOfSentInvoices"] = this.numberOfSentInvoices;
        data["numberOfInvoiceSendErrors"] = this.numberOfInvoiceSendErrors;
        data["totalAmount"] = this.totalAmount;
        data["totalConsumption"] = this.totalConsumption;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IInvoicing {
    invoicingDate?: moment.Moment;
    dueDate?: moment.Moment | undefined;
    comment?: string | undefined;
    id?: string;
    createdOn?: moment.Moment;
    invoiceData?: InvoiceData[] | undefined;
    numberOfElavtal?: number;
    numberOfInvoiceDatas?: number;
    numberOfInvoiceDataErrors?: number;
    numberOfBilledInvoiceDatas?: number;
    numberOfInvoices?: number;
    numberOfInvoiceErrors?: number;
    numberOfSentInvoices?: number;
    numberOfInvoiceSendErrors?: number;
    totalAmount?: number;
    totalConsumption?: number;
    completedOn?: moment.Moment | undefined;
    status?: InvoicingStatus;
}

export class AvyInvoicing implements IAvyInvoicing {
    easyId?: string;
    easyInvoices?: number;
    sentInvoices?: number;
    failedInvoices?: number;

    constructor(data?: IAvyInvoicing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.easyId = _data["easyId"];
            this.easyInvoices = _data["easyInvoices"];
            this.sentInvoices = _data["sentInvoices"];
            this.failedInvoices = _data["failedInvoices"];
        }
    }

    static fromJS(data: any): AvyInvoicing {
        data = typeof data === 'object' ? data : {};
        let result = new AvyInvoicing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["easyId"] = this.easyId;
        data["easyInvoices"] = this.easyInvoices;
        data["sentInvoices"] = this.sentInvoices;
        data["failedInvoices"] = this.failedInvoices;
        return data;
    }
}

export interface IAvyInvoicing {
    easyId?: string;
    easyInvoices?: number;
    sentInvoices?: number;
    failedInvoices?: number;
}

export enum AvyInvoiceStatus {
    OK = "OK",
    FAILED = "FAILED",
    MISSING = "MISSING",
    SENDING = "SENDING",
}

export class AvyInvoice implements IAvyInvoice {
    id?: string;
    easyInvoicingId?: string;
    avyId?: string | undefined;
    easyId?: string;
    easyUrl?: string | undefined;
    customerId?: string;
    customerName?: string | undefined;
    propertyStreet?: string | undefined;
    propertyNumber?: string | undefined;
    deliveryStatus?: Elavtalsstatus;
    deliveryStartDate?: moment.Moment | undefined;
    deliveryEndDate?: moment.Moment | undefined;
    invoiceDeliveryMethod?: InvoiceDeliveryMethod;
    amount?: number;
    createdOn?: moment.Moment;
    createdBy?: string;
    status?: AvyInvoiceStatus;

    constructor(data?: IAvyInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.easyInvoicingId = _data["easyInvoicingId"];
            this.avyId = _data["avyId"];
            this.easyId = _data["easyId"];
            this.easyUrl = _data["easyUrl"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.propertyStreet = _data["propertyStreet"];
            this.propertyNumber = _data["propertyNumber"];
            this.deliveryStatus = _data["deliveryStatus"];
            this.deliveryStartDate = _data["deliveryStartDate"] ? moment(_data["deliveryStartDate"].toString()) : <any>undefined;
            this.deliveryEndDate = _data["deliveryEndDate"] ? moment(_data["deliveryEndDate"].toString()) : <any>undefined;
            this.invoiceDeliveryMethod = _data["invoiceDeliveryMethod"];
            this.amount = _data["amount"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AvyInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new AvyInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["easyInvoicingId"] = this.easyInvoicingId;
        data["avyId"] = this.avyId;
        data["easyId"] = this.easyId;
        data["easyUrl"] = this.easyUrl;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["propertyStreet"] = this.propertyStreet;
        data["propertyNumber"] = this.propertyNumber;
        data["deliveryStatus"] = this.deliveryStatus;
        data["deliveryStartDate"] = this.deliveryStartDate ? this.deliveryStartDate.toISOString() : <any>undefined;
        data["deliveryEndDate"] = this.deliveryEndDate ? this.deliveryEndDate.toISOString() : <any>undefined;
        data["invoiceDeliveryMethod"] = this.invoiceDeliveryMethod;
        data["amount"] = this.amount;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["status"] = this.status;
        return data;
    }
}

export interface IAvyInvoice {
    id?: string;
    easyInvoicingId?: string;
    avyId?: string | undefined;
    easyId?: string;
    easyUrl?: string | undefined;
    customerId?: string;
    customerName?: string | undefined;
    propertyStreet?: string | undefined;
    propertyNumber?: string | undefined;
    deliveryStatus?: Elavtalsstatus;
    deliveryStartDate?: moment.Moment | undefined;
    deliveryEndDate?: moment.Moment | undefined;
    invoiceDeliveryMethod?: InvoiceDeliveryMethod;
    amount?: number;
    createdOn?: moment.Moment;
    createdBy?: string;
    status?: AvyInvoiceStatus;
}

export enum RealEstateOrderStatus {
    NEW = "NEW",
    PROCESSED = "PROCESSED",
    COMPLETED = "COMPLETED",
    NOT_INTERESTED = "NOT_INTERESTED",
    NOT_ASKED = "NOT_ASKED",
}

export enum AddOn {
    Electricity = "Electricity",
    Insurance = "Insurance",
    Mortgage = "Mortgage",
}

export enum RealEstateOrderContractMethod {
    MAIL = "MAIL",
    SYSTEM = "SYSTEM",
    UPLOAD = "UPLOAD",
    NOT_SET = "NOT_SET",
}

export class MspecsOrder implements IMspecsOrder {
    dealId?: string | undefined;
    dealShortId?: string | undefined;
    reminderSent?: moment.Moment | undefined;
    missingFileNotificationSent?: moment.Moment | undefined;
    mspecsFileIds?: string[] | undefined;
    caseCreated?: boolean;
    id?: string;
    createdOn?: moment.Moment;
    updatedOn?: moment.Moment;
    status?: RealEstateOrderStatus;
    addOns?: AddOn[] | undefined;
    contractMethod?: RealEstateOrderContractMethod;
    comment?: string | undefined;
    realEstateObjectId?: string | undefined;
    realEstateObject?: RealEstateObjectDbModel;
    easyFileIds?: string[] | undefined;
    easyCaseId?: string | undefined;
    rebelOrderId?: number | undefined;
    readonly auditEntityId?: string | undefined;

    constructor(data?: IMspecsOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.dealShortId = _data["dealShortId"];
            this.reminderSent = _data["reminderSent"] ? moment(_data["reminderSent"].toString()) : <any>undefined;
            this.missingFileNotificationSent = _data["missingFileNotificationSent"] ? moment(_data["missingFileNotificationSent"].toString()) : <any>undefined;
            if (Array.isArray(_data["mspecsFileIds"])) {
                this.mspecsFileIds = [] as any;
                for (let item of _data["mspecsFileIds"])
                    this.mspecsFileIds!.push(item);
            }
            this.caseCreated = _data["caseCreated"];
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["addOns"])) {
                this.addOns = [] as any;
                for (let item of _data["addOns"])
                    this.addOns!.push(item);
            }
            this.contractMethod = _data["contractMethod"];
            this.comment = _data["comment"];
            this.realEstateObjectId = _data["realEstateObjectId"];
            this.realEstateObject = _data["realEstateObject"] ? RealEstateObjectDbModel.fromJS(_data["realEstateObject"]) : <any>undefined;
            if (Array.isArray(_data["easyFileIds"])) {
                this.easyFileIds = [] as any;
                for (let item of _data["easyFileIds"])
                    this.easyFileIds!.push(item);
            }
            this.easyCaseId = _data["easyCaseId"];
            this.rebelOrderId = _data["rebelOrderId"];
            (<any>this).auditEntityId = _data["auditEntityId"];
        }
    }

    static fromJS(data: any): MspecsOrder {
        data = typeof data === 'object' ? data : {};
        let result = new MspecsOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["dealShortId"] = this.dealShortId;
        data["reminderSent"] = this.reminderSent ? this.reminderSent.toISOString() : <any>undefined;
        data["missingFileNotificationSent"] = this.missingFileNotificationSent ? this.missingFileNotificationSent.toISOString() : <any>undefined;
        if (Array.isArray(this.mspecsFileIds)) {
            data["mspecsFileIds"] = [];
            for (let item of this.mspecsFileIds)
                data["mspecsFileIds"].push(item);
        }
        data["caseCreated"] = this.caseCreated;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["status"] = this.status;
        if (Array.isArray(this.addOns)) {
            data["addOns"] = [];
            for (let item of this.addOns)
                data["addOns"].push(item);
        }
        data["contractMethod"] = this.contractMethod;
        data["comment"] = this.comment;
        data["realEstateObjectId"] = this.realEstateObjectId;
        data["realEstateObject"] = this.realEstateObject ? this.realEstateObject.toJSON() : <any>undefined;
        if (Array.isArray(this.easyFileIds)) {
            data["easyFileIds"] = [];
            for (let item of this.easyFileIds)
                data["easyFileIds"].push(item);
        }
        data["easyCaseId"] = this.easyCaseId;
        data["rebelOrderId"] = this.rebelOrderId;
        data["auditEntityId"] = this.auditEntityId;
        return data;
    }
}

export interface IMspecsOrder {
    dealId?: string | undefined;
    dealShortId?: string | undefined;
    reminderSent?: moment.Moment | undefined;
    missingFileNotificationSent?: moment.Moment | undefined;
    mspecsFileIds?: string[] | undefined;
    caseCreated?: boolean;
    id?: string;
    createdOn?: moment.Moment;
    updatedOn?: moment.Moment;
    status?: RealEstateOrderStatus;
    addOns?: AddOn[] | undefined;
    contractMethod?: RealEstateOrderContractMethod;
    comment?: string | undefined;
    realEstateObjectId?: string | undefined;
    realEstateObject?: RealEstateObjectDbModel;
    easyFileIds?: string[] | undefined;
    easyCaseId?: string | undefined;
    rebelOrderId?: number | undefined;
    auditEntityId?: string | undefined;
}

export class MspecsFileCategory implements IMspecsFileCategory {
    constant?: string | undefined;
    translation?: string | undefined;

    constructor(data?: IMspecsFileCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constant = _data["constant"];
            this.translation = _data["translation"];
        }
    }

    static fromJS(data: any): MspecsFileCategory {
        data = typeof data === 'object' ? data : {};
        let result = new MspecsFileCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constant"] = this.constant;
        data["translation"] = this.translation;
        return data;
    }
}

export interface IMspecsFileCategory {
    constant?: string | undefined;
    translation?: string | undefined;
}

export class MspecsFile implements IMspecsFile {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    createdDate?: moment.Moment;
    extension?: string | undefined;
    mimeType?: string | undefined;
    originalUrl?: string | undefined;
    category?: MspecsFileCategory;

    constructor(data?: IMspecsFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>undefined;
            this.extension = _data["extension"];
            this.mimeType = _data["mimeType"];
            this.originalUrl = _data["originalUrl"];
            this.category = _data["category"] ? MspecsFileCategory.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MspecsFile {
        data = typeof data === 'object' ? data : {};
        let result = new MspecsFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        data["originalUrl"] = this.originalUrl;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMspecsFile {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    createdDate?: moment.Moment;
    extension?: string | undefined;
    mimeType?: string | undefined;
    originalUrl?: string | undefined;
    category?: MspecsFileCategory;
}

export class MspecsCompleteOrderRequest implements IMspecsCompleteOrderRequest {
    fileIds?: string[] | undefined;

    constructor(data?: IMspecsCompleteOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MspecsCompleteOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MspecsCompleteOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        return data;
    }
}

export interface IMspecsCompleteOrderRequest {
    fileIds?: string[] | undefined;
}

export class BankIdInitResponse implements IBankIdInitResponse {
    autoStartToken?: string | undefined;
    orderRef?: string | undefined;
    qrCodeBase64Encoded?: string | undefined;
    state?: string | undefined;

    constructor(data?: IBankIdInitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autoStartToken = _data["autoStartToken"];
            this.orderRef = _data["orderRef"];
            this.qrCodeBase64Encoded = _data["qrCodeBase64Encoded"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): BankIdInitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BankIdInitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autoStartToken"] = this.autoStartToken;
        data["orderRef"] = this.orderRef;
        data["qrCodeBase64Encoded"] = this.qrCodeBase64Encoded;
        data["state"] = this.state;
        return data;
    }
}

export interface IBankIdInitResponse {
    autoStartToken?: string | undefined;
    orderRef?: string | undefined;
    qrCodeBase64Encoded?: string | undefined;
    state?: string | undefined;
}

export enum CollectStatus {
    Unknown = "Unknown",
    Pending = "Pending",
    Failed = "Failed",
    Complete = "Complete",
}

export class User implements IUser {
    pid?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    company?: string | undefined;
    customerId?: string | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pid = _data["pid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.company = _data["company"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pid"] = this.pid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["company"] = this.company;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IUser {
    pid?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    company?: string | undefined;
    customerId?: string | undefined;
}

export class StatusResponse implements IStatusResponse {
    status?: CollectStatus;
    qrCodeBase64Encoded?: string | undefined;
    message?: string | undefined;
    token?: string | undefined;
    user?: User;
    signatureId?: string;

    constructor(data?: IStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.qrCodeBase64Encoded = _data["qrCodeBase64Encoded"];
            this.message = _data["message"];
            this.token = _data["token"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.signatureId = _data["signatureId"];
        }
    }

    static fromJS(data: any): StatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["qrCodeBase64Encoded"] = this.qrCodeBase64Encoded;
        data["message"] = this.message;
        data["token"] = this.token;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["signatureId"] = this.signatureId;
        return data;
    }
}

export interface IStatusResponse {
    status?: CollectStatus;
    qrCodeBase64Encoded?: string | undefined;
    message?: string | undefined;
    token?: string | undefined;
    user?: User;
    signatureId?: string;
}

export enum Status {
    NEW = "NEW",
    WARRENT = "WARRENT",
    WARRENT_MOVE = "WARRENT_MOVE",
    MOVE_REG = "MOVE_REG",
    SERVICE = "SERVICE",
    COMPLETION = "COMPLETION",
    ABORTED = "ABORTED",
    DONE = "DONE",
}

export enum ContactChannel {
    MAIL = "MAIL",
    SMS = "SMS",
    PHONE = "PHONE",
}

export enum ContactType {
    LEAD = "LEAD",
    REALESTATESELLER = "REALESTATESELLER",
    CUSTOMER = "CUSTOMER",
}

export class Contact implements IContact {
    id?: string;
    pid?: string | undefined;
    mobile?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    contactChannel?: ContactChannel;
    createdOn?: moment.Moment;
    customText?: string | undefined;
    contactType?: ContactType;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pid = _data["pid"];
            this.mobile = _data["mobile"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.email = _data["email"];
            this.contactChannel = _data["contactChannel"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.customText = _data["customText"];
            this.contactType = _data["contactType"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pid"] = this.pid;
        data["mobile"] = this.mobile;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["email"] = this.email;
        data["contactChannel"] = this.contactChannel;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["customText"] = this.customText;
        data["contactType"] = this.contactType;
        return data;
    }
}

export interface IContact {
    id?: string;
    pid?: string | undefined;
    mobile?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    contactChannel?: ContactChannel;
    createdOn?: moment.Moment;
    customText?: string | undefined;
    contactType?: ContactType;
}

export enum RealEstateChannel {
    V = "V",
    Q = "Q",
    F = "F",
}

export class Signature implements ISignature {
    id?: string;
    pid?: string | undefined;
    orderRef?: string | undefined;
    createdOn?: moment.Moment;
    completedOn?: moment.Moment | undefined;
    ocspResponse?: string | undefined;
    signatureData?: string | undefined;
    userVisibleData?: string | undefined;
    initiatedIP?: string | undefined;
    signedIP?: string | undefined;
    environmentType?: string | undefined;
    environmentDeviceInfo?: string | undefined;
    clientVersion?: string | undefined;

    constructor(data?: ISignature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pid = _data["pid"];
            this.orderRef = _data["orderRef"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.completedOn = _data["completedOn"] ? moment(_data["completedOn"].toString()) : <any>undefined;
            this.ocspResponse = _data["ocspResponse"];
            this.signatureData = _data["signatureData"];
            this.userVisibleData = _data["userVisibleData"];
            this.initiatedIP = _data["initiatedIP"];
            this.signedIP = _data["signedIP"];
            this.environmentType = _data["environmentType"];
            this.environmentDeviceInfo = _data["environmentDeviceInfo"];
            this.clientVersion = _data["clientVersion"];
        }
    }

    static fromJS(data: any): Signature {
        data = typeof data === 'object' ? data : {};
        let result = new Signature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pid"] = this.pid;
        data["orderRef"] = this.orderRef;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["ocspResponse"] = this.ocspResponse;
        data["signatureData"] = this.signatureData;
        data["userVisibleData"] = this.userVisibleData;
        data["initiatedIP"] = this.initiatedIP;
        data["signedIP"] = this.signedIP;
        data["environmentType"] = this.environmentType;
        data["environmentDeviceInfo"] = this.environmentDeviceInfo;
        data["clientVersion"] = this.clientVersion;
        return data;
    }
}

export interface ISignature {
    id?: string;
    pid?: string | undefined;
    orderRef?: string | undefined;
    createdOn?: moment.Moment;
    completedOn?: moment.Moment | undefined;
    ocspResponse?: string | undefined;
    signatureData?: string | undefined;
    userVisibleData?: string | undefined;
    initiatedIP?: string | undefined;
    signedIP?: string | undefined;
    environmentType?: string | undefined;
    environmentDeviceInfo?: string | undefined;
    clientVersion?: string | undefined;
}

export enum AddOnStatus {
    PENDING = "PENDING",
    ACCEPTED = "ACCEPTED",
    REJECTED = "REJECTED",
}

export enum CompletionType {
    Confirmation = "Confirmation",
    UnknownCustomer = "UnknownCustomer",
    UnknownProperty = "UnknownProperty",
}

export class Order implements IOrder {
    id?: number;
    pid?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    ean?: string | undefined;
    isCurrent?: boolean;
    currentFirstName?: string | undefined;
    currentLastName?: string | undefined;
    startDate?: moment.Moment;
    housing?: Housing;
    area?: number | undefined;
    consumption?: number | undefined;
    channel?: Channel;
    status?: Status;
    ip?: string | undefined;
    salesperson?: string | undefined;
    externalID?: string | undefined;
    parentID?: string | undefined;
    createdOn?: moment.Moment;
    modifiedOn?: moment.Moment;
    createdInCrm?: boolean;
    elavtalsserviceId?: string | undefined;
    realEstateAgentId?: string | undefined;
    realEstateAgent?: RealEstateAgentModel;
    realEstateOfficeId?: string | undefined;
    realEstateOffice?: RealEstateOfficeModel;
    realEstateChainId?: string | undefined;
    realEstateChain?: RealEstateChainModel;
    contactId?: string | undefined;
    contact?: Contact;
    offerId?: string | undefined;
    club?: string | undefined;
    team?: string | undefined;
    salesData1?: string | undefined;
    salesData2?: string | undefined;
    salesData3?: string | undefined;
    salesData4?: string | undefined;
    salesDate?: moment.Moment | undefined;
    objectId?: string | undefined;
    objectChannel?: RealEstateChannel;
    objectCustomerId?: string | undefined;
    objectStatus?: string | undefined;
    objectStatusText?: string | undefined;
    lmvNumber?: string | undefined;
    internalPropertyNumber?: string | undefined;
    signatureId?: string | undefined;
    signature?: Signature;
    easyQuoteId?: string | undefined;
    hasElectricity?: boolean;
    hasInsurance?: boolean;
    insuranceStatus?: AddOnStatus;
    insuranceStatusDate?: moment.Moment | undefined;
    hasMortgage?: boolean;
    mortgageStatus?: AddOnStatus;
    mortgageStatusDate?: moment.Moment | undefined;
    createdBy?: string | undefined;
    completionType?: CompletionType;
    completionId?: string | undefined;
    completionContactTypeId?: string | undefined;
    completionContactFirstName?: string | undefined;
    completionContactLastName?: string | undefined;
    completionSalesChannelName?: string | undefined;
    insuranceReminderSent?: boolean;
    notes?: string | undefined;
    customerType?: CustomerType;
    readonly auditEntityId?: string | undefined;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pid = _data["pid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.street = _data["street"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.ean = _data["ean"];
            this.isCurrent = _data["isCurrent"];
            this.currentFirstName = _data["currentFirstName"];
            this.currentLastName = _data["currentLastName"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.housing = _data["housing"];
            this.area = _data["area"];
            this.consumption = _data["consumption"];
            this.channel = _data["channel"];
            this.status = _data["status"];
            this.ip = _data["ip"];
            this.salesperson = _data["salesperson"];
            this.externalID = _data["externalID"];
            this.parentID = _data["parentID"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
            this.createdInCrm = _data["createdInCrm"];
            this.elavtalsserviceId = _data["elavtalsserviceId"];
            this.realEstateAgentId = _data["realEstateAgentId"];
            this.realEstateAgent = _data["realEstateAgent"] ? RealEstateAgentModel.fromJS(_data["realEstateAgent"]) : <any>undefined;
            this.realEstateOfficeId = _data["realEstateOfficeId"];
            this.realEstateOffice = _data["realEstateOffice"] ? RealEstateOfficeModel.fromJS(_data["realEstateOffice"]) : <any>undefined;
            this.realEstateChainId = _data["realEstateChainId"];
            this.realEstateChain = _data["realEstateChain"] ? RealEstateChainModel.fromJS(_data["realEstateChain"]) : <any>undefined;
            this.contactId = _data["contactId"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.offerId = _data["offerId"];
            this.club = _data["club"];
            this.team = _data["team"];
            this.salesData1 = _data["salesData1"];
            this.salesData2 = _data["salesData2"];
            this.salesData3 = _data["salesData3"];
            this.salesData4 = _data["salesData4"];
            this.salesDate = _data["salesDate"] ? moment(_data["salesDate"].toString()) : <any>undefined;
            this.objectId = _data["objectId"];
            this.objectChannel = _data["objectChannel"];
            this.objectCustomerId = _data["objectCustomerId"];
            this.objectStatus = _data["objectStatus"];
            this.objectStatusText = _data["objectStatusText"];
            this.lmvNumber = _data["lmvNumber"];
            this.internalPropertyNumber = _data["internalPropertyNumber"];
            this.signatureId = _data["signatureId"];
            this.signature = _data["signature"] ? Signature.fromJS(_data["signature"]) : <any>undefined;
            this.easyQuoteId = _data["easyQuoteId"];
            this.hasElectricity = _data["hasElectricity"];
            this.hasInsurance = _data["hasInsurance"];
            this.insuranceStatus = _data["insuranceStatus"];
            this.insuranceStatusDate = _data["insuranceStatusDate"] ? moment(_data["insuranceStatusDate"].toString()) : <any>undefined;
            this.hasMortgage = _data["hasMortgage"];
            this.mortgageStatus = _data["mortgageStatus"];
            this.mortgageStatusDate = _data["mortgageStatusDate"] ? moment(_data["mortgageStatusDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.completionType = _data["completionType"];
            this.completionId = _data["completionId"];
            this.completionContactTypeId = _data["completionContactTypeId"];
            this.completionContactFirstName = _data["completionContactFirstName"];
            this.completionContactLastName = _data["completionContactLastName"];
            this.completionSalesChannelName = _data["completionSalesChannelName"];
            this.insuranceReminderSent = _data["insuranceReminderSent"];
            this.notes = _data["notes"];
            this.customerType = _data["customerType"];
            (<any>this).auditEntityId = _data["auditEntityId"];
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pid"] = this.pid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["street"] = this.street;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["ean"] = this.ean;
        data["isCurrent"] = this.isCurrent;
        data["currentFirstName"] = this.currentFirstName;
        data["currentLastName"] = this.currentLastName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["housing"] = this.housing;
        data["area"] = this.area;
        data["consumption"] = this.consumption;
        data["channel"] = this.channel;
        data["status"] = this.status;
        data["ip"] = this.ip;
        data["salesperson"] = this.salesperson;
        data["externalID"] = this.externalID;
        data["parentID"] = this.parentID;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["createdInCrm"] = this.createdInCrm;
        data["elavtalsserviceId"] = this.elavtalsserviceId;
        data["realEstateAgentId"] = this.realEstateAgentId;
        data["realEstateAgent"] = this.realEstateAgent ? this.realEstateAgent.toJSON() : <any>undefined;
        data["realEstateOfficeId"] = this.realEstateOfficeId;
        data["realEstateOffice"] = this.realEstateOffice ? this.realEstateOffice.toJSON() : <any>undefined;
        data["realEstateChainId"] = this.realEstateChainId;
        data["realEstateChain"] = this.realEstateChain ? this.realEstateChain.toJSON() : <any>undefined;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["offerId"] = this.offerId;
        data["club"] = this.club;
        data["team"] = this.team;
        data["salesData1"] = this.salesData1;
        data["salesData2"] = this.salesData2;
        data["salesData3"] = this.salesData3;
        data["salesData4"] = this.salesData4;
        data["salesDate"] = this.salesDate ? this.salesDate.toISOString() : <any>undefined;
        data["objectId"] = this.objectId;
        data["objectChannel"] = this.objectChannel;
        data["objectCustomerId"] = this.objectCustomerId;
        data["objectStatus"] = this.objectStatus;
        data["objectStatusText"] = this.objectStatusText;
        data["lmvNumber"] = this.lmvNumber;
        data["internalPropertyNumber"] = this.internalPropertyNumber;
        data["signatureId"] = this.signatureId;
        data["signature"] = this.signature ? this.signature.toJSON() : <any>undefined;
        data["easyQuoteId"] = this.easyQuoteId;
        data["hasElectricity"] = this.hasElectricity;
        data["hasInsurance"] = this.hasInsurance;
        data["insuranceStatus"] = this.insuranceStatus;
        data["insuranceStatusDate"] = this.insuranceStatusDate ? this.insuranceStatusDate.toISOString() : <any>undefined;
        data["hasMortgage"] = this.hasMortgage;
        data["mortgageStatus"] = this.mortgageStatus;
        data["mortgageStatusDate"] = this.mortgageStatusDate ? this.mortgageStatusDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["completionType"] = this.completionType;
        data["completionId"] = this.completionId;
        data["completionContactTypeId"] = this.completionContactTypeId;
        data["completionContactFirstName"] = this.completionContactFirstName;
        data["completionContactLastName"] = this.completionContactLastName;
        data["completionSalesChannelName"] = this.completionSalesChannelName;
        data["insuranceReminderSent"] = this.insuranceReminderSent;
        data["notes"] = this.notes;
        data["customerType"] = this.customerType;
        data["auditEntityId"] = this.auditEntityId;
        return data;
    }
}

export interface IOrder {
    id?: number;
    pid?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    ean?: string | undefined;
    isCurrent?: boolean;
    currentFirstName?: string | undefined;
    currentLastName?: string | undefined;
    startDate?: moment.Moment;
    housing?: Housing;
    area?: number | undefined;
    consumption?: number | undefined;
    channel?: Channel;
    status?: Status;
    ip?: string | undefined;
    salesperson?: string | undefined;
    externalID?: string | undefined;
    parentID?: string | undefined;
    createdOn?: moment.Moment;
    modifiedOn?: moment.Moment;
    createdInCrm?: boolean;
    elavtalsserviceId?: string | undefined;
    realEstateAgentId?: string | undefined;
    realEstateAgent?: RealEstateAgentModel;
    realEstateOfficeId?: string | undefined;
    realEstateOffice?: RealEstateOfficeModel;
    realEstateChainId?: string | undefined;
    realEstateChain?: RealEstateChainModel;
    contactId?: string | undefined;
    contact?: Contact;
    offerId?: string | undefined;
    club?: string | undefined;
    team?: string | undefined;
    salesData1?: string | undefined;
    salesData2?: string | undefined;
    salesData3?: string | undefined;
    salesData4?: string | undefined;
    salesDate?: moment.Moment | undefined;
    objectId?: string | undefined;
    objectChannel?: RealEstateChannel;
    objectCustomerId?: string | undefined;
    objectStatus?: string | undefined;
    objectStatusText?: string | undefined;
    lmvNumber?: string | undefined;
    internalPropertyNumber?: string | undefined;
    signatureId?: string | undefined;
    signature?: Signature;
    easyQuoteId?: string | undefined;
    hasElectricity?: boolean;
    hasInsurance?: boolean;
    insuranceStatus?: AddOnStatus;
    insuranceStatusDate?: moment.Moment | undefined;
    hasMortgage?: boolean;
    mortgageStatus?: AddOnStatus;
    mortgageStatusDate?: moment.Moment | undefined;
    createdBy?: string | undefined;
    completionType?: CompletionType;
    completionId?: string | undefined;
    completionContactTypeId?: string | undefined;
    completionContactFirstName?: string | undefined;
    completionContactLastName?: string | undefined;
    completionSalesChannelName?: string | undefined;
    insuranceReminderSent?: boolean;
    notes?: string | undefined;
    customerType?: CustomerType;
    auditEntityId?: string | undefined;
}

export class SignInitiateRequest implements ISignInitiateRequest {
    order?: Order;

    constructor(data?: ISignInitiateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SignInitiateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignInitiateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISignInitiateRequest {
    order?: Order;
}

export class TokenResponse implements ITokenResponse {
    sentTo?: string | undefined;
    completed?: boolean;

    constructor(data?: ITokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sentTo = _data["sentTo"];
            this.completed = _data["completed"];
        }
    }

    static fromJS(data: any): TokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sentTo"] = this.sentTo;
        data["completed"] = this.completed;
        return data;
    }
}

export interface ITokenResponse {
    sentTo?: string | undefined;
    completed?: boolean;
}

export class AuthenticationResponse implements IAuthenticationResponse {
    token?: string | undefined;

    constructor(data?: IAuthenticationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): AuthenticationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IAuthenticationResponse {
    token?: string | undefined;
}

export class BankIdUiApiInitializeRequest implements IBankIdUiApiInitializeRequest {
    returnUrl!: string | undefined;
    uiOptions!: string | undefined;

    constructor(data?: IBankIdUiApiInitializeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnUrl = _data["returnUrl"];
            this.uiOptions = _data["uiOptions"];
        }
    }

    static fromJS(data: any): BankIdUiApiInitializeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BankIdUiApiInitializeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnUrl"] = this.returnUrl;
        data["uiOptions"] = this.uiOptions;
        return data;
    }
}

export interface IBankIdUiApiInitializeRequest {
    returnUrl: string | undefined;
    uiOptions: string | undefined;
}

export class BankIdUiApiInitializeResponse implements IBankIdUiApiInitializeResponse {
    readonly isAutoLaunch?: boolean;
    readonly deviceMightRequireUserInteractionToLaunchBankIdApp?: boolean;
    readonly checkStatus?: boolean;
    readonly orderRef?: string | undefined;
    readonly redirectUri?: string | undefined;
    qrStartState?: string | undefined;
    qrCodeAsBase64?: string | undefined;

    constructor(data?: IBankIdUiApiInitializeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isAutoLaunch = _data["isAutoLaunch"];
            (<any>this).deviceMightRequireUserInteractionToLaunchBankIdApp = _data["deviceMightRequireUserInteractionToLaunchBankIdApp"];
            (<any>this).checkStatus = _data["checkStatus"];
            (<any>this).orderRef = _data["orderRef"];
            (<any>this).redirectUri = _data["redirectUri"];
            this.qrStartState = _data["qrStartState"];
            this.qrCodeAsBase64 = _data["qrCodeAsBase64"];
        }
    }

    static fromJS(data: any): BankIdUiApiInitializeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BankIdUiApiInitializeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAutoLaunch"] = this.isAutoLaunch;
        data["deviceMightRequireUserInteractionToLaunchBankIdApp"] = this.deviceMightRequireUserInteractionToLaunchBankIdApp;
        data["checkStatus"] = this.checkStatus;
        data["orderRef"] = this.orderRef;
        data["redirectUri"] = this.redirectUri;
        data["qrStartState"] = this.qrStartState;
        data["qrCodeAsBase64"] = this.qrCodeAsBase64;
        return data;
    }
}

export interface IBankIdUiApiInitializeResponse {
    isAutoLaunch?: boolean;
    deviceMightRequireUserInteractionToLaunchBankIdApp?: boolean;
    checkStatus?: boolean;
    orderRef?: string | undefined;
    redirectUri?: string | undefined;
    qrStartState?: string | undefined;
    qrCodeAsBase64?: string | undefined;
}

export class BankIdUiApiStatusRequest implements IBankIdUiApiStatusRequest {
    orderRef!: string | undefined;
    returnUrl!: string | undefined;
    uiOptions!: string | undefined;
    autoStartAttempts?: number;

    constructor(data?: IBankIdUiApiStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderRef = _data["orderRef"];
            this.returnUrl = _data["returnUrl"];
            this.uiOptions = _data["uiOptions"];
            this.autoStartAttempts = _data["autoStartAttempts"];
        }
    }

    static fromJS(data: any): BankIdUiApiStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BankIdUiApiStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderRef"] = this.orderRef;
        data["returnUrl"] = this.returnUrl;
        data["uiOptions"] = this.uiOptions;
        data["autoStartAttempts"] = this.autoStartAttempts;
        return data;
    }
}

export interface IBankIdUiApiStatusRequest {
    orderRef: string | undefined;
    returnUrl: string | undefined;
    uiOptions: string | undefined;
    autoStartAttempts?: number;
}

export class BankIdUiApiQrCodeRequest implements IBankIdUiApiQrCodeRequest {
    qrStartState!: string | undefined;

    constructor(data?: IBankIdUiApiQrCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrStartState = _data["qrStartState"];
        }
    }

    static fromJS(data: any): BankIdUiApiQrCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BankIdUiApiQrCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrStartState"] = this.qrStartState;
        return data;
    }
}

export interface IBankIdUiApiQrCodeRequest {
    qrStartState: string | undefined;
}

export class BankIdUiApiCancelRequest implements IBankIdUiApiCancelRequest {
    uiOptions!: string | undefined;
    orderRef!: string | undefined;

    constructor(data?: IBankIdUiApiCancelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uiOptions = _data["uiOptions"];
            this.orderRef = _data["orderRef"];
        }
    }

    static fromJS(data: any): BankIdUiApiCancelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BankIdUiApiCancelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uiOptions"] = this.uiOptions;
        data["orderRef"] = this.orderRef;
        return data;
    }
}

export interface IBankIdUiApiCancelRequest {
    uiOptions: string | undefined;
    orderRef: string | undefined;
}

export class EasyLead implements IEasyLead {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    notes?: string | undefined;
    ip?: string | undefined;

    constructor(data?: IEasyLead) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.notes = _data["notes"];
            this.ip = _data["ip"];
        }
    }

    static fromJS(data: any): EasyLead {
        data = typeof data === 'object' ? data : {};
        let result = new EasyLead();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["notes"] = this.notes;
        data["ip"] = this.ip;
        return data;
    }
}

export interface IEasyLead {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    notes?: string | undefined;
    ip?: string | undefined;
}

export class EasyPriceResponse implements IEasyPriceResponse {
    name?: string | undefined;
    fixedPrice?: number;
    pricePerDelivery?: number;
    monthlyCostPerDelivery?: number;

    constructor(data?: IEasyPriceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.fixedPrice = _data["fixedPrice"];
            this.pricePerDelivery = _data["pricePerDelivery"];
            this.monthlyCostPerDelivery = _data["monthlyCostPerDelivery"];
        }
    }

    static fromJS(data: any): EasyPriceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EasyPriceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fixedPrice"] = this.fixedPrice;
        data["pricePerDelivery"] = this.pricePerDelivery;
        data["monthlyCostPerDelivery"] = this.monthlyCostPerDelivery;
        return data;
    }
}

export interface IEasyPriceResponse {
    name?: string | undefined;
    fixedPrice?: number;
    pricePerDelivery?: number;
    monthlyCostPerDelivery?: number;
}

export class VehicleModel implements IVehicleModel {
    id?: string | undefined;
    userId?: string | undefined;
    vendor?: string | undefined;
    lastSeen?: moment.Moment;
    isReachable?: boolean;
    vin?: string | undefined;
    brand?: string | undefined;
    model?: string | undefined;
    year?: number;
    batteryLevel?: number;
    range?: number;
    isPluggedIn?: boolean;
    isCharging?: boolean;
    isFullyCharged?: boolean;
    batteryCapacity?: number;
    chargeLimit?: number;
    chargeRate?: number;
    chargeRemainingTime?: number;
    chargeStateLastUpdated?: moment.Moment;
    maxCurrent?: number;
    powerDeliveryState?: string | undefined;
    smartChargingEnabled?: boolean;
    smartChargingDeadline?: string | undefined;
    smartChargingUpdatedAt?: moment.Moment | undefined;
    smartChargingVendor?: string | undefined;
    smartChargingState?: string | undefined;
    smartChargingStateChanged?: moment.Moment | undefined;
    smartChargingConsiderationIsPluggedIn?: boolean | undefined;
    smartChargingConsiderationIsCharging?: boolean | undefined;
    smartChargingConsiderationAtChargingLocation?: boolean | undefined;
    smartChargingConsiderationHasTimeEstimate?: boolean | undefined;
    smartChargingPlanCurrency?: string | undefined;
    smartChargingPlanNonSmartCost?: number | undefined;
    smartChargingPlanSmartCost?: number | undefined;
    smartChargingPlanStopAt?: moment.Moment | undefined;
    smartChargingPlanStartAt?: moment.Moment | undefined;
    smartChargingPlanEstimatedFinishAt?: moment.Moment | undefined;
    smartChargingPlanStopConfirmedAt?: moment.Moment | undefined;
    smartChargingPlanStartConfirmedAt?: moment.Moment | undefined;
    smartChargingPlanEndedAt?: moment.Moment | undefined;
    smartChargingPlanFinalState?: string | undefined;
    smartChargingPlanFailureCondition?: string | undefined;
    smartChargingPlanExternalStartCreatedAt?: moment.Moment | undefined;
    smartChargingPlanExternalStartEndedAt?: moment.Moment | undefined;
    smartChargingPlanExternalStartTargetType?: string | undefined;
    smartChargingPlanExternalStartTargetId?: string | undefined;
    smartChargingPlanExternalStartVendorActionId?: string | undefined;
    smartChargingPlanChargingLocationId?: string | undefined;
    smartChargingSmartOverrideCreatedAt?: moment.Moment | undefined;
    smartChargingSmartOverrideEndedAt?: moment.Moment | undefined;
    smartChargingSmartOverrideTargetType?: string | undefined;
    smartChargingSmartOverrideTargetId?: string | undefined;
    smartChargingSmartOverrideVendorActionId?: string | undefined;
    minimumChargeLimit?: number;
    longitude?: number;
    latitude?: number;
    locationLastUpdated?: moment.Moment;
    odometerDistance?: number;
    odometerLastUpdated?: moment.Moment;
    informationCapable?: boolean;
    informationInterventionIds?: string[] | undefined;
    chargeStateCapable?: boolean;
    chargeStateInterventionIds?: string[] | undefined;
    locationCapable?: boolean;
    locationInterventionIds?: string[] | undefined;
    odometerCapable?: boolean;
    odometerInterventionIds?: string[] | undefined;
    setMaxCurrentCapable?: boolean;
    setMaxCurrentInterventionIds?: string[] | undefined;
    startChargingCapable?: boolean;
    startChargingInterventionIds?: string[] | undefined;
    stopChargingCapable?: boolean;
    stopChargingInterventionIds?: string[] | undefined;
    smartChargingCapable?: boolean;
    smartChargingInterventionIds?: string[] | undefined;
    scopes?: string | undefined;
    locationId?: string | undefined;
    createdOn?: moment.Moment;
    updatedOn?: moment.Moment;
    deleted?: boolean;
    reliability?: string | undefined;
    credentialsInvalidated?: boolean;

    constructor(data?: IVehicleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.vendor = _data["vendor"];
            this.lastSeen = _data["lastSeen"] ? moment(_data["lastSeen"].toString()) : <any>undefined;
            this.isReachable = _data["isReachable"];
            this.vin = _data["vin"];
            this.brand = _data["brand"];
            this.model = _data["model"];
            this.year = _data["year"];
            this.batteryLevel = _data["batteryLevel"];
            this.range = _data["range"];
            this.isPluggedIn = _data["isPluggedIn"];
            this.isCharging = _data["isCharging"];
            this.isFullyCharged = _data["isFullyCharged"];
            this.batteryCapacity = _data["batteryCapacity"];
            this.chargeLimit = _data["chargeLimit"];
            this.chargeRate = _data["chargeRate"];
            this.chargeRemainingTime = _data["chargeRemainingTime"];
            this.chargeStateLastUpdated = _data["chargeStateLastUpdated"] ? moment(_data["chargeStateLastUpdated"].toString()) : <any>undefined;
            this.maxCurrent = _data["maxCurrent"];
            this.powerDeliveryState = _data["powerDeliveryState"];
            this.smartChargingEnabled = _data["smartChargingEnabled"];
            this.smartChargingDeadline = _data["smartChargingDeadline"];
            this.smartChargingUpdatedAt = _data["smartChargingUpdatedAt"] ? moment(_data["smartChargingUpdatedAt"].toString()) : <any>undefined;
            this.smartChargingVendor = _data["smartChargingVendor"];
            this.smartChargingState = _data["smartChargingState"];
            this.smartChargingStateChanged = _data["smartChargingStateChanged"] ? moment(_data["smartChargingStateChanged"].toString()) : <any>undefined;
            this.smartChargingConsiderationIsPluggedIn = _data["smartChargingConsiderationIsPluggedIn"];
            this.smartChargingConsiderationIsCharging = _data["smartChargingConsiderationIsCharging"];
            this.smartChargingConsiderationAtChargingLocation = _data["smartChargingConsiderationAtChargingLocation"];
            this.smartChargingConsiderationHasTimeEstimate = _data["smartChargingConsiderationHasTimeEstimate"];
            this.smartChargingPlanCurrency = _data["smartChargingPlanCurrency"];
            this.smartChargingPlanNonSmartCost = _data["smartChargingPlanNonSmartCost"];
            this.smartChargingPlanSmartCost = _data["smartChargingPlanSmartCost"];
            this.smartChargingPlanStopAt = _data["smartChargingPlanStopAt"] ? moment(_data["smartChargingPlanStopAt"].toString()) : <any>undefined;
            this.smartChargingPlanStartAt = _data["smartChargingPlanStartAt"] ? moment(_data["smartChargingPlanStartAt"].toString()) : <any>undefined;
            this.smartChargingPlanEstimatedFinishAt = _data["smartChargingPlanEstimatedFinishAt"] ? moment(_data["smartChargingPlanEstimatedFinishAt"].toString()) : <any>undefined;
            this.smartChargingPlanStopConfirmedAt = _data["smartChargingPlanStopConfirmedAt"] ? moment(_data["smartChargingPlanStopConfirmedAt"].toString()) : <any>undefined;
            this.smartChargingPlanStartConfirmedAt = _data["smartChargingPlanStartConfirmedAt"] ? moment(_data["smartChargingPlanStartConfirmedAt"].toString()) : <any>undefined;
            this.smartChargingPlanEndedAt = _data["smartChargingPlanEndedAt"] ? moment(_data["smartChargingPlanEndedAt"].toString()) : <any>undefined;
            this.smartChargingPlanFinalState = _data["smartChargingPlanFinalState"];
            this.smartChargingPlanFailureCondition = _data["smartChargingPlanFailureCondition"];
            this.smartChargingPlanExternalStartCreatedAt = _data["smartChargingPlanExternalStartCreatedAt"] ? moment(_data["smartChargingPlanExternalStartCreatedAt"].toString()) : <any>undefined;
            this.smartChargingPlanExternalStartEndedAt = _data["smartChargingPlanExternalStartEndedAt"] ? moment(_data["smartChargingPlanExternalStartEndedAt"].toString()) : <any>undefined;
            this.smartChargingPlanExternalStartTargetType = _data["smartChargingPlanExternalStartTargetType"];
            this.smartChargingPlanExternalStartTargetId = _data["smartChargingPlanExternalStartTargetId"];
            this.smartChargingPlanExternalStartVendorActionId = _data["smartChargingPlanExternalStartVendorActionId"];
            this.smartChargingPlanChargingLocationId = _data["smartChargingPlanChargingLocationId"];
            this.smartChargingSmartOverrideCreatedAt = _data["smartChargingSmartOverrideCreatedAt"] ? moment(_data["smartChargingSmartOverrideCreatedAt"].toString()) : <any>undefined;
            this.smartChargingSmartOverrideEndedAt = _data["smartChargingSmartOverrideEndedAt"] ? moment(_data["smartChargingSmartOverrideEndedAt"].toString()) : <any>undefined;
            this.smartChargingSmartOverrideTargetType = _data["smartChargingSmartOverrideTargetType"];
            this.smartChargingSmartOverrideTargetId = _data["smartChargingSmartOverrideTargetId"];
            this.smartChargingSmartOverrideVendorActionId = _data["smartChargingSmartOverrideVendorActionId"];
            this.minimumChargeLimit = _data["minimumChargeLimit"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.locationLastUpdated = _data["locationLastUpdated"] ? moment(_data["locationLastUpdated"].toString()) : <any>undefined;
            this.odometerDistance = _data["odometerDistance"];
            this.odometerLastUpdated = _data["odometerLastUpdated"] ? moment(_data["odometerLastUpdated"].toString()) : <any>undefined;
            this.informationCapable = _data["informationCapable"];
            if (Array.isArray(_data["informationInterventionIds"])) {
                this.informationInterventionIds = [] as any;
                for (let item of _data["informationInterventionIds"])
                    this.informationInterventionIds!.push(item);
            }
            this.chargeStateCapable = _data["chargeStateCapable"];
            if (Array.isArray(_data["chargeStateInterventionIds"])) {
                this.chargeStateInterventionIds = [] as any;
                for (let item of _data["chargeStateInterventionIds"])
                    this.chargeStateInterventionIds!.push(item);
            }
            this.locationCapable = _data["locationCapable"];
            if (Array.isArray(_data["locationInterventionIds"])) {
                this.locationInterventionIds = [] as any;
                for (let item of _data["locationInterventionIds"])
                    this.locationInterventionIds!.push(item);
            }
            this.odometerCapable = _data["odometerCapable"];
            if (Array.isArray(_data["odometerInterventionIds"])) {
                this.odometerInterventionIds = [] as any;
                for (let item of _data["odometerInterventionIds"])
                    this.odometerInterventionIds!.push(item);
            }
            this.setMaxCurrentCapable = _data["setMaxCurrentCapable"];
            if (Array.isArray(_data["setMaxCurrentInterventionIds"])) {
                this.setMaxCurrentInterventionIds = [] as any;
                for (let item of _data["setMaxCurrentInterventionIds"])
                    this.setMaxCurrentInterventionIds!.push(item);
            }
            this.startChargingCapable = _data["startChargingCapable"];
            if (Array.isArray(_data["startChargingInterventionIds"])) {
                this.startChargingInterventionIds = [] as any;
                for (let item of _data["startChargingInterventionIds"])
                    this.startChargingInterventionIds!.push(item);
            }
            this.stopChargingCapable = _data["stopChargingCapable"];
            if (Array.isArray(_data["stopChargingInterventionIds"])) {
                this.stopChargingInterventionIds = [] as any;
                for (let item of _data["stopChargingInterventionIds"])
                    this.stopChargingInterventionIds!.push(item);
            }
            this.smartChargingCapable = _data["smartChargingCapable"];
            if (Array.isArray(_data["smartChargingInterventionIds"])) {
                this.smartChargingInterventionIds = [] as any;
                for (let item of _data["smartChargingInterventionIds"])
                    this.smartChargingInterventionIds!.push(item);
            }
            this.scopes = _data["scopes"];
            this.locationId = _data["locationId"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.reliability = _data["reliability"];
            this.credentialsInvalidated = _data["credentialsInvalidated"];
        }
    }

    static fromJS(data: any): VehicleModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["vendor"] = this.vendor;
        data["lastSeen"] = this.lastSeen ? this.lastSeen.toISOString() : <any>undefined;
        data["isReachable"] = this.isReachable;
        data["vin"] = this.vin;
        data["brand"] = this.brand;
        data["model"] = this.model;
        data["year"] = this.year;
        data["batteryLevel"] = this.batteryLevel;
        data["range"] = this.range;
        data["isPluggedIn"] = this.isPluggedIn;
        data["isCharging"] = this.isCharging;
        data["isFullyCharged"] = this.isFullyCharged;
        data["batteryCapacity"] = this.batteryCapacity;
        data["chargeLimit"] = this.chargeLimit;
        data["chargeRate"] = this.chargeRate;
        data["chargeRemainingTime"] = this.chargeRemainingTime;
        data["chargeStateLastUpdated"] = this.chargeStateLastUpdated ? this.chargeStateLastUpdated.toISOString() : <any>undefined;
        data["maxCurrent"] = this.maxCurrent;
        data["powerDeliveryState"] = this.powerDeliveryState;
        data["smartChargingEnabled"] = this.smartChargingEnabled;
        data["smartChargingDeadline"] = this.smartChargingDeadline;
        data["smartChargingUpdatedAt"] = this.smartChargingUpdatedAt ? this.smartChargingUpdatedAt.toISOString() : <any>undefined;
        data["smartChargingVendor"] = this.smartChargingVendor;
        data["smartChargingState"] = this.smartChargingState;
        data["smartChargingStateChanged"] = this.smartChargingStateChanged ? this.smartChargingStateChanged.toISOString() : <any>undefined;
        data["smartChargingConsiderationIsPluggedIn"] = this.smartChargingConsiderationIsPluggedIn;
        data["smartChargingConsiderationIsCharging"] = this.smartChargingConsiderationIsCharging;
        data["smartChargingConsiderationAtChargingLocation"] = this.smartChargingConsiderationAtChargingLocation;
        data["smartChargingConsiderationHasTimeEstimate"] = this.smartChargingConsiderationHasTimeEstimate;
        data["smartChargingPlanCurrency"] = this.smartChargingPlanCurrency;
        data["smartChargingPlanNonSmartCost"] = this.smartChargingPlanNonSmartCost;
        data["smartChargingPlanSmartCost"] = this.smartChargingPlanSmartCost;
        data["smartChargingPlanStopAt"] = this.smartChargingPlanStopAt ? this.smartChargingPlanStopAt.toISOString() : <any>undefined;
        data["smartChargingPlanStartAt"] = this.smartChargingPlanStartAt ? this.smartChargingPlanStartAt.toISOString() : <any>undefined;
        data["smartChargingPlanEstimatedFinishAt"] = this.smartChargingPlanEstimatedFinishAt ? this.smartChargingPlanEstimatedFinishAt.toISOString() : <any>undefined;
        data["smartChargingPlanStopConfirmedAt"] = this.smartChargingPlanStopConfirmedAt ? this.smartChargingPlanStopConfirmedAt.toISOString() : <any>undefined;
        data["smartChargingPlanStartConfirmedAt"] = this.smartChargingPlanStartConfirmedAt ? this.smartChargingPlanStartConfirmedAt.toISOString() : <any>undefined;
        data["smartChargingPlanEndedAt"] = this.smartChargingPlanEndedAt ? this.smartChargingPlanEndedAt.toISOString() : <any>undefined;
        data["smartChargingPlanFinalState"] = this.smartChargingPlanFinalState;
        data["smartChargingPlanFailureCondition"] = this.smartChargingPlanFailureCondition;
        data["smartChargingPlanExternalStartCreatedAt"] = this.smartChargingPlanExternalStartCreatedAt ? this.smartChargingPlanExternalStartCreatedAt.toISOString() : <any>undefined;
        data["smartChargingPlanExternalStartEndedAt"] = this.smartChargingPlanExternalStartEndedAt ? this.smartChargingPlanExternalStartEndedAt.toISOString() : <any>undefined;
        data["smartChargingPlanExternalStartTargetType"] = this.smartChargingPlanExternalStartTargetType;
        data["smartChargingPlanExternalStartTargetId"] = this.smartChargingPlanExternalStartTargetId;
        data["smartChargingPlanExternalStartVendorActionId"] = this.smartChargingPlanExternalStartVendorActionId;
        data["smartChargingPlanChargingLocationId"] = this.smartChargingPlanChargingLocationId;
        data["smartChargingSmartOverrideCreatedAt"] = this.smartChargingSmartOverrideCreatedAt ? this.smartChargingSmartOverrideCreatedAt.toISOString() : <any>undefined;
        data["smartChargingSmartOverrideEndedAt"] = this.smartChargingSmartOverrideEndedAt ? this.smartChargingSmartOverrideEndedAt.toISOString() : <any>undefined;
        data["smartChargingSmartOverrideTargetType"] = this.smartChargingSmartOverrideTargetType;
        data["smartChargingSmartOverrideTargetId"] = this.smartChargingSmartOverrideTargetId;
        data["smartChargingSmartOverrideVendorActionId"] = this.smartChargingSmartOverrideVendorActionId;
        data["minimumChargeLimit"] = this.minimumChargeLimit;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["locationLastUpdated"] = this.locationLastUpdated ? this.locationLastUpdated.toISOString() : <any>undefined;
        data["odometerDistance"] = this.odometerDistance;
        data["odometerLastUpdated"] = this.odometerLastUpdated ? this.odometerLastUpdated.toISOString() : <any>undefined;
        data["informationCapable"] = this.informationCapable;
        if (Array.isArray(this.informationInterventionIds)) {
            data["informationInterventionIds"] = [];
            for (let item of this.informationInterventionIds)
                data["informationInterventionIds"].push(item);
        }
        data["chargeStateCapable"] = this.chargeStateCapable;
        if (Array.isArray(this.chargeStateInterventionIds)) {
            data["chargeStateInterventionIds"] = [];
            for (let item of this.chargeStateInterventionIds)
                data["chargeStateInterventionIds"].push(item);
        }
        data["locationCapable"] = this.locationCapable;
        if (Array.isArray(this.locationInterventionIds)) {
            data["locationInterventionIds"] = [];
            for (let item of this.locationInterventionIds)
                data["locationInterventionIds"].push(item);
        }
        data["odometerCapable"] = this.odometerCapable;
        if (Array.isArray(this.odometerInterventionIds)) {
            data["odometerInterventionIds"] = [];
            for (let item of this.odometerInterventionIds)
                data["odometerInterventionIds"].push(item);
        }
        data["setMaxCurrentCapable"] = this.setMaxCurrentCapable;
        if (Array.isArray(this.setMaxCurrentInterventionIds)) {
            data["setMaxCurrentInterventionIds"] = [];
            for (let item of this.setMaxCurrentInterventionIds)
                data["setMaxCurrentInterventionIds"].push(item);
        }
        data["startChargingCapable"] = this.startChargingCapable;
        if (Array.isArray(this.startChargingInterventionIds)) {
            data["startChargingInterventionIds"] = [];
            for (let item of this.startChargingInterventionIds)
                data["startChargingInterventionIds"].push(item);
        }
        data["stopChargingCapable"] = this.stopChargingCapable;
        if (Array.isArray(this.stopChargingInterventionIds)) {
            data["stopChargingInterventionIds"] = [];
            for (let item of this.stopChargingInterventionIds)
                data["stopChargingInterventionIds"].push(item);
        }
        data["smartChargingCapable"] = this.smartChargingCapable;
        if (Array.isArray(this.smartChargingInterventionIds)) {
            data["smartChargingInterventionIds"] = [];
            for (let item of this.smartChargingInterventionIds)
                data["smartChargingInterventionIds"].push(item);
        }
        data["scopes"] = this.scopes;
        data["locationId"] = this.locationId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["reliability"] = this.reliability;
        data["credentialsInvalidated"] = this.credentialsInvalidated;
        return data;
    }
}

export interface IVehicleModel {
    id?: string | undefined;
    userId?: string | undefined;
    vendor?: string | undefined;
    lastSeen?: moment.Moment;
    isReachable?: boolean;
    vin?: string | undefined;
    brand?: string | undefined;
    model?: string | undefined;
    year?: number;
    batteryLevel?: number;
    range?: number;
    isPluggedIn?: boolean;
    isCharging?: boolean;
    isFullyCharged?: boolean;
    batteryCapacity?: number;
    chargeLimit?: number;
    chargeRate?: number;
    chargeRemainingTime?: number;
    chargeStateLastUpdated?: moment.Moment;
    maxCurrent?: number;
    powerDeliveryState?: string | undefined;
    smartChargingEnabled?: boolean;
    smartChargingDeadline?: string | undefined;
    smartChargingUpdatedAt?: moment.Moment | undefined;
    smartChargingVendor?: string | undefined;
    smartChargingState?: string | undefined;
    smartChargingStateChanged?: moment.Moment | undefined;
    smartChargingConsiderationIsPluggedIn?: boolean | undefined;
    smartChargingConsiderationIsCharging?: boolean | undefined;
    smartChargingConsiderationAtChargingLocation?: boolean | undefined;
    smartChargingConsiderationHasTimeEstimate?: boolean | undefined;
    smartChargingPlanCurrency?: string | undefined;
    smartChargingPlanNonSmartCost?: number | undefined;
    smartChargingPlanSmartCost?: number | undefined;
    smartChargingPlanStopAt?: moment.Moment | undefined;
    smartChargingPlanStartAt?: moment.Moment | undefined;
    smartChargingPlanEstimatedFinishAt?: moment.Moment | undefined;
    smartChargingPlanStopConfirmedAt?: moment.Moment | undefined;
    smartChargingPlanStartConfirmedAt?: moment.Moment | undefined;
    smartChargingPlanEndedAt?: moment.Moment | undefined;
    smartChargingPlanFinalState?: string | undefined;
    smartChargingPlanFailureCondition?: string | undefined;
    smartChargingPlanExternalStartCreatedAt?: moment.Moment | undefined;
    smartChargingPlanExternalStartEndedAt?: moment.Moment | undefined;
    smartChargingPlanExternalStartTargetType?: string | undefined;
    smartChargingPlanExternalStartTargetId?: string | undefined;
    smartChargingPlanExternalStartVendorActionId?: string | undefined;
    smartChargingPlanChargingLocationId?: string | undefined;
    smartChargingSmartOverrideCreatedAt?: moment.Moment | undefined;
    smartChargingSmartOverrideEndedAt?: moment.Moment | undefined;
    smartChargingSmartOverrideTargetType?: string | undefined;
    smartChargingSmartOverrideTargetId?: string | undefined;
    smartChargingSmartOverrideVendorActionId?: string | undefined;
    minimumChargeLimit?: number;
    longitude?: number;
    latitude?: number;
    locationLastUpdated?: moment.Moment;
    odometerDistance?: number;
    odometerLastUpdated?: moment.Moment;
    informationCapable?: boolean;
    informationInterventionIds?: string[] | undefined;
    chargeStateCapable?: boolean;
    chargeStateInterventionIds?: string[] | undefined;
    locationCapable?: boolean;
    locationInterventionIds?: string[] | undefined;
    odometerCapable?: boolean;
    odometerInterventionIds?: string[] | undefined;
    setMaxCurrentCapable?: boolean;
    setMaxCurrentInterventionIds?: string[] | undefined;
    startChargingCapable?: boolean;
    startChargingInterventionIds?: string[] | undefined;
    stopChargingCapable?: boolean;
    stopChargingInterventionIds?: string[] | undefined;
    smartChargingCapable?: boolean;
    smartChargingInterventionIds?: string[] | undefined;
    scopes?: string | undefined;
    locationId?: string | undefined;
    createdOn?: moment.Moment;
    updatedOn?: moment.Moment;
    deleted?: boolean;
    reliability?: string | undefined;
    credentialsInvalidated?: boolean;
}

export class SmartChargingResponse implements ISmartChargingResponse {
    enabled?: boolean;
    deadline?: string | undefined;
    minimumChargeLimit?: number;

    constructor(data?: ISmartChargingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.deadline = _data["deadline"];
            this.minimumChargeLimit = _data["minimumChargeLimit"];
        }
    }

    static fromJS(data: any): SmartChargingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SmartChargingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["deadline"] = this.deadline;
        data["minimumChargeLimit"] = this.minimumChargeLimit;
        return data;
    }
}

export interface ISmartChargingResponse {
    enabled?: boolean;
    deadline?: string | undefined;
    minimumChargeLimit?: number;
}

export class SmartChargingOverrideResponse implements ISmartChargingOverrideResponse {
    createdAt?: moment.Moment;
    endedAt?: moment.Moment;
    targetType?: string | undefined;
    targetId?: string | undefined;
    vendorActionId?: string;
    userId?: string | undefined;
    vendor?: string | undefined;

    constructor(data?: ISmartChargingOverrideResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>undefined;
            this.endedAt = _data["endedAt"] ? moment(_data["endedAt"].toString()) : <any>undefined;
            this.targetType = _data["targetType"];
            this.targetId = _data["targetId"];
            this.vendorActionId = _data["vendorActionId"];
            this.userId = _data["userId"];
            this.vendor = _data["vendor"];
        }
    }

    static fromJS(data: any): SmartChargingOverrideResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SmartChargingOverrideResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["endedAt"] = this.endedAt ? this.endedAt.toISOString() : <any>undefined;
        data["targetType"] = this.targetType;
        data["targetId"] = this.targetId;
        data["vendorActionId"] = this.vendorActionId;
        data["userId"] = this.userId;
        data["vendor"] = this.vendor;
        return data;
    }
}

export interface ISmartChargingOverrideResponse {
    createdAt?: moment.Moment;
    endedAt?: moment.Moment;
    targetType?: string | undefined;
    targetId?: string | undefined;
    vendorActionId?: string;
    userId?: string | undefined;
    vendor?: string | undefined;
}

export class EnodeLinkResult implements IEnodeLinkResult {
    url?: string | undefined;
    accessToken?: string | undefined;
    userId?: string | undefined;

    constructor(data?: IEnodeLinkResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.accessToken = _data["accessToken"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): EnodeLinkResult {
        data = typeof data === 'object' ? data : {};
        let result = new EnodeLinkResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["accessToken"] = this.accessToken;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IEnodeLinkResult {
    url?: string | undefined;
    accessToken?: string | undefined;
    userId?: string | undefined;
}

export enum BatteryVendor {
    TESLA = "TESLA",
    ENPHASE = "ENPHASE",
}

export enum ChargerVendor {
    ZAPTEC = "ZAPTEC",
    EASEE = "EASEE",
    WALLBOX = "WALLBOX",
    EO = "EO",
    CHARGEAMPS = "CHARGEAMPS",
    EVBOX = "EVBOX",
    GOE = "GOE",
    FRONIUS = "FRONIUS",
    CHARGEPOINT = "CHARGEPOINT",
    ENELX = "ENELX",
    TESLA = "TESLA",
}

export enum HvacVendor {
    TADO = "TADO",
    MILL = "MILL",
    ADAX = "ADAX",
    ECOBEE = "ECOBEE",
    SENSIBO = "SENSIBO",
    HONEYWELL = "HONEYWELL",
    RESIDEO = "RESIDEO",
    MITSUBISHI = "MITSUBISHI",
    MICROMATIC = "MICROMATIC",
    NIBE = "NIBE",
    PANASONIC = "PANASONIC",
    TOSHIBA = "TOSHIBA",
    DAIKIN = "DAIKIN",
    NEST = "NEST",
    FUJITSU = "FUJITSU",
    BOSCH = "BOSCH",
    NETATMO = "NETATMO",
}

export enum InverterVendor {
    APSYSTEMS = "APSYSTEMS",
    CSISolar = "CSISolar",
    Deye = "Deye",
    ENPHASE = "ENPHASE",
    FOXESS = "FOXESS",
    FRONIUS = "FRONIUS",
    GOODWE = "GOODWE",
    GROWATT = "GROWATT",
    Hoymiles = "Hoymiles",
    HUAWEI = "HUAWEI",
    INVT = "INVT",
    SMA = "SMA",
    SOFAR = "SOFAR",
    SOLAREDGE = "SOLAREDGE",
    SOLARK = "SOLARK",
    SOLAX = "SOLAX",
    SOLIS = "SOLIS",
    SOLPLANET = "SOLPLANET",
    SUNGROW = "SUNGROW",
    SUNSYNK = "SUNSYNK",
    TESLA = "TESLA",
    TSUN = "TSUN",
}

export enum MeterVendor {
    ENPHASE = "ENPHASE",
    TESLA = "TESLA",
}

export enum VehicleVendor {
    AUDI = "AUDI",
    BMW = "BMW",
    HONDA = "HONDA",
    HYUNDAI = "HYUNDAI",
    JAGUAR = "JAGUAR",
    LANDROVER = "LANDROVER",
    KIA = "KIA",
    MERCEDES = "MERCEDES",
    MINI = "MINI",
    NISSAN = "NISSAN",
    PEUGEOT = "PEUGEOT",
    PORSCHE = "PORSCHE",
    RENAULT = "RENAULT",
    SEAT = "SEAT",
    SKODA = "SKODA",
    TESLA = "TESLA",
    VOLKSWAGEN = "VOLKSWAGEN",
    VOLVO = "VOLVO",
    FORD = "FORD",
    OPEL = "OPEL",
    DS = "DS",
    TOYOTA = "TOYOTA",
    LEXUS = "LEXUS",
    CITROEN = "CITROEN",
    CUPRA = "CUPRA",
    VAUXHALL = "VAUXHALL",
    FIAT = "FIAT",
    RIVIAN = "RIVIAN",
    NIO = "NIO",
    CHEVROLET = "CHEVROLET",
    GMC = "GMC",
    CADILLAC = "CADILLAC",
    XPENG = "XPENG",
}

export class UserResponse_linkedVendors_vendor implements IUserResponse_linkedVendors_vendor {
    batteryVendor?: BatteryVendor;
    chargerVendor?: ChargerVendor;
    hvacVendor?: HvacVendor;
    inverterVendor?: InverterVendor;
    meterVendor?: MeterVendor;
    vehicleVendor?: VehicleVendor;

    constructor(data?: IUserResponse_linkedVendors_vendor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batteryVendor = _data["batteryVendor"];
            this.chargerVendor = _data["chargerVendor"];
            this.hvacVendor = _data["hvacVendor"];
            this.inverterVendor = _data["inverterVendor"];
            this.meterVendor = _data["meterVendor"];
            this.vehicleVendor = _data["vehicleVendor"];
        }
    }

    static fromJS(data: any): UserResponse_linkedVendors_vendor {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponse_linkedVendors_vendor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batteryVendor"] = this.batteryVendor;
        data["chargerVendor"] = this.chargerVendor;
        data["hvacVendor"] = this.hvacVendor;
        data["inverterVendor"] = this.inverterVendor;
        data["meterVendor"] = this.meterVendor;
        data["vehicleVendor"] = this.vehicleVendor;
        return data;
    }
}

export interface IUserResponse_linkedVendors_vendor {
    batteryVendor?: BatteryVendor;
    chargerVendor?: ChargerVendor;
    hvacVendor?: HvacVendor;
    inverterVendor?: InverterVendor;
    meterVendor?: MeterVendor;
    vehicleVendor?: VehicleVendor;
}

export enum VendorType {
    Vehicle = "vehicle",
    Charger = "charger",
    Hvac = "hvac",
    Inverter = "inverter",
    Battery = "battery",
    Meter = "meter",
}

export class UserResponse_linkedVendors implements IUserResponse_linkedVendors {
    isValid?: boolean | undefined;
    vendor?: UserResponse_linkedVendors_vendor;
    vendorType?: VendorType;

    constructor(data?: IUserResponse_linkedVendors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.vendor = _data["vendor"] ? UserResponse_linkedVendors_vendor.fromJS(_data["vendor"]) : <any>undefined;
            this.vendorType = _data["vendorType"];
        }
    }

    static fromJS(data: any): UserResponse_linkedVendors {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponse_linkedVendors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["vendorType"] = this.vendorType;
        return data;
    }
}

export interface IUserResponse_linkedVendors {
    isValid?: boolean | undefined;
    vendor?: UserResponse_linkedVendors_vendor;
    vendorType?: VendorType;
}

export class UserResponse implements IUserResponse {
    id?: string | undefined;
    linkedVendors?: UserResponse_linkedVendors[] | undefined;

    constructor(data?: IUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["linkedVendors"])) {
                this.linkedVendors = [] as any;
                for (let item of _data["linkedVendors"])
                    this.linkedVendors!.push(UserResponse_linkedVendors.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.linkedVendors)) {
            data["linkedVendors"] = [];
            for (let item of this.linkedVendors)
                data["linkedVendors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserResponse {
    id?: string | undefined;
    linkedVendors?: UserResponse_linkedVendors[] | undefined;
}

export class Location implements ILocation {
    id?: string;
    userId?: string | undefined;
    name?: string | undefined;
    latitude?: number;
    longitude?: number;
    timeZoneName?: string | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.timeZoneName = _data["timeZoneName"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["timeZoneName"] = this.timeZoneName;
        return data;
    }
}

export interface ILocation {
    id?: string;
    userId?: string | undefined;
    name?: string | undefined;
    latitude?: number;
    longitude?: number;
    timeZoneName?: string | undefined;
}

export enum BatteryBrand {
    Tesla = "Tesla",
    Enphase = "Enphase",
}

export enum ChargerBrand {
    Zaptec = "Zaptec",
    Easee = "Easee",
    Wallbox = "Wallbox",
    EO = "EO",
    EVBox = "EVBox",
    Charge_Amps = "Charge Amps",
    GoE = "go-e",
    Fronius = "Fronius",
    ChargePoint = "ChargePoint",
    Enel_X = "Enel X",
    Tesla = "Tesla",
}

export enum HvacBrand {
    Tado = "Tado",
    Mill = "Mill",
    ADAX = "ADAX",
    Ecobee = "Ecobee",
    Sensibo = "Sensibo",
    Honeywell_TCC = "Honeywell TCC",
    Resideo = "Resideo",
    Mitsubishi = "Mitsubishi",
    Micro_Matic = "Micro Matic",
    NIBE = "NIBE",
    Panasonic = "Panasonic",
    Toshiba = "Toshiba",
    DAIKIN = "DAIKIN",
    Nest = "Nest",
    Fujitsu = "Fujitsu",
    Bosch = "Bosch",
    Netatmo = "Netatmo",
}

export enum InverterBrand {
    APsystems = "APsystems",
    CSISolar = "CSISolar",
    Deye = "Deye",
    Enphase = "Enphase",
    FOXESS = "FOXESS",
    Fronius = "Fronius",
    GoodWe = "GoodWe",
    Growatt = "Growatt",
    Hoymiles = "Hoymiles",
    Huawei = "Huawei",
    INVT = "INVT",
    SMA = "SMA",
    Sofar = "Sofar",
    SolarEdge = "SolarEdge",
    SolArk = "SolArk",
    Solax = "Solax",
    Solis = "Solis",
    Solplanet = "Solplanet",
    Sungrow = "Sungrow",
    SUNSYNK = "SUNSYNK",
    Tesla = "Tesla",
    TSUN = "TSUN",
}

export enum MeterBrand {
    Enphase = "Enphase",
    Tesla = "Tesla",
}

export enum VehicleBrand {
    Audi = "Audi",
    BMW = "BMW",
    Honda = "Honda",
    Hyundai = "Hyundai",
    Jaguar = "Jaguar",
    Land_Rover = "Land Rover",
    Kia = "Kia",
    Mercedes = "Mercedes",
    MINI = "MINI",
    Nissan = "Nissan",
    Peugeot = "Peugeot",
    Porsche = "Porsche",
    Renault = "Renault",
    SEAT = "SEAT",
    ŠKODA = "ŠKODA",
    Tesla = "Tesla",
    Volkswagen = "Volkswagen",
    Volvo = "Volvo",
    Ford = "Ford",
    Opel = "Opel",
    DS = "DS",
    Toyota = "Toyota",
    Lexus = "Lexus",
    Citroën = "Citroën",
    Cupra = "Cupra",
    Vauxhall = "Vauxhall",
    Fiat = "Fiat",
    Rivian = "Rivian",
    Nio = "Nio",
    Chevrolet = "Chevrolet",
    GMC = "GMC",
    Cadillac = "Cadillac",
    XPENG = "XPENG",
}

export class Intervention_brand implements IIntervention_brand {
    batteryBrand?: BatteryBrand;
    chargerBrand?: ChargerBrand;
    hvacBrand?: HvacBrand;
    inverterBrand?: InverterBrand;
    meterBrand?: MeterBrand;
    vehicleBrand?: VehicleBrand;

    constructor(data?: IIntervention_brand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batteryBrand = _data["batteryBrand"];
            this.chargerBrand = _data["chargerBrand"];
            this.hvacBrand = _data["hvacBrand"];
            this.inverterBrand = _data["inverterBrand"];
            this.meterBrand = _data["meterBrand"];
            this.vehicleBrand = _data["vehicleBrand"];
        }
    }

    static fromJS(data: any): Intervention_brand {
        data = typeof data === 'object' ? data : {};
        let result = new Intervention_brand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batteryBrand"] = this.batteryBrand;
        data["chargerBrand"] = this.chargerBrand;
        data["hvacBrand"] = this.hvacBrand;
        data["inverterBrand"] = this.inverterBrand;
        data["meterBrand"] = this.meterBrand;
        data["vehicleBrand"] = this.vehicleBrand;
        return data;
    }
}

export interface IIntervention_brand {
    batteryBrand?: BatteryBrand;
    chargerBrand?: ChargerBrand;
    hvacBrand?: HvacBrand;
    inverterBrand?: InverterBrand;
    meterBrand?: MeterBrand;
    vehicleBrand?: VehicleBrand;
}

export enum Intervention_domain {
    Account = "Account",
    Device = "Device",
}

export enum Intervention_resolution_access {
    Remote = "Remote",
    Physical = "Physical",
}

export enum Intervention_resolution_agent {
    User = "User",
    ThirdParty = "ThirdParty",
}

export class Intervention_resolution implements IIntervention_resolution {
    access?: Intervention_resolution_access;
    agent?: Intervention_resolution_agent;
    description?: string | undefined;
    title?: string | undefined;

    constructor(data?: IIntervention_resolution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access = _data["access"];
            this.agent = _data["agent"];
            this.description = _data["description"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): Intervention_resolution {
        data = typeof data === 'object' ? data : {};
        let result = new Intervention_resolution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access"] = this.access;
        data["agent"] = this.agent;
        data["description"] = this.description;
        data["title"] = this.title;
        return data;
    }
}

export interface IIntervention_resolution {
    access?: Intervention_resolution_access;
    agent?: Intervention_resolution_agent;
    description?: string | undefined;
    title?: string | undefined;
}

export class Intervention_vendor implements IIntervention_vendor {
    batteryVendor?: BatteryVendor;
    chargerVendor?: ChargerVendor;
    hvacVendor?: HvacVendor;
    inverterVendor?: InverterVendor;
    meterVendor?: MeterVendor;
    vehicleVendor?: VehicleVendor;

    constructor(data?: IIntervention_vendor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batteryVendor = _data["batteryVendor"];
            this.chargerVendor = _data["chargerVendor"];
            this.hvacVendor = _data["hvacVendor"];
            this.inverterVendor = _data["inverterVendor"];
            this.meterVendor = _data["meterVendor"];
            this.vehicleVendor = _data["vehicleVendor"];
        }
    }

    static fromJS(data: any): Intervention_vendor {
        data = typeof data === 'object' ? data : {};
        let result = new Intervention_vendor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batteryVendor"] = this.batteryVendor;
        data["chargerVendor"] = this.chargerVendor;
        data["hvacVendor"] = this.hvacVendor;
        data["inverterVendor"] = this.inverterVendor;
        data["meterVendor"] = this.meterVendor;
        data["vehicleVendor"] = this.vehicleVendor;
        return data;
    }
}

export interface IIntervention_vendor {
    batteryVendor?: BatteryVendor;
    chargerVendor?: ChargerVendor;
    hvacVendor?: HvacVendor;
    inverterVendor?: InverterVendor;
    meterVendor?: MeterVendor;
    vehicleVendor?: VehicleVendor;
}

export class Intervention implements IIntervention {
    brand?: Intervention_brand;
    domain?: Intervention_domain;
    id?: string | undefined;
    introducedAt?: moment.Moment | undefined;
    resolution?: Intervention_resolution;
    vendor?: Intervention_vendor;
    vendorType?: VendorType;

    constructor(data?: IIntervention) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brand = _data["brand"] ? Intervention_brand.fromJS(_data["brand"]) : <any>undefined;
            this.domain = _data["domain"];
            this.id = _data["id"];
            this.introducedAt = _data["introducedAt"] ? moment(_data["introducedAt"].toString()) : <any>undefined;
            this.resolution = _data["resolution"] ? Intervention_resolution.fromJS(_data["resolution"]) : <any>undefined;
            this.vendor = _data["vendor"] ? Intervention_vendor.fromJS(_data["vendor"]) : <any>undefined;
            this.vendorType = _data["vendorType"];
        }
    }

    static fromJS(data: any): Intervention {
        data = typeof data === 'object' ? data : {};
        let result = new Intervention();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand ? this.brand.toJSON() : <any>undefined;
        data["domain"] = this.domain;
        data["id"] = this.id;
        data["introducedAt"] = this.introducedAt ? this.introducedAt.toISOString() : <any>undefined;
        data["resolution"] = this.resolution ? this.resolution.toJSON() : <any>undefined;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["vendorType"] = this.vendorType;
        return data;
    }
}

export interface IIntervention {
    brand?: Intervention_brand;
    domain?: Intervention_domain;
    id?: string | undefined;
    introducedAt?: moment.Moment | undefined;
    resolution?: Intervention_resolution;
    vendor?: Intervention_vendor;
    vendorType?: VendorType;
}

export class Aggregates implements IAggregates {
    max?: number | undefined;
    mean?: number | undefined;
    min?: number | undefined;

    constructor(data?: IAggregates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.max = _data["max"];
            this.mean = _data["mean"];
            this.min = _data["min"];
        }
    }

    static fromJS(data: any): Aggregates {
        data = typeof data === 'object' ? data : {};
        let result = new Aggregates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["max"] = this.max;
        data["mean"] = this.mean;
        data["min"] = this.min;
        return data;
    }
}

export interface IAggregates {
    max?: number | undefined;
    mean?: number | undefined;
    min?: number | undefined;
}

export class NullableAggregates implements INullableAggregates {
    max?: number | undefined;
    mean?: number | undefined;
    min?: number | undefined;

    constructor(data?: INullableAggregates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.max = _data["max"];
            this.mean = _data["mean"];
            this.min = _data["min"];
        }
    }

    static fromJS(data: any): NullableAggregates {
        data = typeof data === 'object' ? data : {};
        let result = new NullableAggregates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["max"] = this.max;
        data["mean"] = this.mean;
        data["min"] = this.min;
        return data;
    }
}

export interface INullableAggregates {
    max?: number | undefined;
    mean?: number | undefined;
    min?: number | undefined;
}

export class SessionsStatisticsTimeseries implements ISessionsStatisticsTimeseries {
    costSum?: number | undefined;
    estimatedSavings?: number | undefined;
    from?: moment.Moment | undefined;
    id?: string | undefined;
    kw?: Aggregates;
    kwhSum?: number | undefined;
    locationId?: string | undefined;
    nonSmartPrice?: NullableAggregates;
    price?: Aggregates;
    to?: moment.Moment | undefined;

    constructor(data?: ISessionsStatisticsTimeseries) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costSum = _data["costSum"];
            this.estimatedSavings = _data["estimatedSavings"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.kw = _data["kw"] ? Aggregates.fromJS(_data["kw"]) : <any>undefined;
            this.kwhSum = _data["kwhSum"];
            this.locationId = _data["locationId"];
            this.nonSmartPrice = _data["nonSmartPrice"] ? NullableAggregates.fromJS(_data["nonSmartPrice"]) : <any>undefined;
            this.price = _data["price"] ? Aggregates.fromJS(_data["price"]) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SessionsStatisticsTimeseries {
        data = typeof data === 'object' ? data : {};
        let result = new SessionsStatisticsTimeseries();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costSum"] = this.costSum;
        data["estimatedSavings"] = this.estimatedSavings;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["kw"] = this.kw ? this.kw.toJSON() : <any>undefined;
        data["kwhSum"] = this.kwhSum;
        data["locationId"] = this.locationId;
        data["nonSmartPrice"] = this.nonSmartPrice ? this.nonSmartPrice.toJSON() : <any>undefined;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISessionsStatisticsTimeseries {
    costSum?: number | undefined;
    estimatedSavings?: number | undefined;
    from?: moment.Moment | undefined;
    id?: string | undefined;
    kw?: Aggregates;
    kwhSum?: number | undefined;
    locationId?: string | undefined;
    nonSmartPrice?: NullableAggregates;
    price?: Aggregates;
    to?: moment.Moment | undefined;
}

export class SupportedModelCapabilities implements ISupportedModelCapabilities {
    information?: boolean;
    location?: boolean;
    odometer?: boolean;
    chargeState?: boolean;
    startCharging?: boolean;
    stopCharging?: boolean;
    smartCharging?: boolean;

    constructor(data?: ISupportedModelCapabilities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.information = _data["information"];
            this.location = _data["location"];
            this.odometer = _data["odometer"];
            this.chargeState = _data["chargeState"];
            this.startCharging = _data["startCharging"];
            this.stopCharging = _data["stopCharging"];
            this.smartCharging = _data["smartCharging"];
        }
    }

    static fromJS(data: any): SupportedModelCapabilities {
        data = typeof data === 'object' ? data : {};
        let result = new SupportedModelCapabilities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["information"] = this.information;
        data["location"] = this.location;
        data["odometer"] = this.odometer;
        data["chargeState"] = this.chargeState;
        data["startCharging"] = this.startCharging;
        data["stopCharging"] = this.stopCharging;
        data["smartCharging"] = this.smartCharging;
        return data;
    }
}

export interface ISupportedModelCapabilities {
    information?: boolean;
    location?: boolean;
    odometer?: boolean;
    chargeState?: boolean;
    startCharging?: boolean;
    stopCharging?: boolean;
    smartCharging?: boolean;
}

export class SupportedModel implements ISupportedModel {
    id?: string;
    createdAt?: moment.Moment;
    updatedAt?: moment.Moment;
    model?: string | undefined;
    activationRequired?: boolean;
    integrationStatus?: string | undefined;
    regions?: string[] | undefined;
    reliability?: string | undefined;
    vendor?: string | undefined;
    brand?: string | undefined;
    year?: number[] | undefined;
    driveTrain?: string | undefined;
    capabilities?: SupportedModelCapabilities;
    enabled?: boolean;

    constructor(data?: ISupportedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? moment(_data["updatedAt"].toString()) : <any>undefined;
            this.model = _data["model"];
            this.activationRequired = _data["activationRequired"];
            this.integrationStatus = _data["integrationStatus"];
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            this.reliability = _data["reliability"];
            this.vendor = _data["vendor"];
            this.brand = _data["brand"];
            if (Array.isArray(_data["year"])) {
                this.year = [] as any;
                for (let item of _data["year"])
                    this.year!.push(item);
            }
            this.driveTrain = _data["driveTrain"];
            this.capabilities = _data["capabilities"] ? SupportedModelCapabilities.fromJS(_data["capabilities"]) : <any>undefined;
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): SupportedModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupportedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["model"] = this.model;
        data["activationRequired"] = this.activationRequired;
        data["integrationStatus"] = this.integrationStatus;
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        data["reliability"] = this.reliability;
        data["vendor"] = this.vendor;
        data["brand"] = this.brand;
        if (Array.isArray(this.year)) {
            data["year"] = [];
            for (let item of this.year)
                data["year"].push(item);
        }
        data["driveTrain"] = this.driveTrain;
        data["capabilities"] = this.capabilities ? this.capabilities.toJSON() : <any>undefined;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface ISupportedModel {
    id?: string;
    createdAt?: moment.Moment;
    updatedAt?: moment.Moment;
    model?: string | undefined;
    activationRequired?: boolean;
    integrationStatus?: string | undefined;
    regions?: string[] | undefined;
    reliability?: string | undefined;
    vendor?: string | undefined;
    brand?: string | undefined;
    year?: number[] | undefined;
    driveTrain?: string | undefined;
    capabilities?: SupportedModelCapabilities;
    enabled?: boolean;
}

export enum MspecsSubscriberStatus {
    ENUMS_PROVIDER_SERVICE_SUBSCRIPTION_STATUS_ACTIVE = "ENUMS_PROVIDER_SERVICE_SUBSCRIPTION_STATUS_ACTIVE",
    ENUMS_PROVIDER_SERVICE_SUBSCRIPTION_STATUS_PENDING = "ENUMS_PROVIDER_SERVICE_SUBSCRIPTION_STATUS_PENDING",
    ENUMS_PROVIDER_SERVICE_SUBSCRIPTION_STATUS_INACTIVE = "ENUMS_PROVIDER_SERVICE_SUBSCRIPTION_STATUS_INACTIVE",
}

export class MspecsOrganization implements IMspecsOrganization {
    id?: string | undefined;
    name?: string | undefined;
    legalName?: string | undefined;
    identifier?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    streetAddress?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;

    constructor(data?: IMspecsOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.legalName = _data["legalName"];
            this.identifier = _data["identifier"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.streetAddress = _data["streetAddress"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): MspecsOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new MspecsOrganization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["legalName"] = this.legalName;
        data["identifier"] = this.identifier;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["streetAddress"] = this.streetAddress;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        return data;
    }
}

export interface IMspecsOrganization {
    id?: string | undefined;
    name?: string | undefined;
    legalName?: string | undefined;
    identifier?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    streetAddress?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
}

export class MspecsSubscriber implements IMspecsSubscriber {
    subscriberId?: string | undefined;
    createdDate?: moment.Moment;
    status?: MspecsSubscriberStatus;
    serviceId?: string | undefined;
    organization?: MspecsOrganization;
    isOfficeOptInSubscription?: boolean;

    constructor(data?: IMspecsSubscriber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriberId = _data["subscriberId"];
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.serviceId = _data["serviceId"];
            this.organization = _data["organization"] ? MspecsOrganization.fromJS(_data["organization"]) : <any>undefined;
            this.isOfficeOptInSubscription = _data["isOfficeOptInSubscription"];
        }
    }

    static fromJS(data: any): MspecsSubscriber {
        data = typeof data === 'object' ? data : {};
        let result = new MspecsSubscriber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriberId"] = this.subscriberId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["serviceId"] = this.serviceId;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["isOfficeOptInSubscription"] = this.isOfficeOptInSubscription;
        return data;
    }
}

export interface IMspecsSubscriber {
    subscriberId?: string | undefined;
    createdDate?: moment.Moment;
    status?: MspecsSubscriberStatus;
    serviceId?: string | undefined;
    organization?: MspecsOrganization;
    isOfficeOptInSubscription?: boolean;
}

export class RealEstateOffice implements IRealEstateOffice {
    id?: string;
    name?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    chainId?: string;

    constructor(data?: IRealEstateOffice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.chainId = _data["chainId"];
        }
    }

    static fromJS(data: any): RealEstateOffice {
        data = typeof data === 'object' ? data : {};
        let result = new RealEstateOffice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["street"] = this.street;
        data["city"] = this.city;
        data["chainId"] = this.chainId;
        return data;
    }
}

export interface IRealEstateOffice {
    id?: string;
    name?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    chainId?: string;
}

export class RealEstateChain implements IRealEstateChain {
    id?: string;
    name?: string | undefined;

    constructor(data?: IRealEstateChain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RealEstateChain {
        data = typeof data === 'object' ? data : {};
        let result = new RealEstateChain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRealEstateChain {
    id?: string;
    name?: string | undefined;
}

export class RealEstateObjectConsumers implements IRealEstateObjectConsumers {
    firstName?: string | undefined;
    lastName?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    pid?: string | undefined;
    customerType?: CustomerType;

    constructor(data?: IRealEstateObjectConsumers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.pid = _data["pid"];
            this.customerType = _data["customerType"];
        }
    }

    static fromJS(data: any): RealEstateObjectConsumers {
        data = typeof data === 'object' ? data : {};
        let result = new RealEstateObjectConsumers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["pid"] = this.pid;
        data["customerType"] = this.customerType;
        return data;
    }
}

export interface IRealEstateObjectConsumers {
    firstName?: string | undefined;
    lastName?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    pid?: string | undefined;
    customerType?: CustomerType;
}

export class RealEstateObject implements IRealEstateObject {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    salesDate?: moment.Moment | undefined;
    startDate?: moment.Moment | undefined;
    sellerFirstName?: string | undefined;
    sellerLastName?: string | undefined;
    sellerMobile?: string | undefined;
    sellerEmail?: string | undefined;
    area?: number;
    housing?: Housing;
    internalPropertyNumber?: string | undefined;
    lmvNumber?: string | undefined;
    realEstateAgent?: RealEstateAgentModel;
    realEstateOffice?: RealEstateOffice;
    realEstateChain?: RealEstateChain;
    sellers?: RealEstateObjectConsumers[] | undefined;
    buyers?: RealEstateObjectConsumers[] | undefined;
    orderCreated?: boolean;
    status?: string | undefined;
    statusText?: string | undefined;

    constructor(data?: IRealEstateObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.street = _data["street"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.salesDate = _data["salesDate"] ? moment(_data["salesDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.sellerFirstName = _data["sellerFirstName"];
            this.sellerLastName = _data["sellerLastName"];
            this.sellerMobile = _data["sellerMobile"];
            this.sellerEmail = _data["sellerEmail"];
            this.area = _data["area"];
            this.housing = _data["housing"];
            this.internalPropertyNumber = _data["internalPropertyNumber"];
            this.lmvNumber = _data["lmvNumber"];
            this.realEstateAgent = _data["realEstateAgent"] ? RealEstateAgentModel.fromJS(_data["realEstateAgent"]) : <any>undefined;
            this.realEstateOffice = _data["realEstateOffice"] ? RealEstateOffice.fromJS(_data["realEstateOffice"]) : <any>undefined;
            this.realEstateChain = _data["realEstateChain"] ? RealEstateChain.fromJS(_data["realEstateChain"]) : <any>undefined;
            if (Array.isArray(_data["sellers"])) {
                this.sellers = [] as any;
                for (let item of _data["sellers"])
                    this.sellers!.push(RealEstateObjectConsumers.fromJS(item));
            }
            if (Array.isArray(_data["buyers"])) {
                this.buyers = [] as any;
                for (let item of _data["buyers"])
                    this.buyers!.push(RealEstateObjectConsumers.fromJS(item));
            }
            this.orderCreated = _data["orderCreated"];
            this.status = _data["status"];
            this.statusText = _data["statusText"];
        }
    }

    static fromJS(data: any): RealEstateObject {
        data = typeof data === 'object' ? data : {};
        let result = new RealEstateObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["street"] = this.street;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["salesDate"] = this.salesDate ? this.salesDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["sellerFirstName"] = this.sellerFirstName;
        data["sellerLastName"] = this.sellerLastName;
        data["sellerMobile"] = this.sellerMobile;
        data["sellerEmail"] = this.sellerEmail;
        data["area"] = this.area;
        data["housing"] = this.housing;
        data["internalPropertyNumber"] = this.internalPropertyNumber;
        data["lmvNumber"] = this.lmvNumber;
        data["realEstateAgent"] = this.realEstateAgent ? this.realEstateAgent.toJSON() : <any>undefined;
        data["realEstateOffice"] = this.realEstateOffice ? this.realEstateOffice.toJSON() : <any>undefined;
        data["realEstateChain"] = this.realEstateChain ? this.realEstateChain.toJSON() : <any>undefined;
        if (Array.isArray(this.sellers)) {
            data["sellers"] = [];
            for (let item of this.sellers)
                data["sellers"].push(item.toJSON());
        }
        if (Array.isArray(this.buyers)) {
            data["buyers"] = [];
            for (let item of this.buyers)
                data["buyers"].push(item.toJSON());
        }
        data["orderCreated"] = this.orderCreated;
        data["status"] = this.status;
        data["statusText"] = this.statusText;
        return data;
    }
}

export interface IRealEstateObject {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    salesDate?: moment.Moment | undefined;
    startDate?: moment.Moment | undefined;
    sellerFirstName?: string | undefined;
    sellerLastName?: string | undefined;
    sellerMobile?: string | undefined;
    sellerEmail?: string | undefined;
    area?: number;
    housing?: Housing;
    internalPropertyNumber?: string | undefined;
    lmvNumber?: string | undefined;
    realEstateAgent?: RealEstateAgentModel;
    realEstateOffice?: RealEstateOffice;
    realEstateChain?: RealEstateChain;
    sellers?: RealEstateObjectConsumers[] | undefined;
    buyers?: RealEstateObjectConsumers[] | undefined;
    orderCreated?: boolean;
    status?: string | undefined;
    statusText?: string | undefined;
}

export enum NegotiatePeriod {
    THREE_YEARS = "THREE_YEARS",
    FIVE_YEARS = "FIVE_YEARS",
    NEVER = "NEVER",
    ONE_YEAR = "ONE_YEAR",
}

export class Savings implements ISavings {
    averageSaving?: number;
    guaranteedSaving?: number;

    constructor(data?: ISavings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageSaving = _data["averageSaving"];
            this.guaranteedSaving = _data["guaranteedSaving"];
        }
    }

    static fromJS(data: any): Savings {
        data = typeof data === 'object' ? data : {};
        let result = new Savings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageSaving"] = this.averageSaving;
        data["guaranteedSaving"] = this.guaranteedSaving;
        return data;
    }
}

export interface ISavings {
    averageSaving?: number;
    guaranteedSaving?: number;
}

export class OfferLog implements IOfferLog {
    id?: string;
    offerId?: string;
    ip?: string | undefined;
    timestamp?: moment.Moment;

    constructor(data?: IOfferLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.offerId = _data["offerId"];
            this.ip = _data["ip"];
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OfferLog {
        data = typeof data === 'object' ? data : {};
        let result = new OfferLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["offerId"] = this.offerId;
        data["ip"] = this.ip;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOfferLog {
    id?: string;
    offerId?: string;
    ip?: string | undefined;
    timestamp?: moment.Moment;
}

export class Offer implements IOffer {
    id?: string;
    status?: number;
    pid?: string | undefined;
    mobile?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    ean?: string | undefined;
    consumption?: number | undefined;
    area?: number | undefined;
    possibleStartDate?: moment.Moment | undefined;
    email?: string | undefined;
    comparingMonth?: number | undefined;
    variablePriceRebel?: number | undefined;
    fixedPriceRebel?: number | undefined;
    variablePriceCompetitor?: number | undefined;
    fixedPriceCompetitor?: number | undefined;
    comparingCompetitor?: string | undefined;
    salesChannel?: Channel;
    contactChannel?: ContactChannel;
    createdOn?: moment.Moment;
    netArea?: string | undefined;
    club?: string | undefined;
    team?: string | undefined;
    housing?: Housing;
    customText?: string | undefined;
    negotiatePeriod?: NegotiatePeriod;
    advisor?: string | undefined;
    savings?: Savings;
    externalId?: string | undefined;
    unsubscribed?: boolean;
    logs?: OfferLog[] | undefined;
    orders?: Order[] | undefined;
    reminderSent?: moment.Moment | undefined;
    modifiedOn?: moment.Moment;

    constructor(data?: IOffer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.pid = _data["pid"];
            this.mobile = _data["mobile"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.ean = _data["ean"];
            this.consumption = _data["consumption"];
            this.area = _data["area"];
            this.possibleStartDate = _data["possibleStartDate"] ? moment(_data["possibleStartDate"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.comparingMonth = _data["comparingMonth"];
            this.variablePriceRebel = _data["variablePriceRebel"];
            this.fixedPriceRebel = _data["fixedPriceRebel"];
            this.variablePriceCompetitor = _data["variablePriceCompetitor"];
            this.fixedPriceCompetitor = _data["fixedPriceCompetitor"];
            this.comparingCompetitor = _data["comparingCompetitor"];
            this.salesChannel = _data["salesChannel"];
            this.contactChannel = _data["contactChannel"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.netArea = _data["netArea"];
            this.club = _data["club"];
            this.team = _data["team"];
            this.housing = _data["housing"];
            this.customText = _data["customText"];
            this.negotiatePeriod = _data["negotiatePeriod"];
            this.advisor = _data["advisor"];
            this.savings = _data["savings"] ? Savings.fromJS(_data["savings"]) : <any>undefined;
            this.externalId = _data["externalId"];
            this.unsubscribed = _data["unsubscribed"];
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(OfferLog.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(Order.fromJS(item));
            }
            this.reminderSent = _data["reminderSent"] ? moment(_data["reminderSent"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? moment(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Offer {
        data = typeof data === 'object' ? data : {};
        let result = new Offer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["pid"] = this.pid;
        data["mobile"] = this.mobile;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["ean"] = this.ean;
        data["consumption"] = this.consumption;
        data["area"] = this.area;
        data["possibleStartDate"] = this.possibleStartDate ? this.possibleStartDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["comparingMonth"] = this.comparingMonth;
        data["variablePriceRebel"] = this.variablePriceRebel;
        data["fixedPriceRebel"] = this.fixedPriceRebel;
        data["variablePriceCompetitor"] = this.variablePriceCompetitor;
        data["fixedPriceCompetitor"] = this.fixedPriceCompetitor;
        data["comparingCompetitor"] = this.comparingCompetitor;
        data["salesChannel"] = this.salesChannel;
        data["contactChannel"] = this.contactChannel;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["netArea"] = this.netArea;
        data["club"] = this.club;
        data["team"] = this.team;
        data["housing"] = this.housing;
        data["customText"] = this.customText;
        data["negotiatePeriod"] = this.negotiatePeriod;
        data["advisor"] = this.advisor;
        data["savings"] = this.savings ? this.savings.toJSON() : <any>undefined;
        data["externalId"] = this.externalId;
        data["unsubscribed"] = this.unsubscribed;
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["reminderSent"] = this.reminderSent ? this.reminderSent.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOffer {
    id?: string;
    status?: number;
    pid?: string | undefined;
    mobile?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    ean?: string | undefined;
    consumption?: number | undefined;
    area?: number | undefined;
    possibleStartDate?: moment.Moment | undefined;
    email?: string | undefined;
    comparingMonth?: number | undefined;
    variablePriceRebel?: number | undefined;
    fixedPriceRebel?: number | undefined;
    variablePriceCompetitor?: number | undefined;
    fixedPriceCompetitor?: number | undefined;
    comparingCompetitor?: string | undefined;
    salesChannel?: Channel;
    contactChannel?: ContactChannel;
    createdOn?: moment.Moment;
    netArea?: string | undefined;
    club?: string | undefined;
    team?: string | undefined;
    housing?: Housing;
    customText?: string | undefined;
    negotiatePeriod?: NegotiatePeriod;
    advisor?: string | undefined;
    savings?: Savings;
    externalId?: string | undefined;
    unsubscribed?: boolean;
    logs?: OfferLog[] | undefined;
    orders?: Order[] | undefined;
    reminderSent?: moment.Moment | undefined;
    modifiedOn?: moment.Moment;
}

export class OrderStatus implements IOrderStatus {
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    adress?: string | undefined;
    salesChannel?: string | undefined;
    startdate?: string | undefined;
    status?: string | undefined;
    statusText?: string | undefined;
    netOwner?: string | undefined;

    constructor(data?: IOrderStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.adress = _data["adress"];
            this.salesChannel = _data["salesChannel"];
            this.startdate = _data["startdate"];
            this.status = _data["status"];
            this.statusText = _data["statusText"];
            this.netOwner = _data["netOwner"];
        }
    }

    static fromJS(data: any): OrderStatus {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["adress"] = this.adress;
        data["salesChannel"] = this.salesChannel;
        data["startdate"] = this.startdate;
        data["status"] = this.status;
        data["statusText"] = this.statusText;
        data["netOwner"] = this.netOwner;
        return data;
    }
}

export interface IOrderStatus {
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    adress?: string | undefined;
    salesChannel?: string | undefined;
    startdate?: string | undefined;
    status?: string | undefined;
    statusText?: string | undefined;
    netOwner?: string | undefined;
}

export class PriceResponse implements IPriceResponse {
    consumtion?: number;
    month?: number;

    constructor(data?: IPriceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumtion = _data["consumtion"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): PriceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PriceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumtion"] = this.consumtion;
        data["month"] = this.month;
        return data;
    }
}

export interface IPriceResponse {
    consumtion?: number;
    month?: number;
}

export class AveragePrices implements IAveragePrices {
    price2000?: number;
    price5000?: number;
    price20000?: number;

    constructor(data?: IAveragePrices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price2000 = _data["price2000"];
            this.price5000 = _data["price5000"];
            this.price20000 = _data["price20000"];
        }
    }

    static fromJS(data: any): AveragePrices {
        data = typeof data === 'object' ? data : {};
        let result = new AveragePrices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price2000"] = this.price2000;
        data["price5000"] = this.price5000;
        data["price20000"] = this.price20000;
        return data;
    }
}

export interface IAveragePrices {
    price2000?: number;
    price5000?: number;
    price20000?: number;
}

export class SpotPrice implements ISpotPrice {
    fromDate?: moment.Moment;
    price?: number;
    priceSE1?: number;
    priceSE2?: number;
    priceSE3?: number;
    priceSE4?: number;
    priceCertificate?: number;
    priceEnvironment?: number;
    priceProfileCostSE1?: number;
    priceProfileCostSE2?: number;
    priceProfileCostSE3?: number;
    priceProfileCostSE4?: number;
    priceBalanceCost?: number;
    priceSupplierCost?: number;
    priceAdministrationCost?: number;

    constructor(data?: ISpotPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.price = _data["price"];
            this.priceSE1 = _data["priceSE1"];
            this.priceSE2 = _data["priceSE2"];
            this.priceSE3 = _data["priceSE3"];
            this.priceSE4 = _data["priceSE4"];
            this.priceCertificate = _data["priceCertificate"];
            this.priceEnvironment = _data["priceEnvironment"];
            this.priceProfileCostSE1 = _data["priceProfileCostSE1"];
            this.priceProfileCostSE2 = _data["priceProfileCostSE2"];
            this.priceProfileCostSE3 = _data["priceProfileCostSE3"];
            this.priceProfileCostSE4 = _data["priceProfileCostSE4"];
            this.priceBalanceCost = _data["priceBalanceCost"];
            this.priceSupplierCost = _data["priceSupplierCost"];
            this.priceAdministrationCost = _data["priceAdministrationCost"];
        }
    }

    static fromJS(data: any): SpotPrice {
        data = typeof data === 'object' ? data : {};
        let result = new SpotPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["price"] = this.price;
        data["priceSE1"] = this.priceSE1;
        data["priceSE2"] = this.priceSE2;
        data["priceSE3"] = this.priceSE3;
        data["priceSE4"] = this.priceSE4;
        data["priceCertificate"] = this.priceCertificate;
        data["priceEnvironment"] = this.priceEnvironment;
        data["priceProfileCostSE1"] = this.priceProfileCostSE1;
        data["priceProfileCostSE2"] = this.priceProfileCostSE2;
        data["priceProfileCostSE3"] = this.priceProfileCostSE3;
        data["priceProfileCostSE4"] = this.priceProfileCostSE4;
        data["priceBalanceCost"] = this.priceBalanceCost;
        data["priceSupplierCost"] = this.priceSupplierCost;
        data["priceAdministrationCost"] = this.priceAdministrationCost;
        return data;
    }
}

export interface ISpotPrice {
    fromDate?: moment.Moment;
    price?: number;
    priceSE1?: number;
    priceSE2?: number;
    priceSE3?: number;
    priceSE4?: number;
    priceCertificate?: number;
    priceEnvironment?: number;
    priceProfileCostSE1?: number;
    priceProfileCostSE2?: number;
    priceProfileCostSE3?: number;
    priceProfileCostSE4?: number;
    priceBalanceCost?: number;
    priceSupplierCost?: number;
    priceAdministrationCost?: number;
}

export class ReportUserPermission implements IReportUserPermission {
    id?: string;
    userId?: string;
    agentId?: string | undefined;
    agent?: RealEstateAgentModel;
    officeId?: string | undefined;
    office?: RealEstateOfficeModel;
    chainId?: string | undefined;
    chain?: RealEstateChainModel;
    ownerId?: string | undefined;
    owner?: RealEstateChainOwner;

    constructor(data?: IReportUserPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.agentId = _data["agentId"];
            this.agent = _data["agent"] ? RealEstateAgentModel.fromJS(_data["agent"]) : <any>undefined;
            this.officeId = _data["officeId"];
            this.office = _data["office"] ? RealEstateOfficeModel.fromJS(_data["office"]) : <any>undefined;
            this.chainId = _data["chainId"];
            this.chain = _data["chain"] ? RealEstateChainModel.fromJS(_data["chain"]) : <any>undefined;
            this.ownerId = _data["ownerId"];
            this.owner = _data["owner"] ? RealEstateChainOwner.fromJS(_data["owner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportUserPermission {
        data = typeof data === 'object' ? data : {};
        let result = new ReportUserPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["agentId"] = this.agentId;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["officeId"] = this.officeId;
        data["office"] = this.office ? this.office.toJSON() : <any>undefined;
        data["chainId"] = this.chainId;
        data["chain"] = this.chain ? this.chain.toJSON() : <any>undefined;
        data["ownerId"] = this.ownerId;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReportUserPermission {
    id?: string;
    userId?: string;
    agentId?: string | undefined;
    agent?: RealEstateAgentModel;
    officeId?: string | undefined;
    office?: RealEstateOfficeModel;
    chainId?: string | undefined;
    chain?: RealEstateChainModel;
    ownerId?: string | undefined;
    owner?: RealEstateChainOwner;
}

export class ReportUser implements IReportUser {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    pid?: string | undefined;
    office?: RealEstateOfficeModel;
    chain?: RealEstateChainModel;
    owner?: RealEstateChainOwner;
    permissions?: ReportUserPermission[] | undefined;
    showElectricity?: boolean;
    showInsurance?: boolean;
    showMortgage?: boolean;
    showConversion?: boolean;
    showExecutiveReport?: boolean;
    showInsuranceSalesReport?: boolean;
    showMortgageSalesReport?: boolean;
    showElectricitySalesReport?: boolean;
    isAdmin?: boolean;

    constructor(data?: IReportUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.pid = _data["pid"];
            this.office = _data["office"] ? RealEstateOfficeModel.fromJS(_data["office"]) : <any>undefined;
            this.chain = _data["chain"] ? RealEstateChainModel.fromJS(_data["chain"]) : <any>undefined;
            this.owner = _data["owner"] ? RealEstateChainOwner.fromJS(_data["owner"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(ReportUserPermission.fromJS(item));
            }
            this.showElectricity = _data["showElectricity"];
            this.showInsurance = _data["showInsurance"];
            this.showMortgage = _data["showMortgage"];
            this.showConversion = _data["showConversion"];
            this.showExecutiveReport = _data["showExecutiveReport"];
            this.showInsuranceSalesReport = _data["showInsuranceSalesReport"];
            this.showMortgageSalesReport = _data["showMortgageSalesReport"];
            this.showElectricitySalesReport = _data["showElectricitySalesReport"];
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): ReportUser {
        data = typeof data === 'object' ? data : {};
        let result = new ReportUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["pid"] = this.pid;
        data["office"] = this.office ? this.office.toJSON() : <any>undefined;
        data["chain"] = this.chain ? this.chain.toJSON() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        data["showElectricity"] = this.showElectricity;
        data["showInsurance"] = this.showInsurance;
        data["showMortgage"] = this.showMortgage;
        data["showConversion"] = this.showConversion;
        data["showExecutiveReport"] = this.showExecutiveReport;
        data["showInsuranceSalesReport"] = this.showInsuranceSalesReport;
        data["showMortgageSalesReport"] = this.showMortgageSalesReport;
        data["showElectricitySalesReport"] = this.showElectricitySalesReport;
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface IReportUser {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    pid?: string | undefined;
    office?: RealEstateOfficeModel;
    chain?: RealEstateChainModel;
    owner?: RealEstateChainOwner;
    permissions?: ReportUserPermission[] | undefined;
    showElectricity?: boolean;
    showInsurance?: boolean;
    showMortgage?: boolean;
    showConversion?: boolean;
    showExecutiveReport?: boolean;
    showInsuranceSalesReport?: boolean;
    showMortgageSalesReport?: boolean;
    showElectricitySalesReport?: boolean;
    isAdmin?: boolean;
}

export class ReportResponseItem implements IReportResponseItem {
    id?: string | undefined;
    agent?: string | undefined;
    chain?: string | undefined;
    office?: string | undefined;
    officeAddress?: string | undefined;
    group?: string | undefined;
    salesDate?: moment.Moment | undefined;
    salesMonth?: number;
    salesYear?: number;
    createdDate?: moment.Moment;
    propertyAdress?: string | undefined;

    constructor(data?: IReportResponseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agent = _data["agent"];
            this.chain = _data["chain"];
            this.office = _data["office"];
            this.officeAddress = _data["officeAddress"];
            this.group = _data["group"];
            this.salesDate = _data["salesDate"] ? moment(_data["salesDate"].toString()) : <any>undefined;
            this.salesMonth = _data["salesMonth"];
            this.salesYear = _data["salesYear"];
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>undefined;
            this.propertyAdress = _data["propertyAdress"];
        }
    }

    static fromJS(data: any): ReportResponseItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReportResponseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agent"] = this.agent;
        data["chain"] = this.chain;
        data["office"] = this.office;
        data["officeAddress"] = this.officeAddress;
        data["group"] = this.group;
        data["salesDate"] = this.salesDate ? this.salesDate.toISOString() : <any>undefined;
        data["salesMonth"] = this.salesMonth;
        data["salesYear"] = this.salesYear;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["propertyAdress"] = this.propertyAdress;
        return data;
    }
}

export interface IReportResponseItem {
    id?: string | undefined;
    agent?: string | undefined;
    chain?: string | undefined;
    office?: string | undefined;
    officeAddress?: string | undefined;
    group?: string | undefined;
    salesDate?: moment.Moment | undefined;
    salesMonth?: number;
    salesYear?: number;
    createdDate?: moment.Moment;
    propertyAdress?: string | undefined;
}

export class ReportResponse implements IReportResponse {
    responseItems?: ReportResponseItem[] | undefined;

    constructor(data?: IReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseItems"])) {
                this.responseItems = [] as any;
                for (let item of _data["responseItems"])
                    this.responseItems!.push(ReportResponseItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseItems)) {
            data["responseItems"] = [];
            for (let item of this.responseItems)
                data["responseItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportResponse {
    responseItems?: ReportResponseItem[] | undefined;
}

export class ConversionResponseItem implements IConversionResponseItem {
    chain?: string | undefined;
    office?: string | undefined;
    officeAddress?: string | undefined;
    group?: string | undefined;
    date?: string | undefined;
    totalSales?: number;
    orders?: number;

    constructor(data?: IConversionResponseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chain = _data["chain"];
            this.office = _data["office"];
            this.officeAddress = _data["officeAddress"];
            this.group = _data["group"];
            this.date = _data["date"];
            this.totalSales = _data["totalSales"];
            this.orders = _data["orders"];
        }
    }

    static fromJS(data: any): ConversionResponseItem {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionResponseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chain"] = this.chain;
        data["office"] = this.office;
        data["officeAddress"] = this.officeAddress;
        data["group"] = this.group;
        data["date"] = this.date;
        data["totalSales"] = this.totalSales;
        data["orders"] = this.orders;
        return data;
    }
}

export interface IConversionResponseItem {
    chain?: string | undefined;
    office?: string | undefined;
    officeAddress?: string | undefined;
    group?: string | undefined;
    date?: string | undefined;
    totalSales?: number;
    orders?: number;
}

export class ExecutiveReportResponseItem implements IExecutiveReportResponseItem {
    chain?: string | undefined;
    office?: string | undefined;
    officeAddress?: string | undefined;
    group?: string | undefined;
    salesYTD?: number;
    ordersYTD?: number;
    salesThisMonth?: number;
    ordersThisMonth?: number;
    salesLastMonth?: number;
    ordersLastMonth?: number;

    constructor(data?: IExecutiveReportResponseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chain = _data["chain"];
            this.office = _data["office"];
            this.officeAddress = _data["officeAddress"];
            this.group = _data["group"];
            this.salesYTD = _data["salesYTD"];
            this.ordersYTD = _data["ordersYTD"];
            this.salesThisMonth = _data["salesThisMonth"];
            this.ordersThisMonth = _data["ordersThisMonth"];
            this.salesLastMonth = _data["salesLastMonth"];
            this.ordersLastMonth = _data["ordersLastMonth"];
        }
    }

    static fromJS(data: any): ExecutiveReportResponseItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExecutiveReportResponseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chain"] = this.chain;
        data["office"] = this.office;
        data["officeAddress"] = this.officeAddress;
        data["group"] = this.group;
        data["salesYTD"] = this.salesYTD;
        data["ordersYTD"] = this.ordersYTD;
        data["salesThisMonth"] = this.salesThisMonth;
        data["ordersThisMonth"] = this.ordersThisMonth;
        data["salesLastMonth"] = this.salesLastMonth;
        data["ordersLastMonth"] = this.ordersLastMonth;
        return data;
    }
}

export interface IExecutiveReportResponseItem {
    chain?: string | undefined;
    office?: string | undefined;
    officeAddress?: string | undefined;
    group?: string | undefined;
    salesYTD?: number;
    ordersYTD?: number;
    salesThisMonth?: number;
    ordersThisMonth?: number;
    salesLastMonth?: number;
    ordersLastMonth?: number;
}

export class SalesResponseItem implements ISalesResponseItem {
    chain?: string | undefined;
    office?: string | undefined;
    officeAddress?: string | undefined;
    group?: string | undefined;
    date?: string | undefined;
    acceptedOrders?: number;
    rejectedOrders?: number;

    constructor(data?: ISalesResponseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chain = _data["chain"];
            this.office = _data["office"];
            this.officeAddress = _data["officeAddress"];
            this.group = _data["group"];
            this.date = _data["date"];
            this.acceptedOrders = _data["acceptedOrders"];
            this.rejectedOrders = _data["rejectedOrders"];
        }
    }

    static fromJS(data: any): SalesResponseItem {
        data = typeof data === 'object' ? data : {};
        let result = new SalesResponseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chain"] = this.chain;
        data["office"] = this.office;
        data["officeAddress"] = this.officeAddress;
        data["group"] = this.group;
        data["date"] = this.date;
        data["acceptedOrders"] = this.acceptedOrders;
        data["rejectedOrders"] = this.rejectedOrders;
        return data;
    }
}

export interface ISalesResponseItem {
    chain?: string | undefined;
    office?: string | undefined;
    officeAddress?: string | undefined;
    group?: string | undefined;
    date?: string | undefined;
    acceptedOrders?: number;
    rejectedOrders?: number;
}

export class ReportUserUpdate implements IReportUserUpdate {
    firstName?: string | undefined;
    lastName?: string | undefined;
    pid?: string | undefined;
    showElectricity?: boolean;
    showInsurance?: boolean;
    showMortgage?: boolean;
    showConversion?: boolean;
    showExecutiveReport?: boolean;
    showInsuranceSalesReport?: boolean;
    showMortgageSalesReport?: boolean;
    showElectricitySalesReport?: boolean;

    constructor(data?: IReportUserUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.pid = _data["pid"];
            this.showElectricity = _data["showElectricity"];
            this.showInsurance = _data["showInsurance"];
            this.showMortgage = _data["showMortgage"];
            this.showConversion = _data["showConversion"];
            this.showExecutiveReport = _data["showExecutiveReport"];
            this.showInsuranceSalesReport = _data["showInsuranceSalesReport"];
            this.showMortgageSalesReport = _data["showMortgageSalesReport"];
            this.showElectricitySalesReport = _data["showElectricitySalesReport"];
        }
    }

    static fromJS(data: any): ReportUserUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ReportUserUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["pid"] = this.pid;
        data["showElectricity"] = this.showElectricity;
        data["showInsurance"] = this.showInsurance;
        data["showMortgage"] = this.showMortgage;
        data["showConversion"] = this.showConversion;
        data["showExecutiveReport"] = this.showExecutiveReport;
        data["showInsuranceSalesReport"] = this.showInsuranceSalesReport;
        data["showMortgageSalesReport"] = this.showMortgageSalesReport;
        data["showElectricitySalesReport"] = this.showElectricitySalesReport;
        return data;
    }
}

export interface IReportUserUpdate {
    firstName?: string | undefined;
    lastName?: string | undefined;
    pid?: string | undefined;
    showElectricity?: boolean;
    showInsurance?: boolean;
    showMortgage?: boolean;
    showConversion?: boolean;
    showExecutiveReport?: boolean;
    showInsuranceSalesReport?: boolean;
    showMortgageSalesReport?: boolean;
    showElectricitySalesReport?: boolean;
}

export class ReportUserPermissionUpdate implements IReportUserPermissionUpdate {
    agentId?: string | undefined;
    officeId?: string | undefined;
    chainId?: string | undefined;
    ownerId?: string | undefined;

    constructor(data?: IReportUserPermissionUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.officeId = _data["officeId"];
            this.chainId = _data["chainId"];
            this.ownerId = _data["ownerId"];
        }
    }

    static fromJS(data: any): ReportUserPermissionUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ReportUserPermissionUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["officeId"] = this.officeId;
        data["chainId"] = this.chainId;
        data["ownerId"] = this.ownerId;
        return data;
    }
}

export interface IReportUserPermissionUpdate {
    agentId?: string | undefined;
    officeId?: string | undefined;
    chainId?: string | undefined;
    ownerId?: string | undefined;
}

export class OfficeItem implements IOfficeItem {
    officeId?: string | undefined;
    office?: string | undefined;
    chain?: string | undefined;
    count?: number;

    constructor(data?: IOfficeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.officeId = _data["officeId"];
            this.office = _data["office"];
            this.chain = _data["chain"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): OfficeItem {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["officeId"] = this.officeId;
        data["office"] = this.office;
        data["chain"] = this.chain;
        data["count"] = this.count;
        return data;
    }
}

export interface IOfficeItem {
    officeId?: string | undefined;
    office?: string | undefined;
    chain?: string | undefined;
    count?: number;
}

export class HistoryItem implements IHistoryItem {
    monthIndex?: string | undefined;
    monthName?: string | undefined;
    count?: number;

    constructor(data?: IHistoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthIndex = _data["monthIndex"];
            this.monthName = _data["monthName"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): HistoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthIndex"] = this.monthIndex;
        data["monthName"] = this.monthName;
        data["count"] = this.count;
        return data;
    }
}

export interface IHistoryItem {
    monthIndex?: string | undefined;
    monthName?: string | undefined;
    count?: number;
}

export class AgentItem implements IAgentItem {
    agentId?: string | undefined;
    agent?: string | undefined;
    count?: number;
    office?: string | undefined;

    constructor(data?: IAgentItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.agent = _data["agent"];
            this.count = _data["count"];
            this.office = _data["office"];
        }
    }

    static fromJS(data: any): AgentItem {
        data = typeof data === 'object' ? data : {};
        let result = new AgentItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["agent"] = this.agent;
        data["count"] = this.count;
        data["office"] = this.office;
        return data;
    }
}

export interface IAgentItem {
    agentId?: string | undefined;
    agent?: string | undefined;
    count?: number;
    office?: string | undefined;
}

export class Consumption implements IConsumption {
    propertyId?: string | undefined;
    year?: number;
    month?: number;
    amount?: number;
    date?: moment.Moment;
    startTime?: moment.Moment;
    endTime?: moment.Moment;

    constructor(data?: IConsumption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.amount = _data["amount"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Consumption {
        data = typeof data === 'object' ? data : {};
        let result = new Consumption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["amount"] = this.amount;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IConsumption {
    propertyId?: string | undefined;
    year?: number;
    month?: number;
    amount?: number;
    date?: moment.Moment;
    startTime?: moment.Moment;
    endTime?: moment.Moment;
}

export class FixedPrice implements IFixedPrice {
    price?: number;

    constructor(data?: IFixedPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): FixedPrice {
        data = typeof data === 'object' ? data : {};
        let result = new FixedPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        return data;
    }
}

export interface IFixedPrice {
    price?: number;
}

export class VariablePrice implements IVariablePrice {
    startDate?: moment.Moment;
    price?: number;
    complete?: boolean;

    constructor(data?: IVariablePrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.price = _data["price"];
            this.complete = _data["complete"];
        }
    }

    static fromJS(data: any): VariablePrice {
        data = typeof data === 'object' ? data : {};
        let result = new VariablePrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["price"] = this.price;
        data["complete"] = this.complete;
        return data;
    }
}

export interface IVariablePrice {
    startDate?: moment.Moment;
    price?: number;
    complete?: boolean;
}

export enum EstimatedMonthSource {
    HOURS = "HOURS",
    MONTH = "MONTH",
    HISTORIC_MONTH = "HISTORIC_MONTH",
    PLANNED = "PLANNED",
    CALCULATED = "CALCULATED",
}

export class EstimatedMonth implements IEstimatedMonth {
    currentConsumption?: number;
    estimatedConsumption?: number;
    currentCost?: number;
    estimatedCost?: number;
    estimatedPrice?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    deliveryId?: string;
    complete?: boolean;
    source?: EstimatedMonthSource;

    constructor(data?: IEstimatedMonth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentConsumption = _data["currentConsumption"];
            this.estimatedConsumption = _data["estimatedConsumption"];
            this.currentCost = _data["currentCost"];
            this.estimatedCost = _data["estimatedCost"];
            this.estimatedPrice = _data["estimatedPrice"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.deliveryId = _data["deliveryId"];
            this.complete = _data["complete"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): EstimatedMonth {
        data = typeof data === 'object' ? data : {};
        let result = new EstimatedMonth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentConsumption"] = this.currentConsumption;
        data["estimatedConsumption"] = this.estimatedConsumption;
        data["currentCost"] = this.currentCost;
        data["estimatedCost"] = this.estimatedCost;
        data["estimatedPrice"] = this.estimatedPrice;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["deliveryId"] = this.deliveryId;
        data["complete"] = this.complete;
        data["source"] = this.source;
        return data;
    }
}

export interface IEstimatedMonth {
    currentConsumption?: number;
    estimatedConsumption?: number;
    currentCost?: number;
    estimatedCost?: number;
    estimatedPrice?: number;
    startDate?: moment.Moment;
    endDate?: moment.Moment | undefined;
    deliveryId?: string;
    complete?: boolean;
    source?: EstimatedMonthSource;
}

export class EstimationItem implements IEstimationItem {
    id?: string;
    title?: string | undefined;
    description?: string | undefined;
    consumption?: number;
    hours?: number;
    sortIndex?: number;
    icon?: string | undefined;

    constructor(data?: IEstimationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.consumption = _data["consumption"];
            this.hours = _data["hours"];
            this.sortIndex = _data["sortIndex"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): EstimationItem {
        data = typeof data === 'object' ? data : {};
        let result = new EstimationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["consumption"] = this.consumption;
        data["hours"] = this.hours;
        data["sortIndex"] = this.sortIndex;
        data["icon"] = this.icon;
        return data;
    }
}

export interface IEstimationItem {
    id?: string;
    title?: string | undefined;
    description?: string | undefined;
    consumption?: number;
    hours?: number;
    sortIndex?: number;
    icon?: string | undefined;
}

export enum BillogramStatus {
    DRAFT = "DRAFT",
    UNPAID = "UNPAID",
    PAID = "PAID",
    ENDED = "ENDED",
    SCHEDULED = "SCHEDULED",
}

export class Billogram implements IBillogram {
    id?: string | undefined;
    totalSum?: number;
    remainingSum?: number;
    invoiceDate?: moment.Moment;
    url?: string | undefined;
    status?: BillogramStatus;

    constructor(data?: IBillogram) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.totalSum = _data["totalSum"];
            this.remainingSum = _data["remainingSum"];
            this.invoiceDate = _data["invoiceDate"] ? moment(_data["invoiceDate"].toString()) : <any>undefined;
            this.url = _data["url"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): Billogram {
        data = typeof data === 'object' ? data : {};
        let result = new Billogram();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["totalSum"] = this.totalSum;
        data["remainingSum"] = this.remainingSum;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["url"] = this.url;
        data["status"] = this.status;
        return data;
    }
}

export interface IBillogram {
    id?: string | undefined;
    totalSum?: number;
    remainingSum?: number;
    invoiceDate?: moment.Moment;
    url?: string | undefined;
    status?: BillogramStatus;
}

export enum DevicePlatform {
    IOS = "IOS",
    ANDROID = "ANDROID",
}

export class Device implements IDevice {
    id?: string | undefined;
    platform?: DevicePlatform;
    token?: string | undefined;

    constructor(data?: IDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.platform = _data["platform"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): Device {
        data = typeof data === 'object' ? data : {};
        let result = new Device();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["platform"] = this.platform;
        data["token"] = this.token;
        return data;
    }
}

export interface IDevice {
    id?: string | undefined;
    platform?: DevicePlatform;
    token?: string | undefined;
}

export class NotificationRequest implements INotificationRequest {
    text?: string | undefined;
    title?: string | undefined;
    action?: string | undefined;
    silent?: boolean;
    tag?: string | undefined;
    data?: { [key: string]: string; } | undefined;

    constructor(data?: INotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.title = _data["title"];
            this.action = _data["action"];
            this.silent = _data["silent"];
            this.tag = _data["tag"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["title"] = this.title;
        data["action"] = this.action;
        data["silent"] = this.silent;
        data["tag"] = this.tag;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = this.data[key];
            }
        }
        return data;
    }
}

export interface INotificationRequest {
    text?: string | undefined;
    title?: string | undefined;
    action?: string | undefined;
    silent?: boolean;
    tag?: string | undefined;
    data?: { [key: string]: string; } | undefined;
}

export class RegistrationDescription implements IRegistrationDescription {
    eTag?: string | undefined;
    expirationTime?: moment.Moment | undefined;
    registrationId?: string | undefined;
    tags?: string | undefined;
    pushVariables?: string | undefined;

    constructor(data?: IRegistrationDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eTag = _data["ETag"];
            this.expirationTime = _data["ExpirationTime"] ? moment(_data["ExpirationTime"].toString()) : <any>undefined;
            this.registrationId = _data["RegistrationId"];
            this.tags = _data["Tags"];
            this.pushVariables = _data["PushVariables"];
        }
    }

    static fromJS(data: any): RegistrationDescription {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ETag"] = this.eTag;
        data["ExpirationTime"] = this.expirationTime ? this.expirationTime.toISOString() : <any>undefined;
        data["RegistrationId"] = this.registrationId;
        data["Tags"] = this.tags;
        data["PushVariables"] = this.pushVariables;
        return data;
    }
}

export interface IRegistrationDescription {
    eTag?: string | undefined;
    expirationTime?: moment.Moment | undefined;
    registrationId?: string | undefined;
    tags?: string | undefined;
    pushVariables?: string | undefined;
}

export class VitecOrderTicket implements IVitecOrderTicket {
    orderId?: string | undefined;
    userId?: string | undefined;
    orderUserId?: string | undefined;
    targetId?: string | undefined;
    targetType?: string | undefined;
    tenantId?: string | undefined;
    chainId?: string | undefined;
    customerId?: string | undefined;
    hasExpired?: boolean;

    constructor(data?: IVitecOrderTicket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.userId = _data["userId"];
            this.orderUserId = _data["orderUserId"];
            this.targetId = _data["targetId"];
            this.targetType = _data["targetType"];
            this.tenantId = _data["tenantId"];
            this.chainId = _data["chainId"];
            this.customerId = _data["customerId"];
            this.hasExpired = _data["hasExpired"];
        }
    }

    static fromJS(data: any): VitecOrderTicket {
        data = typeof data === 'object' ? data : {};
        let result = new VitecOrderTicket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["userId"] = this.userId;
        data["orderUserId"] = this.orderUserId;
        data["targetId"] = this.targetId;
        data["targetType"] = this.targetType;
        data["tenantId"] = this.tenantId;
        data["chainId"] = this.chainId;
        data["customerId"] = this.customerId;
        data["hasExpired"] = this.hasExpired;
        return data;
    }
}

export interface IVitecOrderTicket {
    orderId?: string | undefined;
    userId?: string | undefined;
    orderUserId?: string | undefined;
    targetId?: string | undefined;
    targetType?: string | undefined;
    tenantId?: string | undefined;
    chainId?: string | undefined;
    customerId?: string | undefined;
    hasExpired?: boolean;
}

export class VitecUserDbModel implements IVitecUserDbModel {
    id?: string;
    userId?: string | undefined;
    name?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    mobile?: string | undefined;
    chainId?: string;
    chain?: RealEstateChainModel;

    constructor(data?: IVitecUserDbModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.mobile = _data["mobile"];
            this.chainId = _data["chainId"];
            this.chain = _data["chain"] ? RealEstateChainModel.fromJS(_data["chain"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VitecUserDbModel {
        data = typeof data === 'object' ? data : {};
        let result = new VitecUserDbModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["title"] = this.title;
        data["email"] = this.email;
        data["mobile"] = this.mobile;
        data["chainId"] = this.chainId;
        data["chain"] = this.chain ? this.chain.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVitecUserDbModel {
    id?: string;
    userId?: string | undefined;
    name?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    mobile?: string | undefined;
    chainId?: string;
    chain?: RealEstateChainModel;
}

export class VitecOrder implements IVitecOrder {
    token?: string | undefined;
    customerId?: string | undefined;
    ticket?: VitecOrderTicket;
    vitecUserId?: string | undefined;
    vitecUser?: VitecUserDbModel;
    vitecResponsibleUserId?: string | undefined;
    vitecResponsibleUser?: VitecUserDbModel;
    vitecFileIds?: string[] | undefined;
    id?: string;
    createdOn?: moment.Moment;
    updatedOn?: moment.Moment;
    status?: RealEstateOrderStatus;
    addOns?: AddOn[] | undefined;
    contractMethod?: RealEstateOrderContractMethod;
    comment?: string | undefined;
    realEstateObjectId?: string | undefined;
    realEstateObject?: RealEstateObjectDbModel;
    easyFileIds?: string[] | undefined;
    easyCaseId?: string | undefined;
    rebelOrderId?: number | undefined;
    readonly auditEntityId?: string | undefined;

    constructor(data?: IVitecOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.customerId = _data["customerId"];
            this.ticket = _data["ticket"] ? VitecOrderTicket.fromJS(_data["ticket"]) : <any>undefined;
            this.vitecUserId = _data["vitecUserId"];
            this.vitecUser = _data["vitecUser"] ? VitecUserDbModel.fromJS(_data["vitecUser"]) : <any>undefined;
            this.vitecResponsibleUserId = _data["vitecResponsibleUserId"];
            this.vitecResponsibleUser = _data["vitecResponsibleUser"] ? VitecUserDbModel.fromJS(_data["vitecResponsibleUser"]) : <any>undefined;
            if (Array.isArray(_data["vitecFileIds"])) {
                this.vitecFileIds = [] as any;
                for (let item of _data["vitecFileIds"])
                    this.vitecFileIds!.push(item);
            }
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["addOns"])) {
                this.addOns = [] as any;
                for (let item of _data["addOns"])
                    this.addOns!.push(item);
            }
            this.contractMethod = _data["contractMethod"];
            this.comment = _data["comment"];
            this.realEstateObjectId = _data["realEstateObjectId"];
            this.realEstateObject = _data["realEstateObject"] ? RealEstateObjectDbModel.fromJS(_data["realEstateObject"]) : <any>undefined;
            if (Array.isArray(_data["easyFileIds"])) {
                this.easyFileIds = [] as any;
                for (let item of _data["easyFileIds"])
                    this.easyFileIds!.push(item);
            }
            this.easyCaseId = _data["easyCaseId"];
            this.rebelOrderId = _data["rebelOrderId"];
            (<any>this).auditEntityId = _data["auditEntityId"];
        }
    }

    static fromJS(data: any): VitecOrder {
        data = typeof data === 'object' ? data : {};
        let result = new VitecOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["customerId"] = this.customerId;
        data["ticket"] = this.ticket ? this.ticket.toJSON() : <any>undefined;
        data["vitecUserId"] = this.vitecUserId;
        data["vitecUser"] = this.vitecUser ? this.vitecUser.toJSON() : <any>undefined;
        data["vitecResponsibleUserId"] = this.vitecResponsibleUserId;
        data["vitecResponsibleUser"] = this.vitecResponsibleUser ? this.vitecResponsibleUser.toJSON() : <any>undefined;
        if (Array.isArray(this.vitecFileIds)) {
            data["vitecFileIds"] = [];
            for (let item of this.vitecFileIds)
                data["vitecFileIds"].push(item);
        }
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["status"] = this.status;
        if (Array.isArray(this.addOns)) {
            data["addOns"] = [];
            for (let item of this.addOns)
                data["addOns"].push(item);
        }
        data["contractMethod"] = this.contractMethod;
        data["comment"] = this.comment;
        data["realEstateObjectId"] = this.realEstateObjectId;
        data["realEstateObject"] = this.realEstateObject ? this.realEstateObject.toJSON() : <any>undefined;
        if (Array.isArray(this.easyFileIds)) {
            data["easyFileIds"] = [];
            for (let item of this.easyFileIds)
                data["easyFileIds"].push(item);
        }
        data["easyCaseId"] = this.easyCaseId;
        data["rebelOrderId"] = this.rebelOrderId;
        data["auditEntityId"] = this.auditEntityId;
        return data;
    }
}

export interface IVitecOrder {
    token?: string | undefined;
    customerId?: string | undefined;
    ticket?: VitecOrderTicket;
    vitecUserId?: string | undefined;
    vitecUser?: VitecUserDbModel;
    vitecResponsibleUserId?: string | undefined;
    vitecResponsibleUser?: VitecUserDbModel;
    vitecFileIds?: string[] | undefined;
    id?: string;
    createdOn?: moment.Moment;
    updatedOn?: moment.Moment;
    status?: RealEstateOrderStatus;
    addOns?: AddOn[] | undefined;
    contractMethod?: RealEstateOrderContractMethod;
    comment?: string | undefined;
    realEstateObjectId?: string | undefined;
    realEstateObject?: RealEstateObjectDbModel;
    easyFileIds?: string[] | undefined;
    easyCaseId?: string | undefined;
    rebelOrderId?: number | undefined;
    auditEntityId?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

declare var ClientConfig: Config;